<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row v-if="pagePrincipal" align="center" justify="center">
          <v-col cols="12" sm="12" md="9" lg="9">
            <v-card class="login" flat style="border-radius: 10px; padding: 0px">
              <span class="login-title">
                <img :src="empresa.logoUrl" width="100%" style="max-width: 100px; border-radius: 30px; margin-top: 10px;" />
              </span>
              <v-card-actions style="padding: 0px; margin-top: 0px">
                <v-container fluid grid-list-md style="padding: 0px">
                  <v-layout row wrap justify-center v-if="eventos.length >= 1">
                    <v-container>
                      <v-row dense>
                        <v-col cols="12" sm="6" md="4" lg="4" v-for="evento in eventos" :key="evento.id">
                          <v-card elevation="3" class="mx-auto" style="border-radius: 12px; overflow: hidden; transition: transform 0.3s; height: 100%;" hover>
                            <div v-if="evento.exibePorcentagem" style="margin: 0px; text-align: center; background-color: rgba(244, 67, 54, 0.9); color: white; padding: 8px 0; font-weight: bold; font-size: 14px;">
                              <span v-if="evento.exigePagamento">{{ (evento.quantidadeInscricoes * 100 / evento.vagas).toFixed(0) }}% VENDIDOS</span>
                              <span v-else>{{ (evento.quantidadeInscricoes * 100 / evento.vagas).toFixed(0) }}% VENDIDOS</span>
                            </div>
                            <v-img 
                              class="mx-auto" 
                              contain
                              width="100%" 
                              :src="evento.urlCapa"
                            ></v-img>
                            <v-card-title class="py-2 text-h6 font-weight-medium no-break" style="line-height: 1.2;">{{ evento.nome }}</v-card-title>
                            <v-card-subtitle class="py-2 font-weight-medium no-break" style="line-height: 1.2;font-size: 16px;">{{ evento.subtitulo }}</v-card-subtitle>
                            <v-card-text class="pt-0">
                              <div class="d-flex align-center mb-2">
                                <v-icon color="black" class="mr-2">mdi-calendar</v-icon>
                                <span>{{ formatPeriodoEvento(evento) }}</span>
                              </div>
                              <div class="d-flex align-start mb-3" v-if="evento.local">
                                <v-icon color="black" class="mr-2 mt-1">mdi-map-marker</v-icon>
                                <div>
                                  <span>{{ evento.local }}</span> 
                                  <span v-if="evento.localizacao">
                                    (<a :href="evento.localizacao" target="_blank" class="primary--text text-decoration-underline">Ver no mapa</a>)
                                  </span>
                                </div>
                              </div>
                              <v-divider class="mb-3"></v-divider>
                              <div v-if="evento.setores && evento.setores.length > 0 && evento.exigePagamento && !evento.valorPix && !evento.valorCartao">
                                <div class="d-flex align-center mb-2">
                                  <v-icon color="black" class="mr-2">mdi-ticket-confirmation</v-icon>
                                  <span class="font-weight-medium">Setores disponíveis:</span>
                                </div>
                                <div v-for="valor in evento.setores" :key="valor.nome" class="pl-6 mb-1">
                                  <div class="d-flex align-center">
                                    <v-icon :color="valor.cor" size="12" class="mr-2">mdi-circle</v-icon>
                                    <span :style="'color: ' + valor.cor" class="font-weight-medium">{{ valor.nome }}: R$ {{ valor.valor }}</span>
                                  </div>
                                </div>
                              </div>
                              <div v-if="!evento.exigePagamento && !evento.valorPix && !evento.valorCartao">
                                <div class="d-flex align-center mb-2">
                                  <v-icon color="black" class="mr-2">mdi-ticket-confirmation</v-icon>
                                  <span class="font-weight-medium">Ingressos:</span>
                                </div>
                                <div v-for="valor in evento.setores" :key="valor.nome" class="pl-6 mb-1">
                                  <span>{{ valor.nome }}: R$ {{ valor.valor }}</span>
                                </div>
                              </div>
                              <div class="evento-descricao mb-3">
                                <div class="descricao-container" :class="{ 'expandida': isDescricaoExpandida(evento.id) }">
                                  <span v-html="mostrarDescricaoResumida(evento)" class="descricao-texto"></span>
                                </div>
                                <div v-if="evento.descricao && evento.descricao.length > 150" class="text-center mt-2">
                                  <v-btn 
                                    x-small 
                                    outlined
                                    rounded
                                    color="#00695c" 
                                    @click="toggleDescricao(evento.id)" 
                                    class="text-none font-weight-medium px-3"
                                    height="24"
                                  >
                                    {{ isDescricaoExpandida(evento.id) ? 'Ver menos' : 'Ver mais' }}
                                    <v-icon right size="16" class="ml-1">{{ isDescricaoExpandida(evento.id) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                                  </v-btn>
                                </div>
                              </div>
                            </v-card-text>
                            <v-card-actions class="px-4 pb-4">
                              <v-btn 
                                block 
                                color="#00695c"
                                :disabled="evento.quantidadeInscricoes >= evento.vagas"
                                @click="realizarInscricaoGrupo(evento)"
                                elevation="2"
                                height="44"
                                class="white--text text-transform-none font-weight-bold"
                                style="border-radius: 8px; transition: all 0.3s;"
                              >
                                <v-icon left>mdi-cart</v-icon>
                                Comprar agora
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-flex xs12 sm12 lg12 style="
                        text-align: center;
                        padding: 0px 10px 0px 10px;
                        margin-bottom: 17px;
                      ">
                      <v-card flat>
                        <img style="margin-right: 5px" src="../../assets/site-seguro-blindado.png" width="300px" />
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 v-if="empresa.telefone" style="padding: 0px 10px 10px 10px">
                      <v-btn depressed block style="border-radius: 7px" large :href="'https://wa.me/55' +
                        empresa.telefone +
                        '?text=Olá,%20pode%20me%20ajudar%20com%20os%20eventos%20da%20empresa%20' +
                        empresa.nome +
                        '?'
                        " target="_blank">
                        <v-icon left>chat</v-icon>
                        Dúvidas? Fale Conosco!
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center v-else-if="eventos.length == 0">
                    <v-flex xs12 sm12 lg12>
                      <v-alert type="info" style="padding-top: 10px">Nenhum evento em cartaz</v-alert>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        
        <!-- pagina pagamento -->
        <v-row v-if="pagePagamento" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px;padding: 10px;">
              <v-card-text style="padding: 0px">
                <v-container fluid>
                  <v-row justify="space-between" align="center" class="mb-3">
                    <v-col cols="auto">
                      <v-btn 
                        text 
                        color="#00695C"
                        @click="cancelarPagamento"
                        class="px-2"
                      >
                        <v-icon left size="20">mdi-arrow-left</v-icon>
                        <span class="font-weight-medium">Voltar</span>
                      </v-btn>
                    </v-col>
                    
                    <v-col cols="auto">
                      <div class="d-flex align-center">
                        <v-chip color="#E0F2F1" text-color="#00695C" small class="font-weight-medium">
                          <v-icon left size="16" color="#00695C">mdi-credit-card-outline</v-icon>
                          Pagamento com Cartão
                        </v-chip>
                      </div>
                    </v-col>
                  </v-row>
                  
                  <v-row v-if="indicacao">
                    <v-col cols="12">
                      <v-alert
                        dense
                        color="#E0F2F1"
                        border="left"
                        colored-border
                        class="mb-4"
                        elevation="1"
                      >
                        <div class="d-flex align-center">
                          <v-icon color="#00695C" class="mr-2">mdi-tag</v-icon>
                          <span class="text-body-2">
                            Você está usando o link do divulgador <strong>{{ this.divulgador.nome }}</strong>
                          </span>
                        </div>
                      </v-alert>
                    </v-col>
                  </v-row>
                  
                  <v-row>
                    <v-col cols="12" class="mb-0 pb-0">
                      <v-chip x-small color="#E0F2F1" text-color="#00695C" class="mb-2">
                        <v-icon left size="12" color="#00695C">mdi-credit-card</v-icon>
                        <span class="text-caption">Dados do cartão</span>
                      </v-chip>
                    </v-col>

                    <v-col cols="12" md="8" class="pt-0">
                      <v-text-field 
                        v-model="pagamento.nomeTitular" 
                        label="NOME IMPRESSO NO CARTÃO" 
                        outlined 
                        color="#00695C"
                        dense 
                        hide-details 
                        required 
                        v-validate="'required'" 
                        :error-messages="errors.collect('nomeCartao')" 
                        data-vv-name="nomeCartao"
                        prepend-inner-icon="mdi-card-account-details-outline"
                        class="mb-3"
                      ></v-text-field>
                    </v-col>
                    
                    <v-col cols="12" md="4" class="pt-0">
                      <v-text-field 
                        v-model="pagamento.cartaoNumero" 
                        v-mask="maskCartao" 
                        label="NÚMERO DO CARTÃO" 
                        outlined 
                        color="#00695C"
                        dense 
                        hide-details 
                        required 
                        v-validate="'required'" 
                        :error-messages="errors.collect('numCartao')" 
                        data-vv-name="numCartao"
                        prepend-inner-icon="mdi-credit-card-outline"
                        class="mb-3"
                      ></v-text-field>
                    </v-col> 
                    
                    <v-col cols="12" md="3" class="pt-0">
                      <v-text-field 
                        v-model="pagamento.cpfTitular" 
                        v-mask="'###.###.###-##'" 
                        v-validate="'required|cpf'" 
                        :error-messages="errors.collect('cpftitular')" 
                        data-vv-name="cpftitular" 
                        label="CPF DO TITULAR" 
                        outlined 
                        color="#00695C"
                        dense 
                        hide-details 
                        required
                        prepend-inner-icon="mdi-identifier"
                        class="mb-3"
                      ></v-text-field>
                    </v-col>
                    
                    <v-col cols="12" md="3" class="pt-0">
                      <v-text-field 
                        v-mask="'###'" 
                        v-model="pagamento.cvv" 
                        label="CVV" 
                        outlined 
                        color="#00695C"
                        dense 
                        hide-details 
                        type="password" 
                        required 
                        v-validate="'required'" 
                        :error-messages="errors.collect('codCartao')" 
                        data-vv-name="codCartao"
                        prepend-inner-icon="mdi-shield-outline"
                        class="mb-3"
                      ></v-text-field>
                    </v-col> 
                    
                    <v-col cols="12" md="2" class="pt-0">
                      <v-select 
                        v-model="pagamento.mesVencimento" 
                        :items="mesesVencimento" 
                        hide-details 
                        item-text="titulo" 
                        item-value="id" 
                        color="#00695C"
                        label="MÊS VENC." 
                        v-validate="'required'" 
                        :error-messages="errors.collect('expiraCartaoMes')" 
                        data-vv-name="expiraCartaoMes"
                        outlined 
                        dense
                        prepend-inner-icon="mdi-calendar-month"
                        class="mb-3"
                      ></v-select>
                    </v-col>
                    
                    <v-col cols="12" md="2" class="pt-0">
                      <v-select 
                        v-model="pagamento.anoVencimento" 
                        :items="anosVencimento" 
                        hide-details 
                        item-text="titulo" 
                        item-value="id" 
                        color="#00695C"
                        label="ANO VENC." 
                        v-validate="'required'" 
                        :error-messages="errors.collect('expiraCartaoAno')" 
                        data-vv-name="expiraCartaoAno"
                        outlined 
                        dense
                        prepend-inner-icon="mdi-calendar"
                        class="mb-3"
                      ></v-select>
                    </v-col>
                    
                    <v-col cols="12" md="2" class="pt-0">
                      <v-select 
                        v-model="pagamento.bandeira" 
                        :items="bandeiras" 
                        hide-details 
                        item-text="text" 
                        item-value="value" 
                        color="#00695C"
                        label="BANDEIRA" 
                        v-validate="'required'" 
                        :error-messages="errors.collect('bandeira')" 
                        data-vv-name="bandeira"
                        outlined 
                        dense
                        prepend-inner-icon="mdi-credit-card"
                        class="mb-3"
                      ></v-select>
                    </v-col>
                    
                    <v-col cols="12" class="pt-0">
                      <v-select 
                        v-model="pagamento.valorEscolhido" 
                        :items="parcelas" 
                        hide-details 
                        color="#00695C"
                        label="PARCELAMENTO" 
                        v-validate="'required'" 
                        :error-messages="errors.collect('parcelas')" 
                        data-vv-name="parcelas" 
                        @input="carregaQtdParcelas"
                        outlined 
                        dense
                        prepend-inner-icon="mdi-cash-multiple"
                        class="mb-3"
                      ></v-select>
                    </v-col>
                  </v-row>
                  
                  <v-row>
                    <v-col cols="12" class="mt-2 mb-0 pb-0">
                      <v-chip x-small color="#E0F2F1" text-color="#00695C" class="mb-2">
                        <v-icon left size="12" color="#00695C">mdi-information-outline</v-icon>
                        <span class="text-caption">Dados de contato e endereço</span>
                      </v-chip>
                    </v-col>
                    
                    <v-col cols="12" md="3" class="pt-0">
                      <v-text-field 
                        v-mask="'#####-###'" 
                        v-model="pagamento.cep" 
                        label="CEP" 
                        outlined 
                        type="tel" 
                        color="#00695C"
                        dense 
                        hide-details 
                        required 
                        v-validate="'required'"
                        prepend-inner-icon="mdi-map-marker-outline"
                        class="mb-3"
                      ></v-text-field>
                    </v-col>
                    
                    <v-col cols="12" md="3" class="pt-0">
                      <v-text-field 
                        v-model="pagamento.numero" 
                        label="NÚMERO DO ENDEREÇO" 
                        outlined 
                        type="tel" 
                        color="#00695C"
                        dense 
                        hide-details 
                        required 
                        v-validate="'required'"
                        prepend-inner-icon="mdi-home-outline"
                        class="mb-3"
                      ></v-text-field>
                    </v-col>
                    
                    <v-col cols="12" md="6" class="pt-0">
                      <v-text-field 
                        v-model="pagamento.email" 
                        label="E-MAIL" 
                        outlined 
                        color="#00695C"
                        dense 
                        hide-details 
                        required 
                        v-validate="'required'"
                        prepend-inner-icon="mdi-email-outline"
                        class="mb-3"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  
                  <v-row>
                    <v-col cols="12" class="mb-2">
                      <v-divider class="mb-2"></v-divider>
                      <v-chip x-small color="#E0F2F1" text-color="#00695C" class="mb-2">
                        <v-icon left size="12" color="#00695C">mdi-cart-outline</v-icon>
                        <span class="text-caption">Detalhes da Compra</span>
                      </v-chip>
                    </v-col>
                    
                    <v-col cols="12" class="mb-3">
                      <v-card outlined class="elevation-0 pa-3" color="#fafafa">
                        <div class="text-subtitle-1 teal--text text--darken-3 font-weight-medium no-break">{{ eventoSelecionado.nome }}</div>
                        
                        <v-divider class="my-2"></v-divider>
                        
                        <div class="d-flex align-center my-2">
                          <v-avatar size="24" color="#E0F2F1" class="mr-2">
                            <v-icon size="16" color="#00695C">mdi-currency-usd</v-icon>
                          </v-avatar>
                          <span class="font-weight-medium text-body-2">Total:</span>
                          <v-spacer></v-spacer>
                          <span class="teal--text text--darken-3 font-weight-bold text-subtitle-1" v-if="!textoParcela">
                            {{ valorTotalCompra.toLocaleString("pt-BR", {style:"currency", currency:"BRL"}) }}
                          </span>
                          <span class="teal--text text--darken-3 font-weight-bold text-subtitle-1" v-else>
                            {{ textoParcela }}
                          </span>
                        </div>

                        <!-- Indicação do desconto aplicado -->
                        <div class="d-flex align-center mt-2" v-if="indicacao && divulgador && divulgador.aplicaDesconto && eventoSelecionado.usaLinkDesconto">
                          <v-avatar size="24" color="#E0F2F1" class="mr-2">
                            <v-icon size="16" color="#00695C">mdi-tag-multiple</v-icon>
                          </v-avatar>
                          <span class="font-weight-medium text-body-2">Desconto aplicado:</span>
                          <v-spacer></v-spacer>
                          <span class="green--text text--darken-2 font-weight-bold text-subtitle-1">
                            -{{ divulgador.valorDesconto }}%
                          </span>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              
              <v-card-actions style="padding: 0px 16px 16px 16px">
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" md="8">
                      <v-btn 
                        dark 
                        block 
                        color="#004940" 
                        elevation="1"
                        class="py-4 font-weight-medium text-subtitle-2" 
                        style="border-radius: 8px;" 
                        @click="pagamentoCartao"
                      >
                        <v-icon left size="18">mdi-check-circle</v-icon>
                        Finalizar Pagamento
                      </v-btn>
                    </v-col>
                    
                    <v-col cols="12" md="4">
                      <v-btn 
                        outlined 
                        block 
                        color="#E53935" 
                        class="py-4 font-weight-medium text-subtitle-2" 
                        style="border-radius: 8px;" 
                        @click="cancelarPagamento"
                      >
                        <v-icon left size="18">mdi-close-circle</v-icon>
                        Cancelar
                      </v-btn>
                    </v-col>

                  </v-row>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- pagina pagamento -->

        <!-- pagina consulta -->
        <v-row v-if="pageConsulta" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px; padding: 0px">
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px">
                        Selecione o evento que você deseja consultar:
                      </p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-select outlined dense v-model="eventoId" :items="eventos" item-text="nome" item-value="id"
                        color="#00695C"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px">
                        Preencha os dados abaixo para consultar a inscrição:
                      </p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="margin: 0 auto">
                      <v-text-field light label="CPF DO RESPONSÁVEL FINANCEIRO" color="#00695C" outlined
                        v-mask="'###.###.###-##'" dense hide-details required v-validate="'required|cpf'"
                        :error-messages="errors.collect('cpf')" data-vv-name="cpf" type="tel"
                        v-model="cpf"></v-text-field>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg8>
                      <v-text-field light v-model="email" label="EMAIL" outlined color="#00695C" dense hide-details required></v-text-field>
                    </v-flex> -->
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg8>
                      <v-btn dark depressed block color="#00695C" style="border-radius: 7px" large
                        @click="consultarInscricao(cpf)">Consultar Inscrição</v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- fim pagina consulta -->
      
     <!-- Formulario de inscrição -->
        <!-- PÁGINA INSCRIÇÃO -->
        <v-row v-if="paginaInscricaoGrupo" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card flat class="modern-card" style="border-radius: 16px; overflow: hidden; box-shadow: 0 8px 30px rgba(0,0,0,0.05);">
              <v-card-text style="padding: 24px;">
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" class="pb-0">
                      <div class="d-flex align-center">
                        <v-btn 
                          v-if="!bloqueiaVoltar" 
                          text 
                          color="#00695C" 
                          @click="retornaPaginaPrincipal"
                          class="px-2 mr-2"
                        >
                          <v-icon>mdi-arrow-left</v-icon>
                        </v-btn>
                        <h2 class="text-h5 font-weight-medium grey--text text--darken-3">Formulário de Inscrição</h2>
                      </div>
                    </v-col>
                    
                    <!-- Mensagem de desconto do divulgador -->
                    <v-col cols="12" v-if="indicacao && divulgador && divulgador.aplicaDesconto && eventoSelecionado.usaLinkDesconto">
                      <v-alert
                        color="#00695C"
                        dark
                        icon="mdi-tag-multiple"
                        border="left"
                        prominent
                        class="mb-4"
                      >
                        <div class="text-subtitle-1">
                          Você está utilizando o link de <strong>{{ divulgador.nome }}</strong>
                          <br>
                          Desconto de <strong>{{ divulgador.valorDesconto }}%</strong> aplicado automaticamente!
                        </div>
                      </v-alert>
                    </v-col>
                    
                    <v-col cols="12" class="text-center" v-if="eventoSelecionado.urlMapa">
                      <v-img 
                        :src="eventoSelecionado.urlMapa" 
                        alt="MapaEvento" 
                        max-width="500px" 
                        class="mx-auto rounded-lg" 
                        style="border-radius: 12px;"
                      ></v-img>
                    </v-col>
                    
                    <v-col cols="12" v-if="quantidade.length > 1">
                      <div class="d-flex align-center my-3">
                        <span class="text-subtitle-1 mr-3 grey--text text--darken-2">Quantidade:</span>
                        <v-select 
                          outlined 
                          dense 
                          hide-details 
                          v-model="qtdCompra" 
                          :items="quantidade"
                          @input="verificaCapacidade()"
                          style="max-width: 100px;"
                          class="mt-0 pt-0"
                        ></v-select>
                      </div>
                    </v-col>
                  </v-row>
                </v-container>

                <v-container fluid v-for="index in qtdCompra" :key="index" class="py-2">
                  <v-card class="mb-6 pa-4" outlined style="border-radius: 12px; border-color: #e0e0e0;">
                    <v-row>
                      <v-col cols="12">
                        <p class="text-subtitle-1 font-weight-medium mb-4" v-if="qtdCompra != 1">
                          Dados do {{ index }}º participante:
                        </p>
                        <p class="text-subtitle-1 font-weight-medium mb-4" v-else>
                          Dados do participante:
                        </p>

                        <v-radio-group 
                          v-model="inscricao[index - 1].tipoDocumento" 
                          row 
                          @change="limpaSetor(index - 1)"
                          v-if="eventoSelecionado.tipoDocumento == 'AMBOS'"
                          class="my-2"
                        >
                          <v-radio label="CPF" value="CPF" color="#00695C"></v-radio>
                          <v-radio label="CNPJ" value="CNPJ" color="#00695C"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" md="4" v-if="(eventoSelecionado.tipoDocumento == 'CPF' || inscricao[index - 1].tipoDocumento == 'CPF')">
                        <v-text-field 
                          label="CPF resp. financeiro" 
                          v-model="inscricao[index - 1].cpf" 
                          color="#00695C" 
                          outlined 
                          v-mask="'###.###.###-##'" 
                          dense 
                          rounded
                          hide-details 
                          required 
                          type="tel"
                          @change="verificaDocumento(inscricao[index - 1].cpf, index - 1, 'CPF')"
                          class="input-field"
                          prepend-inner-icon="mdi-card-account-details"
                        ></v-text-field>
                      </v-col>
                      
                      <v-col cols="12" md="4" v-if="eventoSelecionado.tipoDocumento == 'CNPJ' || inscricao[index - 1].tipoDocumento == 'CNPJ'">
                        <v-text-field 
                          label="CNPJ" 
                          v-model="inscricao[index - 1].cpf" 
                          color="#00695C" 
                          outlined 
                          v-mask="'##.###.###/####-##'" 
                          dense 
                          rounded
                          hide-details 
                          required 
                          type="tel"
                          @change="verificaDocumento(inscricao[index - 1].cpf, index - 1, 'CNPJ')"
                          class="input-field"
                          prepend-inner-icon="mdi-card-account-details"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="8" v-if="eventoSelecionado.tipoDocumento == 'CPF' || inscricao[index - 1].tipoDocumento == 'CPF'">
                        <v-text-field
                          label="Nome completo"
                          v-model="inscricao[index - 1].nome"
                          color="#00695C"
                          outlined
                          dense
                          rounded
                          hide-details
                          required
                          class="input-field"
                          prepend-inner-icon="mdi-account"
                        ></v-text-field>
                      </v-col>
                      
                      <v-col cols="12" md="8" v-if="eventoSelecionado.tipoDocumento == 'CNPJ' || inscricao[index - 1].tipoDocumento == 'CNPJ'">
                        <v-text-field
                          label="Razão social"
                          v-model="inscricao[index - 1].nome"
                          color="#00695C"
                          outlined
                          dense
                          rounded
                          hide-details
                          required
                          class="input-field"
                          prepend-inner-icon="mdi-account"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="4">
                        <v-text-field 
                          label="WhatsApp com DDD" 
                          v-model="inscricao[index - 1].telefone" 
                          color="#00695C" 
                          type="tel" 
                          outlined 
                          rounded
                          hide-details 
                          v-mask="'(##) #####-####'" 
                          dense
                          required
                          class="input-field"
                          prepend-inner-icon="mdi-cellphone"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" xs="12" sm="12" md="12" lg="12" v-if="filhosSelect.length > 0">
                        <v-card outlined>
                          <v-card-text>
                            <p style="margin: 0px; font-size: 17px;">Selecione os filhos que irão participar:</p>
                            <div v-for="filho in filhosSelect" :key="filho" style="margin-bottom: 10px;">
                              <v-checkbox 
                                hide-details 
                                v-model="inscricao[index - 1].filho" 
                                :label="filho" 
                                :value="filho"
                                @change="onFilhoChange(filho, index - 1)"
                              ></v-checkbox>
                              <v-select
                                v-if="inscricao[index - 1].filho.includes(filho) && !ehEventoOnibus"
                                v-model="tamanhosCamisaGlobal[`${index - 1}_${filho}`]"
                                :items="tamanhos"
                                label="Tamanho da camisa"
                                dense
                                outlined
                                style="margin-left: 40px; margin-top: 5px; max-width: 250px;"
                                hide-details
                              ></v-select>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      
                      <v-col cols="12">
                        <v-btn
                          v-if="index - 1 != 0"
                          block
                          depressed
                          @click="preencherInformacoes(index - 1)"
                        >Preencher informações
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-container>
                
                <v-flex xs12 sm12 lg12>
                      <v-checkbox v-model="aceiteLgpd" style="margin-top:15px">
                        <template v-slot:label>
                          <div>
                            Concordo com as
                            <a target="_blank"
                              :href="urlPoliticaPrivacidade"
                              @click.stop>políticas de privacidade e tratamento de dados
                              pessoais</a>
                          </div>
                        </template>
                      </v-checkbox>
                    </v-flex>

                <v-container style="padding: 0px 12px" v-if="eventoSelecionado.urlImgObs">
                  <v-img 
                    :src="eventoSelecionado.urlImgObs" 
                    max-width="300px" 
                    class="mx-auto rounded-lg"
                    style="border-radius: 12px;"
                  ></v-img>
                </v-container>

                <v-container class="pt-4 pb-0">
                  <v-card outlined class="pa-4" style="border-radius: 12px; border-color: #e0e0e0;">
                    <v-card-title class="px-0 pt-0 text-h5 font-weight-medium grey--text text--darken-3">
                      Detalhes da Compra
                    </v-card-title>
                    
                    <v-card-text class="px-0 pt-2 pb-0">
                      <h3 class="text-h6 font-weight-medium text--darken-1 mb-4 no-break">{{ eventoSelecionado.nome }}</h3>
                      <v-alert
                        text
                        color="info"
                        border="left"
                        class="mb-4"
                        style="border-radius: 8px;"
                        dense
                      >
                        <span class="text-body-2">
                          <strong>Importante:</strong> Nas compras realizadas com a opção de parcelamento, poderão incidir taxas de parcelamento, cujas condições estarão claramente expostas. <strong>As condições de parcelamentos são personalizadas para melhorar a experiência de compra e o Comprador poderá optar por alterar a condição de parcelamento antes de confirmar o pedido</strong>.
                        </span>
                      </v-alert>

                      <div class="mb-4" style="border-radius: 8px;">
                        <v-alert
                          text
                          color="warning"
                          border="left"
                          class="mb-0"
                          style="border-radius: 8px;"
                          dense
                        >
                          <div class="text-body-2" style="white-space: pre-line;" v-html="formatarDescricao(eventoSelecionado.descricaoCompra)"></div>
                        </v-alert>
                      </div>
                      
                      <div v-if="!eventoSelecionado.valorPix && !eventoSelecionado.valorCartao">
                        <h3 class="text-h6 font-weight-bold orange--text text--darken-1 mb-2">
                          Total: {{ valorTotalCompra.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) }}
                        </h3>
                      </div>
                      
                      <div v-if="eventoSelecionado.valorPix && eventoSelecionado.valorCartao" class="mb-2">
                        <v-chip 
                          color="orange" 
                          text-color="white" 
                          label 
                          small 
                          class="mr-2 mb-2"  
                        >Opções de pagamento</v-chip>
                        
                        <div class="d-flex justify-center" style="width: 100%; flex-wrap: wrap; gap: 16px;margin-top: 10px;">
                          <v-btn
                            class="payment-option-card mb-2"
                            elevation="2"
                            :ripple="false"
                            outlined
                            style="border-radius: 12px; border: 1px solid rgba(0,0,0,0.05); width: 250px; height: 150px; overflow: hidden; text-transform: none; border-top: 5px solid #28c76f;"
                            v-if="eventoSelecionado.valorPix"
                            @click="prosseguirPagamento('PIX')"
                          >
                            <div class="d-flex flex-column align-center" style="width: 100%">
                              <div class="d-flex align-center mb-2">
                                <img src="../../assets/pix.png" width="18px" class="mr-2" />
                                <div class="text-subtitle-1 font-weight-medium">Pix</div>
                              </div>
                              <div class="text-h6 font-weight-bold green--text text--darken-1 mt-2">
                                {{ calculaValorPix().toLocaleString("pt-BR", { style: "currency", currency: "BRL"}) }}
                              </div>
                            </div>
                          </v-btn>
                          
                          <v-btn
                            class="payment-option-card mb-2"
                            elevation="2"
                            :ripple="false"
                            outlined
                            style="border-radius: 12px; border: 1px solid rgba(0,0,0,0.05); width: 250px; height: 150px; overflow: hidden; text-transform: none; border-top: 5px solid #F57C00;"
                            v-if="eventoSelecionado.valorCartao"
                            @click="prosseguirPagamento('CARTÃO')"
                          >
                            <div class="d-flex flex-column align-center" style="width: 100%">
                              <div class="d-flex align-center mb-2">
                                <v-icon small color="black" class="mr-2">mdi-credit-card</v-icon>
                                <div class="text-subtitle-1 font-weight-medium">Cartão</div>
                              </div>
                              <div class="text-caption grey--text text--darken-1 mt-1">
                                em até {{ eventoSelecionado.quantidadeParcelas }}x de
                              </div>
                              <div class="text-h6 font-weight-bold orange--text text--darken-1 mt-2">
                                {{ calculaParcelas(eventoSelecionado, inscricao[0].filho.length) }}
                              </div>
                            </div>
                          </v-btn>
                        </div> 
                      </div>
                    </v-card-text>
                  </v-card>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <!-- PÁGINA INSCRIÇÃO -->

        <!-- PÁGINA INSCRIÇÃO VAGAS -->
        <v-row v-if="paginaInscricaoVagas" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px; padding: 0px">
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12 v-if="!bloqueiaVoltar">
                      <v-btn outlined @click="retornaPaginaPrincipal">
                        <v-icon left>mdi-arrow-left</v-icon>
                        Voltar
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 v-if="!quantidade.length == 1">
                      <br />
                      <p style="margin-bottom: 0px">Quantidade:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg1 v-if="!quantidade.length == 1">
                      <v-select outlined dense hide-details v-model="qtdCompra" :items="quantidade"
                        @input="verificaCapacidade()"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="margin-top: 20px" v-if="!quantidade.length == 1">
                      <v-divider></v-divider>
                    </v-flex>
                  </v-layout>
                </v-container>

                <v-container fluid grid-list-md v-for="index in qtdCompra" :key="index">
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px" v-if="qtdCompra != 1">
                        Dados do {{ index }}º participante:
                      </p>
                      <p style="margin-bottom: 0px" v-else>
                        Dados do participante:
                      </p>
                    </v-flex>

                    <v-flex xs12 sm12 lg12 v-if="eventoSelecionado.tipoDocumento == 'AMBOS'">
                      <v-radio-group v-model="inscricao[index - 1].tipoDocumento" row @change="limpaSetor(index - 1)">
                        <v-radio label="CPF" value="CPF"></v-radio>
                        <v-radio label="CNPJ" value="CNPJ"></v-radio>
                      </v-radio-group>
                      <v-alert v-if="
                        eventoSelecionado.desconto &&
                        inscricao[index - 1].tipoDocumento == 'CNPJ'
                      " dark type="success">
                        Desconto de R$
                        {{ eventoSelecionado.desconto }} aplicado!
                      </v-alert>
                    </v-flex>

                    <v-flex xs12 sm12 lg4 v-if="
                      eventoSelecionado.tipoDocumento == 'CPF' ||
                      inscricao[index - 1].tipoDocumento == 'CPF'
                    ">
                      <v-text-field
                        label="CPF Resp. Financeiro*"
                        v-model="inscricao[index - 1].cpf"
                        light
                        color="#00695C"
                        outlined
                        rounded
                        v-mask="'###.###.###-##'"
                        dense
                        hide-details
                        required
                        type="tel" 
                        class="input-field"
                        prepend-inner-icon="mdi-card-account-details"
                        @change="verificaDocumento(inscricao[index - 1].cpf, index - 1, 'CPF')">
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 v-if="
                      eventoSelecionado.tipoDocumento == 'CNPJ' ||
                      inscricao[index - 1].tipoDocumento == 'CNPJ'
                    ">
                      <v-text-field
                        label="CNPJ*"
                        v-model="inscricao[index - 1].cpf"
                        light
                        color="#00695C"
                        outlined
                        rounded
                        v-mask="'##.###.###/####-##'"
                        dense
                        hide-details
                        required
                        type="tel"
                        class="input-field"
                        prepend-inner-icon="mdi-card-account-details"
                        @change="verificaDocumento(inscricao[index - 1].cpf, index - 1, 'CNPJ')
                      "></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 lg8 v-if="
                      (eventoSelecionado.tipoDocumento == 'CPF' ||
                      inscricao[index - 1].tipoDocumento == 'CPF')
                    ">
                      <v-text-field
                        label="Nome completo*"
                        v-model="inscricao[index - 1].nome"
                        light
                        outlined
                        rounded
                        color="#00695C"
                        dense
                        hide-details
                        required
                        class="input-field"
                        prepend-inner-icon="mdi-account"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg8 v-if="
                      eventoSelecionado.tipoDocumento == 'CNPJ' ||
                      inscricao[index - 1].tipoDocumento == 'CNPJ'
                    ">
                      <v-text-field
                        label="Razão social*"
                        v-model="inscricao[index - 1].nome"
                        light
                        outlined
                        rounded
                        color="#00695C"
                        dense
                        hide-details
                        required
                        class="input-field"
                        prepend-inner-icon="mdi-account"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 lg6>
                      <v-text-field
                        label="WhatsApp com DDD*"
                        v-model="inscricao[index - 1].telefone"
                        light
                        color="#00695C"
                        type="tel"
                        outlined
                        rounded
                        hide-details
                        v-mask="'(##) #####-####'"
                        dense
                        required
                        class="input-field"
                        prepend-inner-icon="mdi-cellphone"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 lg12 v-if="exibeMapa">
                      <v-card outlined>
                        <v-card-text>
                          <p style="margin: 0px; font-size: 17px;">Selecione os filhos que irão participar:</p>
                          <div v-for="filho in filhosSelect" :key="filho" style="margin-bottom: 10px;">
                            <v-checkbox 
                              hide-details 
                              v-model="inscricao[index - 1].filho" 
                              :label="filho" 
                              :value="filho"
                              @change="onFilhoChange(filho, index - 1)"
                            ></v-checkbox>
                            <v-select
                              v-if="inscricao[index - 1].filho.includes(filho) && !ehEventoOnibus"
                              v-model="tamanhosCamisaGlobal[`${index - 1}_${filho}`]"
                              :items="tamanhos"
                              label="Tamanho da camisa"
                              dense
                              outlined
                              style="margin-left: 40px; margin-top: 5px; max-width: 200px;"
                              hide-details
                            ></v-select>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-flex>

                    <!-- <v-flex xs12 sm12 lg4>
                      <v-text-field label="E-MAIL" v-model="inscricao[index - 1].email" light
                        color="#00695C" outlined hide-details dense required></v-text-field>
                    </v-flex> -->

                    <!-- <v-flex xs12 sm12 lg4>
                      <v-text-field label="IDADE*" v-model="inscricao[index - 1].idade" light
                        color="#00695C" outlined hide-details dense required></v-text-field>
                    </v-flex> -->
                    <!-- <v-flex xs12 sm12 lg12 :key="x">
                      <v-row dense>
                        <v-flex xs12 sm12 lg4 v-for="composicao in eventoSelecionado.composicao" :key="composicao.tipo">
                          <v-card outlined>
                            <v-card-title style="font-weight: bold; font-size:14px">{{ composicao.tipo }}</v-card-title>
                            <v-card-subtitle style="padding-bottom: 0px">R$ {{ composicao.valor }}</v-card-subtitle>

                            <v-card-actions :key="composicao.quantidade">
                              <v-spacer></v-spacer>

                              <v-btn icon color="red" @click="removeComposicao(composicao)" :disabled="composicao.quantidade == 0">
                                <v-icon>mdi-minus-circle</v-icon>
                              </v-btn>

                              <v-btn icon disabled>
                                <p style="margin: 0px">{{ composicao.quantidade }}</p>
                              </v-btn>

                              <v-btn icon color="green" @click="acrescentaComposicao(composicao)">
                                <v-icon>mdi-plus-circle</v-icon>
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-flex>
                      </v-row>
                    </v-flex> -->
                    <v-flex xs12 sm12 lg12 style="margin-bottom: 0px" :key="x" v-if="eventoSelecionado.composicao && eventoSelecionado.composicao.length > 0">
                      <v-row dense>
                        <v-flex xs12 sm12 lg4 v-for="composicao in eventoSelecionado.composicao" :key="composicao.tipo">
                          <v-card outlined>
                            <v-row class="" style="padding-left: 10px" align="center">
                              <v-col cols="6" class="text-left">
                                <div style="font-weight: bold; font-size: 14px">
                                  {{ composicao.tipo }}
                                </div>
                                <div>R$ {{ composicao.valor }}</div>
                              </v-col>

                              <v-col cols="6">
                                <v-row justify="end" no-gutters>
                                  <v-btn icon color="red" @click="removeComposicao(composicao)"
                                    :disabled="composicao.quantidade == 0">
                                    <v-icon>mdi-minus-circle</v-icon>
                                  </v-btn>

                                  <v-btn icon>
                                    <p style="margin: 0px">
                                      {{ composicao.quantidade }}
                                    </p>
                                  </v-btn>

                                  <v-btn icon color="green" @click="acrescentaComposicao(composicao)">
                                    <v-icon>mdi-plus-circle</v-icon>
                                  </v-btn>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-card>
                        </v-flex>
                      </v-row>
                    </v-flex>
                    <!-- <v-flex>
                      <v-btn
                        v-if="index - 1 != 0"
                        block
                        depressed
                        @click="preencherInformacoes(index - 1)"
                        >Preencher informações</v-btn
                      >
                    </v-flex> -->
                    <v-flex xs12 sm12 lg12>
                      <v-divider v-if="index != qtdCompra" style="margin-top: 40px"></v-divider>
                    </v-flex>
                  </v-layout>
                </v-container>

                <v-flex xs12 sm12 lg12 style="text-align: center" v-if="exibeMapa">
                  <v-flex xs10 sm10 lg6 style="text-align: left; margin: 0px auto">
                    <table style="width: 100%">
                      <tr>
                        <td>
                          <p style="margin: 0px; font-size: 11px"><v-icon small color="#22b42c">mdi-square</v-icon>Livre
                          </p>
                          <p style="margin: 0px; font-size: 11px"><v-icon small
                              color="#ff5050">mdi-square</v-icon>Ocupado</p>
                        </td>
                        <td>
                          <p style="margin: 0px; font-size: 11px"><v-icon small
                              color="#2024b6">mdi-square</v-icon>Selecionado
                            por você</p>
                          <p style="margin: 0px; font-size: 11px"><v-icon small
                              color="#767171">mdi-square</v-icon>Selecionado
                            por outra pessoa</p>
                        </td>
                      </tr>
                    </table>
                  </v-flex>
                  <div ref="matrixContainer" :style="backgroundStyle" style="overflow: hidden; display: inline-block;">
                    <table ref="matrixTable" :key="x">
                      <tr v-for="(row, rowIndex) in matrix" :key="rowIndex">
                        <td v-for="(cell, colIndex) in row" :key="colIndex"
                          @click="cell.status != 'OCUPADO' || !cell.bloqueado || cell.active ? cellClicked(rowIndex, colIndex) : ''"
                          :data-cell-number="cell.localizacao" style="position: relative;">
                          <img style="cursor: pointer" v-if="cell.status == 'LIVRE' && cell.active"
                            src="../../assets/greentable.webp" width="10px" />
                          <img style="cursor: pointer"
                            v-if="cell.status == 'SELECIONADO' && !cell.bloqueado && cell.active"
                            src="../../assets/bluetable.webp" width="10px" />
                          <img style="cursor: pointer"
                            v-if="cell.status == 'SELECIONADO' && cell.bloqueado && cell.active"
                            src="../../assets/graytable.webp" width="10px" />
                          <img style="cursor: pointer" v-if="cell.status == 'OCUPADO' && cell.active"
                            src="../../assets/redtable.webp" width="10px" />
                          <p
                            style="font-size: 3px; margin: 0px; color: white; cursor: pointer; position: absolute; top: 53%; left: 50%; transform: translate(-50%, -50%); z-index: 1">
                            {{ cell.vaga }}</p>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <p style="background-color: black; color: white; font-weight: bold; padding: 2px; line-height: 1.0rem"
                    v-if="inscricao[0].vagas && inscricao[0].vagas.length > 0">
                    ATENÇÃO: Ao selecionar uma mesa, você terá 15 minutos para realizar o pagamento. Após esse prazo, a
                    vaga
                    será liberada para outra pessoa.
                  </p>
                </v-flex>

                <v-container style="padding: 0px 12px 0px 12px">
                  <v-flex xs12 sm12 lg12>
                    <v-checkbox v-model="aceiteLgpd" style="margin-top: 0px">
                      <template v-slot:label>
                        <div>
                          Concordo com as
                          <a target="_blank"
                            :href="urlPoliticaPrivacidade"
                            @click.stop>políticas de privacidade, cancelamento e tratamento de dados
                            pessoais</a>
                        </div>
                      </template>
                    </v-checkbox>
                  </v-flex>
                </v-container>
                <v-container style="padding: 0px 12px 0px 12px" v-if="eventoSelecionado.urlImgObs">
                  <v-flex xs12 sm12 lg12 style="text-align: center">
                    <img :src="eventoSelecionado.urlImgObs" width="100%" style="max-width: 300px" />
                  </v-flex>
                </v-container>
                <v-container style="padding: 0px 12px 0px 12px">
                  <v-flex xs12 sm12 lg12 style="margin: 5px 0px 5px 0px">              
                    <v-alert
                      text
                      color="info"
                      border="left"
                      class="mb-4"
                      style="border-radius: 8px;"
                      dense
                    >
                      <span class="text-body-2">
                        <strong>Importante:</strong> Nas compras realizadas com a opção de parcelamento, poderão incidir taxas de parcelamento, cujas condições estarão claramente expostas. <strong>As condições de parcelamentos são personalizadas para melhorar a experiência de compra e o Comprador poderá optar por alterar a condição de parcelamento antes de confirmar o pedido</strong>.
                      </span>
                    </v-alert>

                    <div class="mb-4" style="border-radius: 8px;">
                        <v-alert
                          text
                          color="warning"
                          border="left"
                          class="mb-0"
                          style="border-radius: 8px;"
                          dense
                        >
                          <div class="text-body-2" style="white-space: pre-line;" v-html="formatarDescricao(eventoSelecionado.descricaoCompra)"></div>
                        </v-alert>
                      </div>
                  </v-flex>
                  
                  <v-flex xs12 sm12 lg12 style="margin: 5px 0px 5px 0px">
                    <h2>Detalhes da Compra:</h2>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 style="margin: 5px 0px 5px 0px">
                    <h3 style="color: orange" class="no-break">{{ eventoSelecionado.nome }}</h3>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 v-if="inscricao[0].vagas && inscricao[0].vagas.length > 0">
                    <h3 style="color: orange">
                      Mesas selecionadas: {{ vagasSelecionadas }}
                    </h3>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 v-if="!eventoSelecionado.valorPix && !eventoSelecionado.valorCartao">
                    <h3 style="color: orange">
                      Total: {{ valorTotalCompra.toLocaleString("pt-BR", { style: "currency", currency: "BRL", }) }}
                    </h3>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 v-if="eventoSelecionado.valorPix && eventoSelecionado.valorCartao">
                    <h3 style="color: orange" v-if="eventoSelecionado.valorPix && inscricao[0].vagas && inscricao[0].vagas.length > 0">
                      Pix: {{ (parseFloat(this.eventoSelecionado.valorPix.replace(",", ".")) * this.inscricao[0].vagas.length).toLocaleString("pt-BR", { style: "currency", currency: "BRL"}) }}
                    </h3>
                    <h3 style="color: orange" v-if="eventoSelecionado.valorCartao && inscricao[0].vagas && inscricao[0].vagas.length > 0">
                      Cartão: em até {{ eventoSelecionado.quantidadeParcelas }}x de {{ calculaParcelas(eventoSelecionado, inscricao[0].vagas.length) }}
                    </h3>
                  </v-flex>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg4 v-if="eventoSelecionado.valorCartao">
                      <v-btn depressed block outlined style="border-radius: 7px" large
                        @click="prosseguirPagamento('CARTÃO')">
                        <img style="margin-right: 5px" src="../../assets/credit-card.png" width="25px" />
                        Cartão
                      </v-btn>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg4>
                      <v-btn depressed block outlined style="border-radius: 7px;" large @click="prosseguirPagamento('BOLETO')">
                        <img style="margin-right: 5px" src="../../assets/barcode.png" width="30px">
                        Boleto
                      </v-btn> 
                    </v-flex> -->
                    <v-flex xs12 sm12 lg4 v-if="eventoSelecionado.valorPix">
                      <v-btn depressed block outlined style="border-radius: 7px" large
                        @click="prosseguirPagamento('PIX')">
                        <img style="margin-right: 5px" src="../../assets/pix.png" width="20px" />
                        Pix
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="text-align: center">
                      <img style="margin-right: 5px" src="../../assets/site-seguro-blindado.png" width="250px" />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- PÁGINA INSCRIÇÃO VAGAS -->
    <!-- Fim formulario de inscrição --> 

    <!-- Formulario de camisa torcedor -->
        <!-- PÁGINA INSCRIÇÃO -->
        <v-row v-if="paginaInscricaoGrupoTorcedor" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card flat class="modern-card" style="border-radius: 16px; overflow: hidden; box-shadow: 0 8px 30px rgba(0,0,0,0.05);">
              <v-card-text style="padding: 24px;">
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" class="pb-0">
                      <div class="d-flex align-center">
                        <v-btn 
                          v-if="!bloqueiaVoltar" 
                          text 
                          color="#00695C" 
                          @click="retornaPaginaPrincipal"
                          class="px-2 mr-2"
                        >
                          <v-icon>mdi-arrow-left</v-icon>
                        </v-btn>
                        <h2 class="text-h5 font-weight-medium grey--text text--darken-3">Formulário de Inscrição</h2>
                      </div>
                    </v-col>
                    
                    <!-- Mensagem de desconto do divulgador -->
                    <v-col cols="12" v-if="indicacao && divulgador && divulgador.aplicaDesconto && eventoSelecionado.usaLinkDesconto">
                      <v-alert
                        color="#00695C"
                        dark
                        icon="mdi-tag-multiple"
                        border="left"
                        prominent
                        class="mb-4"
                      >
                        <div class="text-subtitle-1">
                          Você está utilizando o link de <strong>{{ divulgador.nome }}</strong>
                          <br>
                          Desconto de <strong>{{ divulgador.valorDesconto }}%</strong> aplicado automaticamente!
                        </div>
                      </v-alert>
                    </v-col>
                    
                    <v-col cols="12" class="text-center" v-if="eventoSelecionado.urlMapa">
                      <v-img 
                        :src="eventoSelecionado.urlMapa" 
                        alt="MapaEvento" 
                        max-width="500px" 
                        class="mx-auto rounded-lg" 
                        style="border-radius: 12px;"
                      ></v-img>
                    </v-col>
                    
                    <v-col cols="12" v-if="quantidade.length > 1">
                      <div class="d-flex align-center my-3">
                        <span class="text-subtitle-1 mr-3 grey--text text--darken-2">Quantidade:</span>
                        <v-select 
                          outlined 
                          dense 
                          hide-details 
                          v-model="qtdCompra" 
                          :items="quantidade"
                          @input="verificaCapacidade()"
                          style="max-width: 100px;"
                          class="mt-0 pt-0"
                        ></v-select>
                      </div>
                    </v-col>
                  </v-row>
                </v-container>

                <v-container fluid v-for="index in qtdCompra" :key="index" class="py-2">
                  <v-card class="mb-6 pa-4" outlined style="border-radius: 12px; border-color: #e0e0e0;">
                    <v-row>
                      <v-col cols="12">
                        <p class="text-subtitle-1 font-weight-medium mb-4" v-if="qtdCompra != 1">
                          Dados do {{ index }}º participante:
                        </p>
                        <p class="text-subtitle-1 font-weight-medium mb-4" v-else>
                          Dados do participante:
                        </p>

                        <v-radio-group 
                          v-model="inscricao[index - 1].tipoDocumento" 
                          row 
                          @change="limpaSetor(index - 1)"
                          v-if="eventoSelecionado.tipoDocumento == 'AMBOS'"
                          class="my-2"
                        >
                          <v-radio label="CPF" value="CPF" color="#00695C"></v-radio>
                          <v-radio label="CNPJ" value="CNPJ" color="#00695C"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" md="4" v-if="(eventoSelecionado.tipoDocumento == 'CPF' || inscricao[index - 1].tipoDocumento == 'CPF')">
                        <v-text-field 
                          label="CPF resp. financeiro" 
                          v-model="inscricao[index - 1].cpf" 
                          color="#00695C" 
                          outlined 
                          v-mask="'###.###.###-##'" 
                          dense 
                          rounded
                          hide-details 
                          required 
                          type="tel"
                          @change="verificaDocumento(inscricao[index - 1].cpf, index - 1, 'CPF')"
                          class="input-field"
                          prepend-inner-icon="mdi-card-account-details"
                        ></v-text-field>
                      </v-col>
                      
                      <v-col cols="12" md="4" v-if="eventoSelecionado.tipoDocumento == 'CNPJ' || inscricao[index - 1].tipoDocumento == 'CNPJ'">
                        <v-text-field 
                          label="CNPJ" 
                          v-model="inscricao[index - 1].cpf" 
                          color="#00695C" 
                          outlined 
                          v-mask="'##.###.###/####-##'" 
                          dense 
                          rounded
                          hide-details 
                          required 
                          type="tel"
                          @change="verificaDocumento(inscricao[index - 1].cpf, index - 1, 'CNPJ')"
                          class="input-field"
                          prepend-inner-icon="mdi-card-account-details"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="8" v-if="eventoSelecionado.tipoDocumento == 'CPF' || inscricao[index - 1].tipoDocumento == 'CPF'">
                        <v-text-field
                          label="Nome Torcedor"
                          v-model="inscricao[index - 1].nome"
                          color="#00695C"
                          outlined
                          dense
                          rounded
                          hide-details
                          required
                          class="input-field"
                          prepend-inner-icon="mdi-account"
                        ></v-text-field>
                      </v-col>
                      
                      <v-col cols="12" md="8" v-if="eventoSelecionado.tipoDocumento == 'CNPJ' || inscricao[index - 1].tipoDocumento == 'CNPJ'">
                        <v-text-field
                          label="Razão social"
                          v-model="inscricao[index - 1].nome"
                          color="#00695C"
                          outlined
                          dense
                          rounded
                          hide-details
                          required
                          class="input-field"
                          prepend-inner-icon="mdi-account"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="4">
                        <v-select 
                          label="Torcida" 
                          v-model="inscricao[index - 1].torcida" 
                          :items="torcidas"
                          color="#00695C" 
                          outlined 
                          dense
                          rounded
                          hide-details 
                          required
                          class="input-field"
                          prepend-inner-icon="mdi-account-group"
                        ></v-select>
                      </v-col>

                      <v-col cols="12" md="4">
                        <v-select 
                          label="Tamanho da camisa" 
                          v-model="inscricao[index - 1].tamanhoCamisa" 
                          :items="tamanhosCamisa"
                          color="#00695C" 
                          outlined 
                          dense
                          rounded
                          hide-details 
                          required
                          class="input-field"
                          prepend-inner-icon="mdi-tshirt-crew"
                        ></v-select>
                      </v-col>

                      <!-- <v-col cols="12" md="4">
                        <v-text-field 
                          label="WhatsApp com DDD" 
                          v-model="inscricao[index - 1].telefone" 
                          color="#00695C" 
                          type="tel" 
                          outlined 
                          rounded
                          hide-details 
                          v-mask="'(##) #####-####'" 
                          dense
                          required
                          class="input-field"
                          prepend-inner-icon="mdi-cellphone"
                        ></v-text-field>
                      </v-col> -->

                      <!-- <v-col cols="12" xs="12" sm="12" md="12" lg="12" v-if="filhosSelect.length > 0">
                        <v-card outlined>
                          <v-card-text>
                            <p style="margin: 0px; font-size: 17px;">Selecione os filhos que irão participar:</p>
                            <div v-for="filho in filhosSelect" :key="filho" style="margin-bottom: 10px;">
                              <v-checkbox 
                                hide-details 
                                v-model="inscricao[index - 1].filho" 
                                :label="filho" 
                                :value="filho"
                                @change="onFilhoChange(filho, index - 1)"
                              ></v-checkbox>
                              <v-select
                                v-if="inscricao[index - 1].filho.includes(filho) && !ehEventoOnibus"
                                v-model="tamanhosCamisaGlobal[`${index - 1}_${filho}`]"
                                :items="tamanhos"
                                label="Tamanho da camisa"
                                dense
                                outlined
                                style="margin-left: 40px; margin-top: 5px; max-width: 250px;"
                                hide-details
                              ></v-select>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col> -->
                      
                      <!-- <v-col cols="12">
                        <v-btn
                          v-if="index - 1 != 0"
                          block
                          depressed
                          @click="preencherInformacoes(index - 1)"
                        >Preencher informações
                        </v-btn>
                      </v-col> -->
                    </v-row>
                  </v-card>
                </v-container>
                
                <v-flex xs12 sm12 lg12>
                      <v-checkbox v-model="aceiteLgpd" style="margin-top:15px">
                        <template v-slot:label>
                          <div>
                            Concordo com as
                            <a target="_blank"
                              :href="urlPoliticaPrivacidade"
                              @click.stop>políticas de privacidade e tratamento de dados
                              pessoais</a>
                          </div>
                        </template>
                      </v-checkbox>
                    </v-flex>

                <v-container style="padding: 0px 12px" v-if="eventoSelecionado.urlImgObs">
                  <v-img 
                    :src="eventoSelecionado.urlImgObs" 
                    max-width="300px" 
                    class="mx-auto rounded-lg"
                    style="border-radius: 12px;"
                  ></v-img>
                </v-container>

                <v-container class="pt-4 pb-0">
                  <v-card outlined class="pa-4" style="border-radius: 12px; border-color: #e0e0e0;">
                    <v-card-title class="px-0 pt-0 text-h5 font-weight-medium grey--text text--darken-3">
                      Detalhes da Compra
                    </v-card-title>
                    
                    <v-card-text class="px-0 pt-2 pb-0">
                      <h3 class="text-h6 font-weight-medium text--darken-1 mb-4 no-break">{{ eventoSelecionado.nome }}</h3>
                      <v-alert
                        text
                        color="info"
                        border="left"
                        class="mb-4"
                        style="border-radius: 8px;"
                        dense
                      >
                        <span class="text-body-2">
                          <strong>Importante:</strong> Nas compras realizadas com a opção de parcelamento, poderão incidir taxas de parcelamento, cujas condições estarão claramente expostas. <strong>As condições de parcelamentos são personalizadas para melhorar a experiência de compra e o Comprador poderá optar por alterar a condição de parcelamento antes de confirmar o pedido</strong>.
                        </span>
                      </v-alert>

                      <v-alert
                        text
                        color="warning"
                        border="left"
                        class="mb-4"
                        style="border-radius: 8px;"
                        dense
                      >
                        <span class="text-body-2">
                          <strong>INFORMAÇÕES IMPORTANTES</strong><br><br>

                          <strong>POLÍTICA DE CANCELAMENTOS</strong><br>
                          Após a compra da camisa, <strong>não será mais passível de reembolso.</strong><br><br>
                        </span>
                      </v-alert>
                      
                      <div v-if="!eventoSelecionado.valorPix && !eventoSelecionado.valorCartao">
                        <h3 class="text-h6 font-weight-bold orange--text text--darken-1 mb-2">
                          Total: {{ valorTotalCompra.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) }}
                        </h3>
                      </div>
                      
                      <div v-if="eventoSelecionado.valorPix && eventoSelecionado.valorCartao" class="mb-2">
                        <v-chip 
                          color="orange" 
                          text-color="white" 
                          label 
                          small 
                          class="mr-2 mb-2"  
                        >Opções de pagamento</v-chip>
                        
                        <div class="d-flex justify-center" style="width: 100%; flex-wrap: wrap; gap: 16px;margin-top: 10px;">
                          <v-btn
                            class="payment-option-card mb-2"
                            elevation="2"
                            :ripple="false"
                            outlined
                            style="border-radius: 12px; border: 1px solid rgba(0,0,0,0.05); width: 250px; height: 150px; overflow: hidden; text-transform: none; border-top: 5px solid #28c76f;"
                            v-if="eventoSelecionado.valorPix"
                            @click="prosseguirPagamento('PIX')"
                          >
                            <div class="d-flex flex-column align-center" style="width: 100%">
                              <div class="d-flex align-center mb-2">
                                <img src="../../assets/pix.png" width="18px" class="mr-2" />
                                <div class="text-subtitle-1 font-weight-medium">Pix</div>
                              </div>
                              <div class="text-h6 font-weight-bold green--text text--darken-1 mt-2">
                                {{ calculaValorPix().toLocaleString("pt-BR", { style: "currency", currency: "BRL"}) }}
                              </div>
                            </div>
                          </v-btn>
                          
                          <v-btn
                            class="payment-option-card mb-2"
                            elevation="2"
                            :ripple="false"
                            outlined
                            style="border-radius: 12px; border: 1px solid rgba(0,0,0,0.05); width: 250px; height: 150px; overflow: hidden; text-transform: none; border-top: 5px solid #F57C00;"
                            v-if="eventoSelecionado.valorCartao"
                            @click="prosseguirPagamento('CARTÃO')"
                          >
                            <div class="d-flex flex-column align-center" style="width: 100%">
                              <div class="d-flex align-center mb-2">
                                <v-icon small color="black" class="mr-2">mdi-credit-card</v-icon>
                                <div class="text-subtitle-1 font-weight-medium">Cartão</div>
                              </div>
                              <div class="text-caption grey--text text--darken-1 mt-1">
                                em até {{ eventoSelecionado.quantidadeParcelas }}x de
                              </div>
                              <div class="text-h6 font-weight-bold orange--text text--darken-1 mt-2">
                                {{ calculaParcelas(eventoSelecionado, inscricao[0].filho.length) }}
                              </div>
                            </div>
                          </v-btn>
                        </div> 
                      </div>
                    </v-card-text>
                  </v-card>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <!-- PÁGINA INSCRIÇÃO -->

        <!-- PÁGINA INSCRIÇÃO VAGAS -->
        <v-row v-if="paginaInscricaoVagasTorcedor" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px; padding: 0px">
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12 v-if="!bloqueiaVoltar">
                      <v-btn outlined @click="retornaPaginaPrincipal">
                        <v-icon left>mdi-arrow-left</v-icon>
                        Voltar
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 v-if="!quantidade.length == 1">
                      <br />
                      <p style="margin-bottom: 0px">Quantidade:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg1 v-if="!quantidade.length == 1">
                      <v-select outlined dense hide-details v-model="qtdCompra" :items="quantidade"
                        @input="verificaCapacidade()"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="margin-top: 20px" v-if="!quantidade.length == 1">
                      <v-divider></v-divider>
                    </v-flex>
                  </v-layout>
                </v-container>

                <v-container fluid grid-list-md v-for="index in qtdCompra" :key="index">
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px" v-if="qtdCompra != 1">
                        Dados do {{ index }}º participante:
                      </p>
                      <p style="margin-bottom: 0px" v-else>
                        Dados do participante:
                      </p>
                    </v-flex>

                    <v-flex xs12 sm12 lg12 v-if="eventoSelecionado.tipoDocumento == 'AMBOS'">
                      <v-radio-group v-model="inscricao[index - 1].tipoDocumento" row @change="limpaSetor(index - 1)">
                        <v-radio label="CPF" value="CPF"></v-radio>
                        <v-radio label="CNPJ" value="CNPJ"></v-radio>
                      </v-radio-group>
                      <v-alert v-if="
                        eventoSelecionado.desconto &&
                        inscricao[index - 1].tipoDocumento == 'CNPJ'
                      " dark type="success">
                        Desconto de R$
                        {{ eventoSelecionado.desconto }} aplicado!
                      </v-alert>
                    </v-flex>

                    <v-flex xs12 sm12 lg4 v-if="
                      eventoSelecionado.tipoDocumento == 'CPF' ||
                      inscricao[index - 1].tipoDocumento == 'CPF'
                    ">
                      <v-text-field
                        label="CPF Resp. Financeiro*"
                        v-model="inscricao[index - 1].cpf"
                        light
                        color="#00695C"
                        outlined
                        rounded
                        v-mask="'###.###.###-##'"
                        dense
                        hide-details
                        required
                        type="tel" 
                        class="input-field"
                        prepend-inner-icon="mdi-card-account-details"
                        @change="verificaDocumento(inscricao[index - 1].cpf, index - 1, 'CPF')">
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 v-if="
                      eventoSelecionado.tipoDocumento == 'CNPJ' ||
                      inscricao[index - 1].tipoDocumento == 'CNPJ'
                    ">
                      <v-text-field
                        label="CNPJ*"
                        v-model="inscricao[index - 1].cpf"
                        light
                        color="#00695C"
                        outlined
                        rounded
                        v-mask="'##.###.###/####-##'"
                        dense
                        hide-details
                        required
                        type="tel"
                        class="input-field"
                        prepend-inner-icon="mdi-card-account-details"
                        @change="verificaDocumento(inscricao[index - 1].cpf, index - 1, 'CNPJ')
                      "></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 lg8 v-if="
                      (eventoSelecionado.tipoDocumento == 'CPF' ||
                      inscricao[index - 1].tipoDocumento == 'CPF')
                    ">
                      <v-text-field
                        label="Nome completo*"
                        v-model="inscricao[index - 1].nome"
                        light
                        outlined
                        rounded
                        color="#00695C"
                        dense
                        hide-details
                        required
                        class="input-field"
                        prepend-inner-icon="mdi-account"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg8 v-if="
                      eventoSelecionado.tipoDocumento == 'CNPJ' ||
                      inscricao[index - 1].tipoDocumento == 'CNPJ'
                    ">
                      <v-text-field
                        label="Razão social*"
                        v-model="inscricao[index - 1].nome"
                        light
                        outlined
                        rounded
                        color="#00695C"
                        dense
                        hide-details
                        required
                        class="input-field"
                        prepend-inner-icon="mdi-account"
                      ></v-text-field>
                    </v-flex>

                    <!-- <v-flex xs12 sm12 lg6>
                      <v-text-field
                        label="WhatsApp com DDD*"
                        v-model="inscricao[index - 1].telefone"
                        light
                        color="#00695C"
                        type="tel"
                        outlined
                        rounded
                        hide-details
                        v-mask="'(##) #####-####'"
                        dense
                        required
                        class="input-field"
                        prepend-inner-icon="mdi-cellphone"
                      ></v-text-field>
                    </v-flex> -->

                    <!-- <v-flex xs12 sm12 lg12 v-if="exibeMapa">
                      <v-card outlined>
                        <v-card-text>
                          <p style="margin: 0px; font-size: 17px;">Selecione os filhos que irão participar:</p>
                          <div v-for="filho in filhosSelect" :key="filho" style="margin-bottom: 10px;">
                            <v-checkbox 
                              hide-details 
                              v-model="inscricao[index - 1].filho" 
                              :label="filho" 
                              :value="filho"
                              @change="onFilhoChange(filho, index - 1)"
                            ></v-checkbox>
                            <v-select
                              v-if="inscricao[index - 1].filho.includes(filho) && !ehEventoOnibus"
                              v-model="tamanhosCamisaGlobal[`${index - 1}_${filho}`]"
                              :items="tamanhos"
                              label="Tamanho da camisa"
                              dense
                              outlined
                              style="margin-left: 40px; margin-top: 5px; max-width: 200px;"
                              hide-details
                            ></v-select>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-flex> -->

                    <!-- <v-flex xs12 sm12 lg4>
                      <v-text-field label="E-MAIL" v-model="inscricao[index - 1].email" light
                        color="#00695C" outlined hide-details dense required></v-text-field>
                    </v-flex> -->

                    <!-- <v-flex xs12 sm12 lg4>
                      <v-text-field label="IDADE*" v-model="inscricao[index - 1].idade" light
                        color="#00695C" outlined hide-details dense required></v-text-field>
                    </v-flex> -->
                    <!-- <v-flex xs12 sm12 lg12 :key="x">
                      <v-row dense>
                        <v-flex xs12 sm12 lg4 v-for="composicao in eventoSelecionado.composicao" :key="composicao.tipo">
                          <v-card outlined>
                            <v-card-title style="font-weight: bold; font-size:14px">{{ composicao.tipo }}</v-card-title>
                            <v-card-subtitle style="padding-bottom: 0px">R$ {{ composicao.valor }}</v-card-subtitle>

                            <v-card-actions :key="composicao.quantidade">
                              <v-spacer></v-spacer>

                              <v-btn icon color="red" @click="removeComposicao(composicao)" :disabled="composicao.quantidade == 0">
                                <v-icon>mdi-minus-circle</v-icon>
                              </v-btn>

                              <v-btn icon disabled>
                                <p style="margin: 0px">{{ composicao.quantidade }}</p>
                              </v-btn>

                              <v-btn icon color="green" @click="acrescentaComposicao(composicao)">
                                <v-icon>mdi-plus-circle</v-icon>
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-flex>
                      </v-row>
                    </v-flex> -->
                    <v-flex xs12 sm12 lg12 style="margin-bottom: 0px" :key="x" v-if="eventoSelecionado.composicao && eventoSelecionado.composicao.length > 0">
                      <v-row dense>
                        <v-flex xs12 sm12 lg4 v-for="composicao in eventoSelecionado.composicao" :key="composicao.tipo">
                          <v-card outlined>
                            <v-row class="" style="padding-left: 10px" align="center">
                              <v-col cols="6" class="text-left">
                                <div style="font-weight: bold; font-size: 14px">
                                  {{ composicao.tipo }}
                                </div>
                                <div>R$ {{ composicao.valor }}</div>
                              </v-col>

                              <v-col cols="6">
                                <v-row justify="end" no-gutters>
                                  <v-btn icon color="red" @click="removeComposicao(composicao)"
                                    :disabled="composicao.quantidade == 0">
                                    <v-icon>mdi-minus-circle</v-icon>
                                  </v-btn>

                                  <v-btn icon>
                                    <p style="margin: 0px">
                                      {{ composicao.quantidade }}
                                    </p>
                                  </v-btn>

                                  <v-btn icon color="green" @click="acrescentaComposicao(composicao)">
                                    <v-icon>mdi-plus-circle</v-icon>
                                  </v-btn>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-card>
                        </v-flex>
                      </v-row>
                    </v-flex>
                    <!-- <v-flex>
                      <v-btn
                        v-if="index - 1 != 0"
                        block
                        depressed
                        @click="preencherInformacoes(index - 1)"
                        >Preencher informações</v-btn
                      >
                    </v-flex> -->
                    <v-flex xs12 sm12 lg12>
                      <v-divider v-if="index != qtdCompra" style="margin-top: 40px"></v-divider>
                    </v-flex>
                  </v-layout>
                </v-container>

                <v-flex xs12 sm12 lg12 style="text-align: center" v-if="exibeMapa">
                  <v-flex xs10 sm10 lg6 style="text-align: left; margin: 0px auto">
                    <table style="width: 100%">
                      <tr>
                        <td>
                          <p style="margin: 0px; font-size: 11px"><v-icon small color="#22b42c">mdi-square</v-icon>Livre
                          </p>
                          <p style="margin: 0px; font-size: 11px"><v-icon small
                              color="#ff5050">mdi-square</v-icon>Ocupado</p>
                        </td>
                        <td>
                          <p style="margin: 0px; font-size: 11px"><v-icon small
                              color="#2024b6">mdi-square</v-icon>Selecionado
                            por você</p>
                          <p style="margin: 0px; font-size: 11px"><v-icon small
                              color="#767171">mdi-square</v-icon>Selecionado
                            por outra pessoa</p>
                        </td>
                      </tr>
                    </table>
                  </v-flex>
                  <div ref="matrixContainer" :style="backgroundStyle" style="overflow: hidden; display: inline-block;">
                    <table ref="matrixTable" :key="x">
                      <tr v-for="(row, rowIndex) in matrix" :key="rowIndex">
                        <td v-for="(cell, colIndex) in row" :key="colIndex"
                          @click="cell.status != 'OCUPADO' || !cell.bloqueado || cell.active ? cellClicked(rowIndex, colIndex) : ''"
                          :data-cell-number="cell.localizacao" style="position: relative;">
                          <img style="cursor: pointer" v-if="cell.status == 'LIVRE' && cell.active"
                            src="../../assets/greentable.webp" width="10px" />
                          <img style="cursor: pointer"
                            v-if="cell.status == 'SELECIONADO' && !cell.bloqueado && cell.active"
                            src="../../assets/bluetable.webp" width="10px" />
                          <img style="cursor: pointer"
                            v-if="cell.status == 'SELECIONADO' && cell.bloqueado && cell.active"
                            src="../../assets/graytable.webp" width="10px" />
                          <img style="cursor: pointer" v-if="cell.status == 'OCUPADO' && cell.active"
                            src="../../assets/redtable.webp" width="10px" />
                          <p
                            style="font-size: 3px; margin: 0px; color: white; cursor: pointer; position: absolute; top: 53%; left: 50%; transform: translate(-50%, -50%); z-index: 1">
                            {{ cell.vaga }}</p>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <p style="background-color: black; color: white; font-weight: bold; padding: 2px; line-height: 1.0rem"
                    v-if="inscricao[0].vagas && inscricao[0].vagas.length > 0">
                    ATENÇÃO: Ao selecionar uma mesa, você terá 15 minutos para realizar o pagamento. Após esse prazo, a
                    vaga
                    será liberada para outra pessoa.
                  </p>
                </v-flex>

                <v-container style="padding: 0px 12px 0px 12px">
                  <v-flex xs12 sm12 lg12>
                    <v-checkbox v-model="aceiteLgpd" style="margin-top: 0px">
                      <template v-slot:label>
                        <div>
                          Concordo com as
                          <a target="_blank"
                            :href="urlPoliticaPrivacidade"
                            @click.stop>políticas de privacidade, cancelamento e tratamento de dados
                            pessoais</a>
                        </div>
                      </template>
                    </v-checkbox>
                  </v-flex>
                </v-container>
                <v-container style="padding: 0px 12px 0px 12px" v-if="eventoSelecionado.urlImgObs">
                  <v-flex xs12 sm12 lg12 style="text-align: center">
                    <img :src="eventoSelecionado.urlImgObs" width="100%" style="max-width: 300px" />
                  </v-flex>
                </v-container>
                <v-container style="padding: 0px 12px 0px 12px">
                  <v-flex xs12 sm12 lg12 style="margin: 5px 0px 5px 0px">              
                    <v-alert
                      text
                      color="info"
                      border="left"
                      class="mb-4"
                      style="border-radius: 8px;"
                      dense
                    >
                      <span class="text-body-2">
                        <strong>Importante:</strong> Nas compras realizadas com a opção de parcelamento, poderão incidir taxas de parcelamento, cujas condições estarão claramente expostas. <strong>As condições de parcelamentos são personalizadas para melhorar a experiência de compra e o Comprador poderá optar por alterar a condição de parcelamento antes de confirmar o pedido</strong>.
                      </span>
                    </v-alert>

                    <!-- <v-alert
                      text
                      color="warning"
                      border="left"
                      class="mb-4"
                      style="border-radius: 8px;"
                      dense
                    >
                      <span class="text-body-2">
                        <strong>INFORMAÇÕES IMPORTANTES</strong><br><br>

                        <strong>PARTICIPAÇÃO DO ALUNO</strong><br>
                        A participação do aluno no Arraiá INA é gratuita, mas deve estar acompanhado de um responsável pagante.<br><br>

                        <strong>TIPOS DE INGRESSOS</strong><br>
                        Mesa (4 lugares): Ingresso com direito a uma mesa e 4 cadeiras (não é póssivel adicionar cadeiras extras).<br>
                        Senha individual: Dá acesso a uma cadeira na área das cadeiras avulsas, conforme mapa do evento.<br><br>

                        <strong>O ALUNO INA CONTA LUGAR NA MESA?</strong><br>
                        Caso o aluno deseje passar todo o Arraiá sentado, sim. Como o aluno não costuma sentar-se, deixamos para a família decidir quem ocupará as 4 cadeiras.<br><br>

                        <strong>A PARTIR DE QUE IDADE A CRIANÇA (QUE NÃO SEJA ALUNO INA) PRECISA DE INGRESSO?</strong><br>
                        Crianças a partir de 6 anos de idade são consideradas pagantes.<br><br>

                        <strong>POLÍTICA DE CANCELAMENTOS</strong><br>
                        O cancelamento poderá ser solicitado em até 7 dias após a compra e com, no mínimo, 48h de antecedência do evento. <strong>Entretanto, após o recebimento da camisa, não será mais passível de reembolso.</strong><br><br>

                        Viva a tradição, celebre com emoção e venha fazer parte de um São João inesquecível!<br>
                        Garanta já o seu ingresso e bora pro Arraiá INA 2025!
                      </span>
                    </v-alert> -->
                  </v-flex>
                  
                  <v-flex xs12 sm12 lg12 style="margin: 5px 0px 5px 0px">
                    <h2>Detalhes da Compra:</h2>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 style="margin: 5px 0px 5px 0px">
                    <h3 style="color: orange" class="no-break">{{ eventoSelecionado.nome }}</h3>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 v-if="inscricao[0].vagas && inscricao[0].vagas.length > 0">
                    <h3 style="color: orange">
                      Mesas selecionadas: {{ vagasSelecionadas }}
                    </h3>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 v-if="!eventoSelecionado.valorPix && !eventoSelecionado.valorCartao">
                    <h3 style="color: orange">
                      Total: {{ valorTotalCompra.toLocaleString("pt-BR", { style: "currency", currency: "BRL", }) }}
                    </h3>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 v-if="eventoSelecionado.valorPix && eventoSelecionado.valorCartao">
                    <h3 style="color: orange" v-if="eventoSelecionado.valorPix && inscricao[0].vagas && inscricao[0].vagas.length > 0">
                      Pix: {{ (parseFloat(this.eventoSelecionado.valorPix.replace(",", ".")) * this.inscricao[0].vagas.length).toLocaleString("pt-BR", { style: "currency", currency: "BRL"}) }}
                    </h3>
                    <h3 style="color: orange" v-if="eventoSelecionado.valorCartao && inscricao[0].vagas && inscricao[0].vagas.length > 0">
                      Cartão: em até {{ eventoSelecionado.quantidadeParcelas }}x de {{ calculaParcelas(eventoSelecionado, inscricao[0].vagas.length) }}
                    </h3>
                  </v-flex>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg4 v-if="eventoSelecionado.valorCartao">
                      <v-btn depressed block outlined style="border-radius: 7px" large
                        @click="prosseguirPagamento('CARTÃO')">
                        <img style="margin-right: 5px" src="../../assets/credit-card.png" width="25px" />
                        Cartão
                      </v-btn>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg4>
                      <v-btn depressed block outlined style="border-radius: 7px;" large @click="prosseguirPagamento('BOLETO')">
                        <img style="margin-right: 5px" src="../../assets/barcode.png" width="30px">
                        Boleto
                      </v-btn> 
                    </v-flex> -->
                    <v-flex xs12 sm12 lg4 v-if="eventoSelecionado.valorPix">
                      <v-btn depressed block outlined style="border-radius: 7px" large
                        @click="prosseguirPagamento('PIX')">
                        <img style="margin-right: 5px" src="../../assets/pix.png" width="20px" />
                        Pix
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="text-align: center">
                      <img style="margin-right: 5px" src="../../assets/site-seguro-blindado.png" width="250px" />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- PÁGINA INSCRIÇÃO VAGAS -->
    <!-- Fim formulario de camisa torcedor -->

    <!-- Formulario de onibus -->
        <!-- PÁGINA INSCRIÇÃO ONIBUS -->
        <v-row v-if="paginaInscricaoGrupoOnibus" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card flat class="modern-card" style="border-radius: 16px; overflow: hidden; box-shadow: 0 8px 30px rgba(0,0,0,0.05);">
              <v-card-text style="padding: 24px;">
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" class="pb-0">
                      <div class="d-flex align-center">
                        <v-btn 
                          v-if="!bloqueiaVoltar" 
                          text 
                          color="#00695C" 
                          @click="retornaPaginaPrincipal"
                          class="px-2 mr-2"
                        >
                          <v-icon>mdi-arrow-left</v-icon>
                        </v-btn>
                        <h2 class="text-h5 font-weight-medium grey--text text--darken-3">Formulário de Inscrição</h2>
                      </div>
                    </v-col>
                    
                    <!-- Mensagem de desconto do divulgador -->
                    <v-col cols="12" v-if="indicacao && divulgador && divulgador.aplicaDesconto && eventoSelecionado.usaLinkDesconto">
                      <v-alert
                        color="#00695C"
                        dark
                        icon="mdi-tag-multiple"
                        border="left"
                        prominent
                        class="mb-4"
                      >
                        <div class="text-subtitle-1">
                          Você está utilizando o link de <strong>{{ divulgador.nome }}</strong>
                          <br>
                          Desconto de <strong>{{ divulgador.valorDesconto }}%</strong> aplicado automaticamente!
                        </div>
                      </v-alert>
                    </v-col>
                    
                    <v-col cols="12" class="text-center" v-if="eventoSelecionado.urlMapa">
                      <v-img 
                        :src="eventoSelecionado.urlMapa" 
                        alt="MapaEvento" 
                        max-width="500px" 
                        class="mx-auto rounded-lg" 
                        style="border-radius: 12px;"
                      ></v-img>
                    </v-col>
                    
                    <!-- <v-col cols="12" v-if="quantidade.length > 1">
                      <div class="d-flex align-center my-3">
                        <span class="text-subtitle-1 mr-3 grey--text text--darken-2">Quantidade:</span>
                        <v-select 
                          outlined 
                          dense 
                          hide-details 
                          v-model="qtdCompra" 
                          :items="quantidade"
                          @input="verificaCapacidade()"
                          style="max-width: 100px;"
                          class="mt-0 pt-0"
                        ></v-select>
                      </div>
                    </v-col> -->
                  </v-row>
                </v-container>

                <!-- SEÇÃO 1: RESPONSÁVEL FINANCEIRO -->
                <v-container fluid class="py-2">
                  <v-card class="mb-6 pa-4" outlined style="border-radius: 12px; border-color: #00695C; border-width: 2px;">
                    <v-card-title class="px-0 pt-0 pb-3">
                      <v-icon color="#00695C" class="mr-2">mdi-account-tie</v-icon>
                      <span class="text-h6 font-weight-bold" style="color: #00695C;">Dados do Responsável Financeiro</span>
                    </v-card-title>
                    <v-divider class="mb-4"></v-divider>
                    
                    <v-row>
                      <v-col cols="12" v-if="eventoSelecionado.tipoDocumento == 'AMBOS'">
                        <v-radio-group 
                          v-model="inscricao[0].tipoDocumento" 
                          row 
                          @change="limpaSetor(0)"
                          class="my-2"
                        >
                          <v-radio label="CPF" value="CPF" color="#00695C"></v-radio>
                          <v-radio label="CNPJ" value="CNPJ" color="#00695C"></v-radio>
                        </v-radio-group>
                      </v-col>

                      <v-col cols="12" md="4" v-if="eventoSelecionado.tipoDocumento == 'CPF' || inscricao[0].tipoDocumento == 'CPF'">
                        <v-text-field 
                          label="CPF do responsável financeiro" 
                          v-model="inscricao[0].cpf" 
                          color="#00695C" 
                          outlined 
                          v-mask="'###.###.###-##'" 
                          dense 
                          rounded
                          hide-details 
                          required 
                          type="tel"
                          @change="verificaDocumento(inscricao[0].cpf, 0, 'CPF')"
                          class="input-field"
                          prepend-inner-icon="mdi-card-account-details"
                        ></v-text-field>
                      </v-col>
                      
                      <v-col cols="12" md="4" v-if="eventoSelecionado.tipoDocumento == 'CNPJ' || inscricao[0].tipoDocumento == 'CNPJ'">
                        <v-text-field 
                          label="CNPJ" 
                          v-model="inscricao[0].cpf" 
                          color="#00695C" 
                          outlined 
                          v-mask="'##.###.###/####-##'" 
                          dense 
                          rounded
                          hide-details 
                          required 
                          type="tel"
                          @change="verificaDocumento(inscricao[0].cpf, 0, 'CNPJ')"
                          class="input-field"
                          prepend-inner-icon="mdi-card-account-details"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="8" v-if="eventoSelecionado.tipoDocumento == 'CPF' || inscricao[0].tipoDocumento == 'CPF'">
                        <v-text-field
                          label="Nome do Responsável"
                          v-model="inscricao[0].nome"
                          color="#00695C"
                          outlined
                          dense
                          rounded
                          hide-details
                          required
                          class="input-field"
                          prepend-inner-icon="mdi-account"
                        ></v-text-field>
                      </v-col>
                      
                      <v-col cols="12" md="8" v-if="eventoSelecionado.tipoDocumento == 'CNPJ' || inscricao[0].tipoDocumento == 'CNPJ'">
                        <v-text-field
                          label="Razão social"
                          v-model="inscricao[0].nome"
                          color="#00695C"
                          outlined
                          dense
                          rounded
                          hide-details
                          required
                          class="input-field"
                          prepend-inner-icon="mdi-account"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="4">
                        <v-text-field 
                          label="WhatsApp com DDD" 
                          v-model="inscricao[0].telefone" 
                          color="#00695C" 
                          type="tel" 
                          outlined 
                          rounded
                          hide-details 
                          v-mask="'(##) #####-####'" 
                          dense
                          required
                          class="input-field"
                          prepend-inner-icon="mdi-cellphone"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-container>

                <!-- SEÇÃO 2: FILHOS -->
                <v-container fluid class="py-2" v-if="filhosSelect && filhosSelect.length > 0">
                  <v-card class="mb-6 pa-4" outlined style="border-radius: 12px; border-color: #FF9800; border-width: 2px;">
                    <v-card-title class="px-0 pt-0 pb-3">
                      <v-icon color="#FF9800" class="mr-2">mdi-human-male-child</v-icon>
                      <span class="text-h6 font-weight-bold" style="color: #FF9800;">Filhos Participantes</span>
                    </v-card-title>
                    <v-divider class="mb-4"></v-divider>
                    
                    <v-row>
                      <v-col cols="12">
                        <p class="text-body-1 mb-4" style="color: #666;">Selecione os filhos que irão participar do evento:</p>
                        <div v-for="filho in filhosSelect" :key="filho" class="mb-4 pa-3" style="background-color: #FFF3E0; border-radius: 8px;">
                          <v-checkbox 
                            hide-details 
                            v-model="inscricao[0].filho" 
                            :label="filho" 
                            :value="filho"
                            @change="onFilhoChange(filho, 0)"
                            color="#FF9800"
                            class="mt-0"
                          ></v-checkbox>
                          <v-select
                            v-if="inscricao[0].filho.includes(filho) && !ehEventoOnibus && eventoSelecionado.permitePais === true"
                            v-model="tamanhosCamisaGlobal[`0_${filho}`]"
                            :items="tamanhos"
                            label="Tamanho da camisa"
                            dense
                            outlined
                            color="#FF9800"
                            style="margin-left: 40px; margin-top: 10px; max-width: 250px;"
                            hide-details
                          ></v-select>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-container>

                <!-- SEÇÃO 3: MAIS PASSAGEIROS -->
                <template v-for="index in qtdCompra">
                  <v-container v-if="index > 1" :key="index" fluid class="py-2">
                    <v-card class="mb-6 pa-4" outlined style="border-radius: 12px; border-color: #2196F3; border-width: 2px;">
                      <v-card-title class="px-0 pt-0 pb-3">
                        <v-icon color="#2196F3" class="mr-2">mdi-account-plus</v-icon>
                        <span class="text-h6 font-weight-bold" style="color: #2196F3;">Dados do Passageiro</span>
                        <v-spacer></v-spacer>
                        <v-btn
                          icon
                          color="red"
                          @click="removerPassageiro()"
                          v-if="qtdCompra > 1"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-card-title>
                      <v-divider class="mb-4"></v-divider>
                      
                      <v-row>
                        <v-col cols="12" md="6" v-if="eventoSelecionado.tipoDocumento == 'CPF' || inscricao[index - 1].tipoDocumento == 'CPF'">
                          <v-text-field
                            label="Nome do Passageiro"
                            v-model="inscricao[index - 1].nome"
                            color="#2196F3"
                            outlined
                            dense
                            rounded
                            hide-details
                            required
                            class="input-field"
                            prepend-inner-icon="mdi-account"
                          ></v-text-field>
                        </v-col>
                        
                        <v-col cols="12" md="6" v-if="eventoSelecionado.tipoDocumento == 'CNPJ' || inscricao[index - 1].tipoDocumento == 'CNPJ'">
                          <v-text-field
                            label="Nome do Passageiro"
                            v-model="inscricao[index - 1].nome"
                            color="#2196F3"
                            outlined
                            dense
                            rounded
                            hide-details
                            required
                            class="input-field"
                            prepend-inner-icon="mdi-account"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-text-field 
                            label="WhatsApp com DDD" 
                            v-model="inscricao[index - 1].telefone" 
                            color="#2196F3" 
                            type="tel" 
                            outlined 
                            rounded
                            hide-details 
                            v-mask="'(##) #####-####'" 
                            dense
                            required
                            class="input-field"
                            prepend-inner-icon="mdi-cellphone"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-container>
                </template>

                <!-- BOTÃO ADICIONAR PASSAGEIRO -->
                <v-container fluid class="py-2">
                  <v-card outlined style="border-radius: 12px; background-color: #F5F5F5;" class="pa-3">
                    <div class="d-flex align-center justify-space-between mb-3">
                      <!-- <div>
                        <v-icon color="#2196F3" class="mr-2">mdi-account-multiple</v-icon>
                        <span class="text-subtitle-1 font-weight-medium">Passageiros Extras: {{ qtdCompra - 1 }}</span>
                      </div> -->
                    </div>
                    <v-btn
                      block
                      color="#2196F3"
                      dark
                      elevation="2"
                      @click="adicionarPassageiro()"
                      :disabled="qtdCompra >= quantidade[quantidade.length - 1]"
                      style="border-radius: 12px;"
                      class="text-none font-weight-medium"
                    >
                      <v-icon left>mdi-account-plus</v-icon>
                      Adicionar Passageiro Extra
                    </v-btn>
                  </v-card>
                </v-container>
                
                <v-flex xs12 sm12 lg12>
                      <v-checkbox v-model="aceiteLgpd" style="margin-top:15px">
                        <template v-slot:label>
                          <div>
                            Concordo com as
                            <a target="_blank"
                              :href="urlPoliticaPrivacidade"
                              @click.stop>políticas de privacidade e tratamento de dados
                              pessoais</a>
                          </div>
                        </template>
                      </v-checkbox>
                    </v-flex>

                <v-container style="padding: 0px 12px" v-if="eventoSelecionado.urlImgObs">
                  <v-img 
                    :src="eventoSelecionado.urlImgObs" 
                    max-width="300px" 
                    class="mx-auto rounded-lg"
                    style="border-radius: 12px;"
                  ></v-img>
                </v-container>

                <v-container class="pt-4 pb-0">
                  <v-card outlined class="pa-4" style="border-radius: 12px; border-color: #e0e0e0;">
                    <v-card-title class="px-0 pt-0 text-h5 font-weight-medium grey--text text--darken-3">
                      Detalhes da Compra
                    </v-card-title>
                    
                    <v-card-text class="px-0 pt-2 pb-0">
                      <h3 class="text-h6 font-weight-medium text--darken-1 mb-4 no-break">{{ eventoSelecionado.nome }}</h3>
                      <v-alert
                        text
                        color="info"
                        border="left"
                        class="mb-4"
                        style="border-radius: 8px;"
                        dense
                      >
                        <span class="text-body-2">
                          <strong>Importante:</strong> Nas compras realizadas com a opção de parcelamento, poderão incidir taxas de parcelamento, cujas condições estarão claramente expostas. <strong>As condições de parcelamentos são personalizadas para melhorar a experiência de compra e o Comprador poderá optar por alterar a condição de parcelamento antes de confirmar o pedido</strong>.
                        </span>
                      </v-alert>

                      <div class="mb-4" style="border-radius: 8px;">
                        <v-alert
                          text
                          color="warning"
                          border="left"
                          class="mb-0"
                          style="border-radius: 8px;"
                          dense
                        >
                          <div class="text-body-2" style="white-space: pre-line;" v-html="formatarDescricao(eventoSelecionado.descricaoCompra)"></div>
                        </v-alert>
                      </div>
                      
                      <div v-if="!eventoSelecionado.valorPix && !eventoSelecionado.valorCartao">
                        <h3 class="text-h6 font-weight-bold orange--text text--darken-1 mb-2">
                          Total: {{ (valorTotalCompra * qtdCompra).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) }}
                        </h3>
                      </div>
                      
                      <div v-if="eventoSelecionado.valorPix && eventoSelecionado.valorCartao" class="mb-2">
                        <v-chip 
                          color="orange" 
                          text-color="white" 
                          label 
                          small 
                          class="mr-2 mb-2"  
                        >Opções de pagamento</v-chip>
                        
                        <div class="d-flex justify-center" style="width: 100%; flex-wrap: wrap; gap: 16px;margin-top: 10px;">
                          <v-btn
                            class="payment-option-card mb-2"
                            elevation="2"
                            :ripple="false"
                            outlined
                            style="border-radius: 12px; border: 1px solid rgba(0,0,0,0.05); width: 250px; height: 150px; overflow: hidden; text-transform: none; border-top: 5px solid #28c76f;"
                            v-if="eventoSelecionado.valorPix"
                            @click="preencherInformacoes();prosseguirPagamento('PIX')"
                          >
                            <div class="d-flex flex-column align-center" style="width: 100%">
                              <div class="d-flex align-center mb-2">
                                <img src="../../assets/pix.png" width="18px" class="mr-2" />
                                <div class="text-subtitle-1 font-weight-medium">Pix</div>
                              </div>
                              <div class="text-h6 font-weight-bold green--text text--darken-1 mt-2">
                                {{ calculaValorPix().toLocaleString("pt-BR", { style: "currency", currency: "BRL"}) }}
                              </div>
                            </div>
                          </v-btn>
                          
                          <v-btn
                            class="payment-option-card mb-2"
                            elevation="2"
                            :ripple="false"
                            outlined
                            style="border-radius: 12px; border: 1px solid rgba(0,0,0,0.05); width: 250px; height: 150px; overflow: hidden; text-transform: none; border-top: 5px solid #F57C00;"
                            v-if="eventoSelecionado.valorCartao"
                            @click="preencherInformacoes();prosseguirPagamento('CARTÃO')"
                          >
                            <div class="d-flex flex-column align-center" style="width: 100%">
                              <div class="d-flex align-center mb-2">
                                <v-icon small color="black" class="mr-2">mdi-credit-card</v-icon>
                                <div class="text-subtitle-1 font-weight-medium">Cartão</div>
                              </div>
                              <div class="text-caption grey--text text--darken-1 mt-1">
                                em até {{ eventoSelecionado.quantidadeParcelas }}x de
                              </div>
                              <div class="text-h6 font-weight-bold orange--text text--darken-1 mt-2">
                                {{ calculaParcelas(eventoSelecionado, qtdCompra) }}
                              </div>
                            </div>
                          </v-btn>
                        </div> 
                      </div>
                    </v-card-text>
                  </v-card>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <!-- PÁGINA INSCRIÇÃO ONIBUS -->

        <!-- PÁGINA INSCRIÇÃO VAGAS ONIBUS -->
        <v-row v-if="paginaInscricaoVagasOnibus" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px; padding: 0px">
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12 v-if="!bloqueiaVoltar">
                      <v-btn outlined @click="retornaPaginaPrincipal">
                        <v-icon left>mdi-arrow-left</v-icon>
                        Voltar
                      </v-btn>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg12 v-if="!quantidade.length == 1">
                      <br />
                      <p style="margin-bottom: 0px">Quantidade:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg1 v-if="!quantidade.length == 1">
                      <v-select outlined dense hide-details v-model="qtdCompra" :items="quantidade"
                        @input="verificaCapacidade()"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="margin-top: 20px" v-if="!quantidade.length == 1">
                      <v-divider></v-divider>
                    </v-flex> -->
                  </v-layout>
                </v-container>

                <!-- SEÇÃO 1: RESPONSÁVEL FINANCEIRO -->
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12>
                      <v-card class="mb-4" outlined style="border-radius: 12px; border-color: #00695C; border-width: 2px;">
                        <v-card-title class="px-3 pt-3 pb-2">
                          <v-icon color="#00695C" class="mr-2">mdi-account-tie</v-icon>
                          <span class="text-h6 font-weight-bold" style="color: #00695C;">Dados do Responsável Financeiro</span>
                        </v-card-title>
                        <v-divider class="mx-3"></v-divider>
                        <v-card-text class="pa-3">
                          <v-layout row wrap justify-left>
                            <v-flex xs12 sm12 lg12 v-if="eventoSelecionado.tipoDocumento == 'AMBOS'">
                              <v-radio-group v-model="inscricao[0].tipoDocumento" row @change="limpaSetor(0)">
                                <v-radio label="CPF" value="CPF" color="#00695C"></v-radio>
                                <v-radio label="CNPJ" value="CNPJ" color="#00695C"></v-radio>
                              </v-radio-group>
                              <v-alert v-if="
                                eventoSelecionado.desconto &&
                                inscricao[0].tipoDocumento == 'CNPJ'
                              " dark type="success">
                                Desconto de R$
                                {{ eventoSelecionado.desconto }} aplicado!
                              </v-alert>
                            </v-flex>

                            <v-flex xs12 sm12 lg4 v-if="
                              (eventoSelecionado.tipoDocumento == 'CPF' ||
                              inscricao[0].tipoDocumento == 'CPF')
                            ">
                              <v-text-field
                                label="CPF do Responsável Financeiro*"
                                v-model="inscricao[0].cpf"
                                light
                                color="#00695C"
                                outlined
                                rounded
                                v-mask="'###.###.###-##'"
                                dense
                                hide-details
                                required
                                type="tel" 
                                class="input-field"
                                prepend-inner-icon="mdi-card-account-details"
                                @change="verificaDocumento(inscricao[0].cpf, 0, 'CPF')">
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 lg4 v-if="
                              (eventoSelecionado.tipoDocumento == 'CNPJ' ||
                              inscricao[0].tipoDocumento == 'CNPJ')
                            ">
                              <v-text-field
                                label="CNPJ*"
                                v-model="inscricao[0].cpf"
                                light
                                color="#00695C"
                                outlined
                                rounded
                                v-mask="'##.###.###/####-##'"
                                dense
                                hide-details
                                required
                                type="tel"
                                class="input-field"
                                prepend-inner-icon="mdi-card-account-details"
                                @change="verificaDocumento(inscricao[0].cpf, 0, 'CNPJ')
                              "></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm12 lg8 v-if="
                              (eventoSelecionado.tipoDocumento == 'CPF' ||
                              inscricao[0].tipoDocumento == 'CPF')
                            ">
                              <v-text-field
                                label="Nome do Responsável*"
                                v-model="inscricao[0].nome"
                                light
                                outlined
                                rounded
                                color="#00695C"
                                dense
                                hide-details
                                required
                                class="input-field"
                                prepend-inner-icon="mdi-account"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 lg8 v-if="
                              eventoSelecionado.tipoDocumento == 'CNPJ' ||
                              inscricao[0].tipoDocumento == 'CNPJ'
                            ">
                              <v-text-field
                                label="Razão social*"
                                v-model="inscricao[0].nome"
                                light
                                outlined
                                rounded
                                color="#00695C"
                                dense
                                hide-details
                                required
                                class="input-field"
                                prepend-inner-icon="mdi-account"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>

                <!-- SEÇÃO 2: FILHOS -->
                <v-container fluid grid-list-md v-if="exibeMapa && filhosSelect && filhosSelect.length > 0">
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12>
                      <v-card class="mb-4" outlined style="border-radius: 12px; border-color: #FF9800; border-width: 2px;">
                        <v-card-title class="px-3 pt-3 pb-2">
                          <v-icon color="#FF9800" class="mr-2">mdi-human-male-child</v-icon>
                          <span class="text-h6 font-weight-bold" style="color: #FF9800;">Filhos Participantes</span>
                        </v-card-title>
                        <v-divider class="mx-3"></v-divider>
                        <v-card-text class="pa-3">
                          <p class="mb-3" style="color: #666;">Selecione os filhos que irão participar:</p>
                          <div v-for="filho in filhosSelect" :key="filho" class="mb-3 pa-3" style="background-color: #FFF3E0; border-radius: 8px;">
                            <v-checkbox 
                              hide-details 
                              v-model="inscricao[0].filho" 
                              :label="filho" 
                              :value="filho"
                              @change="onFilhoChange(filho, 0)"
                              color="#FF9800"
                            ></v-checkbox>
                            <v-select
                              v-if="inscricao[0].filho.includes(filho) && !ehEventoOnibus"
                              v-model="tamanhosCamisaGlobal[`0_${filho}`]"
                              :items="tamanhos"
                              label="Tamanho da camisa"
                              dense
                              outlined
                              color="#FF9800"
                              style="margin-left: 40px; margin-top: 10px; max-width: 200px;"
                              hide-details
                            ></v-select>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>

                <!-- SEÇÃO 3: COMPOSIÇÕES (PRODUTOS ADICIONAIS) -->
                <v-container fluid grid-list-md v-if="eventoSelecionado.composicao && eventoSelecionado.composicao.length > 0">
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12>
                      <v-card class="mb-4" outlined style="border-radius: 12px; border-color: #4CAF50; border-width: 2px;">
                        <v-card-title class="px-3 pt-3 pb-2">
                          <v-icon color="#4CAF50" class="mr-2">mdi-cart-plus</v-icon>
                          <span class="text-h6 font-weight-bold" style="color: #4CAF50;">Produtos Adicionais</span>
                        </v-card-title>
                        <v-divider class="mx-3"></v-divider>
                        <v-card-text class="pa-3">
                          <v-row dense :key="x">
                            <v-flex xs12 sm12 lg4 v-for="composicao in eventoSelecionado.composicao" :key="composicao.tipo">
                              <v-card outlined>
                                <v-row class="" style="padding-left: 10px" align="center">
                                  <v-col cols="6" class="text-left">
                                    <div style="font-weight: bold; font-size: 14px">
                                      {{ composicao.tipo }}
                                    </div>
                                    <div>R$ {{ composicao.valor }}</div>
                                  </v-col>

                                  <v-col cols="6">
                                    <v-row justify="end" no-gutters>
                                      <v-btn icon color="red" @click="removeComposicao(composicao)"
                                        :disabled="composicao.quantidade == 0">
                                        <v-icon>mdi-minus-circle</v-icon>
                                      </v-btn>

                                      <v-btn icon>
                                        <p style="margin: 0px">
                                          {{ composicao.quantidade }}
                                        </p>
                                      </v-btn>

                                      <v-btn icon color="green" @click="acrescentaComposicao(composicao)">
                                        <v-icon>mdi-plus-circle</v-icon>
                                      </v-btn>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-flex>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>

                <!-- BOTÃO ADICIONAR PASSAGEIRO -->
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg12>
                      <v-card outlined style="border-radius: 12px; background-color: #F5F5F5;" class="pa-3">
                        <div class="d-flex align-center justify-space-between mb-3">
                          <div>
                            <v-icon color="#2196F3" class="mr-2">mdi-account-multiple</v-icon>
                            <span class="text-subtitle-1 font-weight-medium">Passageiros Extras: {{ qtdCompra - 1 }}</span>
                          </div>
                        </div>
                        <v-btn
                          block
                          color="#2196F3"
                          dark
                          elevation="2"
                          @click="adicionarPassageiro()"
                          :disabled="qtdCompra >= quantidade[quantidade.length - 1]"
                          style="border-radius: 12px;"
                          class="text-none font-weight-medium"
                        >
                          <v-icon left>mdi-account-plus</v-icon>
                          Adicionar Passageiro Extra
                        </v-btn>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>

                <!-- SEÇÃO 4: MAIS PASSAGEIROS -->
                <template v-for="index in qtdCompra">
                  <v-container v-if="index > 1" :key="index" fluid grid-list-md>
                    <v-layout row wrap justify-left>
                      <v-flex xs12 sm12 lg12>
                        <v-card class="mb-4" outlined style="border-radius: 12px; border-color: #2196F3; border-width: 2px;">
                          <v-card-title class="px-3 pt-3 pb-2">
                            <v-icon color="#2196F3" class="mr-2">mdi-account-plus</v-icon>
                            <span class="text-h6 font-weight-bold" style="color: #2196F3;">Passageiro {{ index }}</span>
                            <v-spacer></v-spacer>
                            <v-btn
                              icon
                              color="red"
                              @click="removerPassageiro()"
                              v-if="qtdCompra > 1"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </v-card-title>
                          <v-divider class="mx-3"></v-divider>
                          <v-card-text class="pa-3">
                            <v-layout row wrap justify-left>
                              <v-flex xs12 sm12 lg12 v-if="
                                (eventoSelecionado.tipoDocumento == 'CPF' ||
                                inscricao[index - 1].tipoDocumento == 'CPF')
                              ">
                                <v-text-field
                                  label="Nome do Passageiro*"
                                  v-model="inscricao[index - 1].nome"
                                  light
                                  outlined
                                  rounded
                                  color="#2196F3"
                                  dense
                                  hide-details
                                  required
                                  class="input-field"
                                  prepend-inner-icon="mdi-account"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm12 lg12 v-if="
                                eventoSelecionado.tipoDocumento == 'CNPJ' ||
                                inscricao[index - 1].tipoDocumento == 'CNPJ'
                              ">
                                <v-text-field
                                  label="Nome do Passageiro*"
                                  v-model="inscricao[index - 1].nome"
                                  light
                                  outlined
                                  rounded
                                  color="#2196F3"
                                  dense
                                  hide-details
                                  required
                                  class="input-field"
                                  prepend-inner-icon="mdi-account"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </template>

                <v-flex xs12 sm12 lg12 style="text-align: center" v-if="exibeMapa">
                  <v-flex xs10 sm10 lg6 style="text-align: left; margin: 0px auto">
                    <table style="width: 100%">
                      <tr>
                        <td>
                          <p style="margin: 0px; font-size: 11px"><v-icon small color="#22b42c">mdi-square</v-icon>Livre
                          </p>
                          <p style="margin: 0px; font-size: 11px"><v-icon small
                              color="#ff5050">mdi-square</v-icon>Ocupado</p>
                        </td>
                        <td>
                          <p style="margin: 0px; font-size: 11px"><v-icon small
                              color="#2024b6">mdi-square</v-icon>Selecionado
                            por você</p>
                          <p style="margin: 0px; font-size: 11px"><v-icon small
                              color="#767171">mdi-square</v-icon>Selecionado
                            por outra pessoa</p>
                        </td>
                      </tr>
                    </table>
                  </v-flex>
                  <div ref="matrixContainer" :style="backgroundStyle" style="overflow: hidden; display: inline-block;">
                    <table ref="matrixTable" :key="x">
                      <tr v-for="(row, rowIndex) in matrix" :key="rowIndex">
                        <td v-for="(cell, colIndex) in row" :key="colIndex"
                          @click="cell.status != 'OCUPADO' || !cell.bloqueado || cell.active ? cellClicked(rowIndex, colIndex) : ''"
                          :data-cell-number="cell.localizacao" style="position: relative;">
                          <img style="cursor: pointer" v-if="cell.status == 'LIVRE' && cell.active"
                            src="../../assets/greentable.webp" width="10px" />
                          <img style="cursor: pointer"
                            v-if="cell.status == 'SELECIONADO' && !cell.bloqueado && cell.active"
                            src="../../assets/bluetable.webp" width="10px" />
                          <img style="cursor: pointer"
                            v-if="cell.status == 'SELECIONADO' && cell.bloqueado && cell.active"
                            src="../../assets/graytable.webp" width="10px" />
                          <img style="cursor: pointer" v-if="cell.status == 'OCUPADO' && cell.active"
                            src="../../assets/redtable.webp" width="10px" />
                          <p
                            style="font-size: 3px; margin: 0px; color: white; cursor: pointer; position: absolute; top: 53%; left: 50%; transform: translate(-50%, -50%); z-index: 1">
                            {{ cell.vaga }}</p>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <p style="background-color: black; color: white; font-weight: bold; padding: 2px; line-height: 1.0rem"
                    v-if="inscricao[0].vagas && inscricao[0].vagas.length > 0">
                    ATENÇÃO: Ao selecionar uma mesa, você terá 15 minutos para realizar o pagamento. Após esse prazo, a
                    vaga
                    será liberada para outra pessoa.
                  </p>
                </v-flex>

                <v-container style="padding: 0px 12px 0px 12px">
                  <v-flex xs12 sm12 lg12>
                    <v-checkbox v-model="aceiteLgpd" style="margin-top: 0px">
                      <template v-slot:label>
                        <div>
                          Concordo com as
                          <a target="_blank"
                            :href="urlPoliticaPrivacidade"
                            @click.stop>políticas de privacidade, cancelamento e tratamento de dados
                            pessoais</a>
                        </div>
                      </template>
                    </v-checkbox>
                  </v-flex>
                </v-container>
                <v-container style="padding: 0px 12px 0px 12px" v-if="eventoSelecionado.urlImgObs">
                  <v-flex xs12 sm12 lg12 style="text-align: center">
                    <img :src="eventoSelecionado.urlImgObs" width="100%" style="max-width: 300px" />
                  </v-flex>
                </v-container>
                <v-container style="padding: 0px 12px 0px 12px">
                  <v-flex xs12 sm12 lg12 style="margin: 5px 0px 5px 0px">              
                    <v-alert
                      text
                      color="info"
                      border="left"
                      class="mb-4"
                      style="border-radius: 8px;"
                      dense
                    >
                      <span class="text-body-2">
                        <strong>Importante:</strong> Nas compras realizadas com a opção de parcelamento, poderão incidir taxas de parcelamento, cujas condições estarão claramente expostas. <strong>As condições de parcelamentos são personalizadas para melhorar a experiência de compra e o Comprador poderá optar por alterar a condição de parcelamento antes de confirmar o pedido</strong>.
                      </span>
                    </v-alert>

                    <div class="mb-4" style="border-radius: 8px;">
                      <v-alert
                        text
                        color="warning"
                        border="left"
                        class="mb-0"
                        style="border-radius: 8px;"
                        dense
                      >
                        <div class="text-body-2" style="white-space: pre-line;" v-html="formatarDescricao(eventoSelecionado.descricaoCompra)"></div>
                      </v-alert>
                    </div>
                  </v-flex>
                  
                  <v-flex xs12 sm12 lg12 style="margin: 5px 0px 5px 0px">
                    <h2>Detalhes da Compra:</h2>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 style="margin: 5px 0px 5px 0px">
                    <h3 style="color: orange" class="no-break">{{ eventoSelecionado.nome }}</h3>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 v-if="inscricao[0].vagas && inscricao[0].vagas.length > 0">
                    <h3 style="color: orange">
                      Mesas selecionadas: {{ vagasSelecionadas }}
                    </h3>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 v-if="!eventoSelecionado.valorPix && !eventoSelecionado.valorCartao">
                    <h3 style="color: orange">
                      Total: {{ valorTotalCompra.toLocaleString("pt-BR", { style: "currency", currency: "BRL", }) }}
                    </h3>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 v-if="eventoSelecionado.valorPix && eventoSelecionado.valorCartao">
                    <h3 style="color: orange" v-if="eventoSelecionado.valorPix && inscricao[0].vagas && inscricao[0].vagas.length > 0">
                      Pix: {{ (parseFloat(this.eventoSelecionado.valorPix.replace(",", ".")) * this.inscricao[0].vagas.length).toLocaleString("pt-BR", { style: "currency", currency: "BRL"}) }}
                    </h3>
                    <h3 style="color: orange" v-if="eventoSelecionado.valorCartao && inscricao[0].vagas && inscricao[0].vagas.length > 0">
                      Cartão: em até {{ eventoSelecionado.quantidadeParcelas }}x de {{ calculaParcelas(eventoSelecionado, inscricao[0].vagas.length) }}
                    </h3>
                  </v-flex>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg4 v-if="eventoSelecionado.valorCartao">
                      <v-btn depressed block outlined style="border-radius: 7px" large
                        @click="preencherInformacoes();prosseguirPagamento('CARTÃO')">
                        <img style="margin-right: 5px" src="../../assets/credit-card.png" width="25px" />
                        Cartão
                      </v-btn>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg4>
                      <v-btn depressed block outlined style="border-radius: 7px;" large @click="prosseguirPagamento('BOLETO')">
                        <img style="margin-right: 5px" src="../../assets/barcode.png" width="30px">
                        Boleto
                      </v-btn> 
                    </v-flex> -->
                    <v-flex xs12 sm12 lg4 v-if="eventoSelecionado.valorPix">
                      <v-btn depressed block outlined style="border-radius: 7px" large
                        @click="preencherInformacoes();prosseguirPagamento('PIX')">
                        <img style="margin-right: 5px" src="../../assets/pix.png" width="20px" />
                        Pix
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="text-align: center">
                      <img style="margin-right: 5px" src="../../assets/site-seguro-blindado.png" width="250px" />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- PÁGINA INSCRIÇÃO VAGAS ONIBUS -->
    <!-- Fim formulario de onibus -->

        <br />
        <div class="login-title">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <img src="../../assets/logoAICheckinIntelite.png" width="180px"/>
          </a>
        </div>

       <v-dialog v-model="dialogoIngressoIndividual" persistent max-width="600px">
          <v-card style="border-radius: 12px; overflow: hidden; box-shadow: 0 8px 20px rgba(0,0,0,0.1);">
            <div style="background-color: #2979FF; padding: 16px; text-align: center; border-radius: 10px 10px 0 0;">
              <div style="display: flex; align-items: center; justify-content: center;">
                <v-icon color="white" class="mr-2" size="24">mdi-ticket-confirmation</v-icon>
                <span style="color: white; font-weight: 600; font-size: 18px; letter-spacing: 0.5px;">Ingresso Digital</span>
              </div>
            </div>
            <v-card-text style="padding: 24px 20px; background-color: #FFFFFF;">
              <div style="text-align: center; margin-bottom: 16px;">
                <h3 style="margin: 0 0 4px 0; color: #1E3A8A; font-size: 20px; font-weight: 600;">{{ inscricaoLocalizada.nome }}</h3>
              </div>
              
              <div style="display: flex; justify-content: center; margin: 20px 0;">
                <div style="border: 1px solid #E0E7FF; padding: 12px; background-color: #FFFFFF; border-radius: 12px; display: inline-block; box-shadow: 0 2px 10px rgba(0,0,0,0.05);">
                  <div style="display: flex; flex-direction: column; align-items: center;">
                    <enhanced-qr-code 
                      :value="inscricaoLocalizada.cod_incricao" 
                      :size="150"
                      :margin="1"
                      :borderWidth="8"
                      borderColor="#FFFFFF"
                      :borderRadius="8"
                    ></enhanced-qr-code>
                    <p style="margin: 8px 0 0 0; font-size: 13px; font-weight: 500; color: #4B5563; text-align: center;">{{ inscricaoLocalizada.cod_incricao }}</p>
                  </div>
                </div>
              </div>
              
              <div v-if="inscricaoLocalizada.setor" style="margin-top: 20px; background-color: #F8FAFC; border-radius: 10px; padding: 16px; border-left: 4px solid #2979FF;">
                <div style="font-weight: 500; color: #4B5563; font-size: 14px; margin-bottom: 10px; display: flex; align-items: center;">
                  <v-icon style="color: #2979FF;" class="mr-2">mdi-ticket-confirmation</v-icon>
                  Setor
                </div>
                <div style="display: flex; align-items: center; padding: 0 0 0 4px;">
                  <div :style="'width: 16px; height: 16px; border-radius: 50%; background-color: ' + inscricaoLocalizada.corSetor + '; margin-right: 10px; box-shadow: 0 1px 4px rgba(0,0,0,0.1);'"></div>
                  <span style="font-size: 18px; color: #1F2937; font-weight: 600;">{{ inscricaoLocalizada.setor }}</span>
                </div>
              </div>
              
              <v-divider style="margin: 20px 0; background-color: #E5E7EB;"></v-divider>
              
              <div>
                <div style="display: flex; margin: 10px 0;">
                  <v-icon style="margin: 2px 12px 0 0; color: #6B7280;">mdi-calendar</v-icon>
                  <div style="flex: 1; font-size: 15px; color: #374151;">{{ inscricaoLocalizada.eventoNome }}</div>
                </div>
                
                <div style="display: flex; margin: 10px 0;">
                  <v-icon style="margin: 2px 12px 0 0; color: #6B7280;">mdi-map-marker</v-icon>
                  <div style="flex: 1; font-size: 15px; color: #374151;">
                    {{ inscricaoLocalizada.eventoLocal }}
                    <span v-if="inscricaoLocalizada.eventoLocalizacao">
                      (<a :href="inscricaoLocalizada.eventoLocalizacao" target="_blank" style="color: #2979FF; font-weight: 500;">Ver no mapa</a>)
                    </span>
                  </div>
                </div>

                <div style="display: flex; margin: 10px 0;" v-if="inscricaoLocalizada.vagas && inscricaoLocalizada.vagas.length > 0">
                  <v-icon style="margin: 2px 12px 0 0; color: #6B7280;">mdi-seat</v-icon>
                  <div style="flex: 1; font-size: 15px; color: #374151;">
                    {{ formatarSetor(inscricaoLocalizada.vagas) }}
                  </div>
                </div>
              </div>
              
              <v-divider style="margin: 20px 0; background-color: #E5E7EB;"></v-divider>
              
              <div style="display: flex; align-items: center; margin: 10px 0; padding: 12px; background-color: #F0F9FF; border-radius: 8px; border-left: 4px solid #2979FF;">
                <v-icon color="#2979FF" class="mr-3" size="22">mdi-check-circle</v-icon>
                <span style="font-weight: 600; color: #1E3A8A;">Pagamento realizado com sucesso!</span>
              </div>
              
              <p style="font-size: 13px; color: #6B7280; margin: 12px 0; text-align: left;">
                Guarde este comprovante para sua referência no dia do evento
              </p>
            </v-card-text>
            <v-card-actions style="padding: 0 20px 20px 20px; background-color: #FFFFFF;" v-if="inscricaoLocalizada.eventoUsaCartaoConsumo">
              <v-btn style="border-radius: 8px; text-transform: none; height: 44px; font-weight: 500; letter-spacing: 0.3px;" dark depressed block color="#4B5563"
                :href="'https://aiconsumer.intelite.com.br?cod=' + inscricaoLocalizada.cod_incricao">
                <v-icon left>mdi-credit-card-outline</v-icon>
                Cartão Consumo
              </v-btn>
            </v-card-actions>
            <v-card-actions style="padding: 0 20px 20px 20px; background-color: #FFFFFF;">
              <v-btn style="border-radius: 8px; text-transform: none; height: 44px; font-weight: 500; letter-spacing: 0.3px;" dark depressed block color="#1565C0"
                @click="dialogoIngressoIndividual = false">
                <v-icon left>mdi-close-circle-outline</v-icon>
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoListaIngresso" persistent max-width="600px" scrollable>
          <v-card style="border-radius: 12px; overflow: hidden; box-shadow: 0 8px 20px rgba(0,0,0,0.1);">
            <div style="background-color: #2979FF; padding: 16px; text-align: center; border-radius: 10px 10px 0 0;">
              <div style="display: flex; align-items: center; justify-content: center;">
                <v-icon color="white" class="mr-2" size="24">mdi-ticket-confirmation</v-icon>
                <span style="color: white; font-weight: 600; font-size: 18px; letter-spacing: 0.5px;">Ingresso Digital</span>
              </div>
            </div>
            <v-card-text style="padding: 0px 16px; background-color: #FFFFFF;">
              <v-container style="padding: 16px 0px;">
                <v-row style="margin: 10px 0; background-color: #F8FAFC; border-radius: 8px; padding: 12px;">
                  <v-col cols="12" style="padding: 0px">
                    <p style="margin: 0px; font-weight: 600; color: #1E3A8A; font-size: 16px;" class="no-break">{{ eventoSelecionado.nome }}</p>
                    <div style="display: flex; align-items: center; margin-top: 4px;">
                      <v-icon size="18" color="#6B7280" class="mr-2">mdi-map-marker</v-icon>
                      <span style="color: #4B5563; font-size: 14px;">{{ eventoSelecionado.local }} 
                        <span v-if="eventoSelecionado.localizacao">
                          (<a :href="eventoSelecionado.localizacao" target="_blank" style="color: #2979FF; font-weight: 500;">Ver no mapa</a>)
                        </span>
                      </span>
                    </div>
                  </v-col>
                </v-row>
                
                <v-row align="center" justify="center" v-for="ingresso in inscricao" :key="ingresso.nome" 
                  style="border: 1px solid #E0E7FF; margin: 16px 0; border-radius: 10px; background-color: white; box-shadow: 0 2px 10px rgba(0,0,0,0.03);">
                  <v-col cols="12" lg="4" style="padding: 10px;">
                    <v-card outlined style="padding: 10px; border-radius: 8px; border-color: #E0E7FF; box-shadow: none;">
                      <enhanced-qr-code 
                        :value="ingresso.cod_incricao" 
                        :size="90"
                        :margin="1"
                        :borderWidth="4"
                        borderColor="#FFFFFF"
                        :borderRadius="4"
                      ></enhanced-qr-code>
                      <p style="margin: 8px 0 0 0; font-size: 11px; font-weight: 500; color: #4B5563; text-align: center;">{{ ingresso.cod_incricao }}</p>
                    </v-card>
                  </v-col>
                  <v-col cols="12" lg="8" style="padding: 10px 16px;">
                    <p style="margin: 0px 0 6px 0; font-weight: 600; font-size: 16px; color: #1F2937;">{{ ingresso.nome }}</p>
                    <p style="margin: 0px 0 12px 0; color: #6B7280; font-size: 14px;">{{ ingresso.cpf }}</p>
                    <!-- <div style="display: flex; align-items: center; margin: 8px 0 14px 0; background-color: #F8FAFC; padding: 8px 10px; border-radius: 6px; border-left: 3px solid #2979FF;">
                      <div :style="'width: 12px; height: 12px; border-radius: 50%; background-color: ' + ingresso.corSetor + '; margin-right: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);'"></div>
                      <span style="font-size: 14px; color: #374151; font-weight: 500;">
                        <span style="color: #6B7280;">Setor:</span> {{ ingresso.setor }}
                      </span>
                    </div> -->
                  </v-col>
                </v-row>
                
                <v-divider style="margin: 20px 0; background-color: #E5E7EB;"></v-divider>
              
                <div style="display: flex; align-items: center; margin: 10px 0; padding: 12px; background-color: #F0F9FF; border-radius: 8px; border-left: 4px solid #2979FF;">
                  <v-icon color="#2979FF" class="mr-3" size="22">mdi-check-circle</v-icon>
                  <span style="font-weight: 600; color: #1E3A8A;">Pagamento realizado com sucesso!</span>
                </div>
              
                <p style="font-size: 13px; color: #6B7280; margin: 12px 0; text-align: left;">
                  Guarde este comprovante para sua referência no dia do evento
                </p>
              </v-container>
            </v-card-text>
            <v-card-actions style="padding: 0 16px 16px 16px; background-color: #FFFFFF;">
              <v-btn style="border-radius: 8px; text-transform: none; height: 44px; font-weight: 500; letter-spacing: 0.3px;" dark depressed block color="#1565C0" 
                @click="dialogoListaIngresso = false">
                <v-icon left>mdi-close-circle-outline</v-icon>
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="confirmacaoBoleto" persistent max-width="600px">
          <v-card style="border-radius: 10px">
            <v-card-title style="justify-content: center; padding: 8px">
              <span class="texto">{{ msgResultado }}</span>
            </v-card-title>
            <v-card-text style="text-align: center; padding: 0 24px 0">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="color: #00695c">
                      {{ inscricao.nome }}
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="color: #ff0000">
                      Fique atento! Após um dia útil, será enviada uma mensagem
                      no WhatsApp do número informado com a confirmação de
                      pagamento e o seu ingresso digital.
                    </p> 
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto">{{ cultoSelecionado }}</p>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" style="padding: 2px">
                    <v-btn style="border-radius: 7px" dark depressed @click="abreBoleto">Visualizar Boleto</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="border-radius: 7px" dark depressed block color="#7b4f44" @click="closeDialog">fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="confirmacaoEmMaos" persistent max-width="600px">
          <v-card style="border-radius: 10px">
            <v-card-title style="justify-content: center; padding: 8px">
              <span class="texto">{{ msgResultado }}</span>
            </v-card-title>
            <v-card-text style="text-align: center; padding: 0 24px 0">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="color: #00695c">
                      {{ inscricao.nome }}
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="color: #ff0000">
                      Sua inscrição foi pré-aprovada. Para confirmar, o
                      pagamento deve ser feito em mãos.
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto">{{ cultoSelecionado }}</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="border-radius: 7px" dark depressed block color="#7b4f44" @click="closeDialog">fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogCancelamento" persistent max-width="600px">
          <v-card style="border-radius: 10px">
            <v-card-title style="justify-content: center; padding: 8px">
              <span class="texto">Solicitação de Cancelamento</span>
            </v-card-title>
            <v-card-text style="text-align: center; padding: 0 24px 0">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="color: #00695c">
                      {{ inscricao.nome }}
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="color: #00695c">
                      CPF : {{ inscricao.cpf }}
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto">{{ cultoSelecionado }}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="background-color: #d32f2f; color: white">
                      Confirme a sua solicitação de cancelamento
                    </p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="border-radius: 7px" dark depressed block color="#00695C"
                @click="realizarCancelamento">confirmar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="pagamentoPix" persistent max-width="600px">
          <v-card style="border-radius: 10px">
            <v-card-title style="justify-content: center; padding: 4px; position: relative">
              <span class="texto" style="color: #00695c; font-weight: bold">{{ msgResultado }}</span>
              <v-btn
                icon
                color="#00695c"
                style="position: absolute; right: 8px; top: 8px"
                @click="closeDialog"
                title="Fechar"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text style="text-align: center; padding: 0 24px 0">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" style="padding: 10px">
                    <p class="texto" style="text-align: left; font-weight: bold;">
                      Copie este código para pagar <b style="color: orange">R$ {{(parseFloat(valorTotalCompra) + parseFloat(valorAcrescimo.acrescimoPix)).toFixed(2).replace(".", ",")}}</b>:
                    </p>
                    <ol style="text-align: left; padding-left: 16px; margin: 0;">
                      <li>Acesse seu app de pagamentos.</li>
                      <li>Escolha pagar via Pix.</li>
                      <li>Cole o seguinte código:</li>
                    </ol>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 1px">
                    <v-card flat class="d-flex justify-center pa-4" color="white">
                      <qrcode-vue
                          v-if="exibirQRCode && empresa.gatewayPagamentoPix == 'SICOOB'"
                          :value="qrCode64"
                          :size="200"
                          level="H"
                          bg-color="white"
                      ></qrcode-vue>
                      <img
                        v-else-if="exibirQRCode"
                        :src="qrCode64"
                        width="100%"
                        style="max-width: 300px"
                      />
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="12" md="12" style="padding: 10px 0px 10px 0px">
                    <v-text-field
                      v-model="chaveCopiaeCola"
                      label="Chave Pix Copia e Cola"
                      id="chavePix"
                      outlined
                      readonly
                      dense
                      disable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" style="padding-top: 0;">
                    <v-btn
                      color="#00695C"
                      dark
                      depressed
                      @click="doCopy('chavePix')"
                      style="border-radius: 10px; font-weight: bold;"
                    >
                      Copiar código
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" style="padding-top: 0;">
                    <v-btn
                      text
                      color="#00695C"
                      dark
                      @click="exibirQRCode = !exibirQRCode"
                      style="border-radius: 10px; font-size: 14px; "
                    >
                      {{ exibirQRCode ? 'Ocultar QR Code' : 'Exibir QR Code' }}
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" style="padding-top: 0;">
                    <v-btn
                      outlined
                      color="#00695C"
                      @click="closeDialog"
                      style="border-radius: 10px; font-weight: bold;"
                    >
                      Fechar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoToken" persistent max-width="400px">
          <v-card style="border-radius: 10px">
            <v-card-text style="text-align: center; padding: 0 24px 0">
              <v-container>
                <p>
                  <b>Enviamos um token para seu WhatsApp.<br />Por favor,
                    informe-o abaixo para ter acesso ao seu ingresso digital:</b>
                </p>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="4" style="padding: 1px">
                    <v-text-field light v-mask="'####'" v-model="token" label="TOKEN" type="tel" single-line outlined
                      color="#00695C" dense hide-details required></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-container fluid grid-list-md>
                <v-spacer></v-spacer>
                <v-btn style="border-radius: 7px" dark block depressed color="#00695C"
                  @click="confirmaToken">Confirmar</v-btn>
              </v-container>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoInscricaoNaoLocalizada" persistent max-width="400px">
          <v-card>
            <v-card-text style="text-align: center; padding: 0 24px 0">
              <v-icon color="orange" size="100">mdi-alert</v-icon>
              <p style="font-weight: bold; line-height: 1.2rem">Responsável Financeiro não localizado para o CPF
                informado.
                Favor entrar em contato com a secretaria da escola.</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="border-radius: 7px" dark block depressed color="red" @click="reloadPage">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ textoSnackbar }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">Fechar</v-btn>
      </template>
    </v-snackbar>
    <loading :active.sync="isLoading" :can-cancel="false" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref="chamaSnackbar" />
  </div>
</template>

<script>
// Import component
import Loading from "vue-loading-overlay";
/* import vueCard from 'vue-card-express'; */
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import CpfValidate from "../../componentes/validators/rules/cpf";
import CnpjValidate from "../../componentes/validators/rules/cnpj";
import QrcodeVue from "qrcode.vue";
import { baseApiUrl /* modelBoleto */ } from "@/global";
import Snackbar from "../../componentes/snackbar.vue";
import { mapState } from "vuex";
import moment from "moment";
import axios from "axios";
import EnhancedQrCode from '../../componentes/EnhancedQrCode.vue'

export default {
  components: {
    Snackbar,
    QrcodeVue,
    Loading,
    EnhancedQrCode
  },
  name: "Auth",

  computed: mapState({
    usuarioLogado: (state) => state.isMenuVisible,

    backgroundStyle() {
      return {
        backgroundImage: `url('${this.eventoSelecionado.urlMapa}')`,
        backgroundSize: "contain",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
      };
    },

    numbers() {
      return Array.from({ length: 50 }, (_, index) => index + 1);
    },

    ehEventoOnibus() {
      return this.eventoSelecionado && this.eventoSelecionado.onibus === true;
    },
  }),

  data: function () {
    return {
      vagas: [],
      valorParcela: 0,
      timeout: 4000,
      snackbar: false,
      textoSnackbar: "",
      pagamentoPix: false,
      localPagamento: "",
      eventoId: "",
      cpf: "",
      email: "",
      qtdCompra: 1,
      pagePrincipal: true,
      pagePagamento: false,
      pageConsulta: false,
      PageIncricao: false,
      paginaInscricaoVagas: false,
      dialogoInscricaoNaoLocalizada: false,
      maskCartao: "#### #### #### ####",
      user: {},
      cultoSelecionado: "",
      inscricao: [
        {
          cod_incricao: "",
          nome: "",
          cpf: "",
          sexo: "",
          telefone: "",
          email: "",
          eventoId: "",
          lote: 0,
          tipo: "VIRTUAL",
          tipoDocumento: "",
          valorPago: "",
          vagas: [],
          qtdSenhasExtra: 1,
          idade: "",
        },
      ],
      inscricaoDefault: [
        {
          cod_incricao: "",
          nome: "",
          cpf: "",
          sexo: "",
          telefone: "",
          email: "",
          eventoId: "",
          lote: 0,
          tipo: "VIRTUAL",
          tipoDocumento: "",
          valorPago: "",
          vagas: [],
          qtdSenhasExtra: 1,
          idade: "",
        },
      ],
      pagamento: {
        valor: 0,
        cartaoNumero: "",
        cvv: "",
        mesVencimento: "",
        anoVencimento: "",
        nomeTitular: "",
        cpfTitular: "",
        bandeira: "",
        cep: "",
        numero: "",
        email: "",
      },
      dialogCancelamento: false,
      dialogoIngressoIndividual: false,
      confirmacaoBoleto: false,
      confirmacaoEmMaos: false,
      qtdInscritos: 0,
      capacidadeEvento: 0,
      reserva: 0,
      sexo: ["MASCULINO", "FEMININO"],
      tipo: ["MEMBRO", "VISITANTE"],
      tamanhos: ["04 anos","06 anos","08 anos","10 anos","12 anos","PP", "P", "M", "G", "GG", "XGG"],
      tamanhosCamisa: ["PP", "P", "M", "G", "GG", "XGG"],
      torcidas: ["Torcida Egito", "Torcida Grécia", "Torcida Mista"],
      tamanhosCamisaGlobal: {}, // Global variable to store shirt sizes for all children
      quantidade: [],
      mesesVencimento: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
      anosVencimento: [],
      eventos: [],
      condicoes: [
        { value: true, text: "SIM" },
        { value: false, text: "NÃO" },
      ],
      necessidades: ["AUDITIVA", "CADEIRANTE", "VISUAL"],
      bandeiras: [
        { value: "DINERS", text: "DINERS" },
        { value: "ELO", text: "ELO" },
        { value: "HIPERCARD", text: "HIPERCARD" },
        { value: "MASTERCARD", text: "MASTERCARD" },
        { value: "VISA", text: "VISA" },
      ],
      parcelas: [],
      modelCartao: {
        id: "",
        valor: "",
        tipoTransacao: "A_VISTA",
        quantidadeParcelas: 1,
        comprador: {
          id: "",
          documentoNumero: "",
          documentoTipo: "1",
          email: "",
          nomeCompleto: "",
          primeiroNome: "",
          ultimoNome: "",
          enderecoLogradouro: "",
          enderecoNumero: "",
          enderecoComplemento: "",
          enderecoCep: "",
          enderecoBairro: "",
          enderecoCidade: "",
          enderecoEstado: "",
        },
        cartao: {
          numero: "",
          codigoSeguranca: "",
          nome: "",
          expiracaoAno: "",
          expiracaoMes: "",
          bandeira: "",
        },
      },
      cobrancaAsaas: {
        customer: "",
        billingType: "",
        value: 0,
        dueDate: "",
        description: "",
      },
      cobrancaAsaasCartao: {
        customer: "",
        billingType: "",
        value: 0,
        dueDate: "",
        description: "",
        remoteIp: "",
        creditCard: {
          holderName: "",
          number: "",
          expiryMonth: "",
          expiryYear: "",
          ccv: "",
        },
        creditCardHolderInfo: {
          name: "",
          email: "",
          cpfCnpj: "",
          postalCode: "",
          addressNumber: "",
          phone: "",
        },
      },
      clienteAsaas: {
        name: "",
        cpfCnpj: "",
        email: "",
        mobilePhone: "",
        postalCode: "",
        addressNumber: "",
        notificationDisabled: true,
      },
      tokenAsaas:
        "49c4e67d3ee1f8dc149532590589285abc97c9b10a8c3759e9b6f63e383a76d3",
      qrCode64: "",
      chaveCopiaeCola: "",
      empresa: [],
      isLoading: false,
      fullPage: true,
      jaExiste: false,
      codigoExistente: "",
      msgResultado: "",
      idInscricao: [],
      codigoAcesso: "",
      informaMunicipio: true,
      idClienteAsaas: "",
      valorAcrescimo: {
        acrescimoBoleto: 0.0,
        acrescimoPix: 0.0,
      },
      qtdInscMasculinas: 0,
      qtdInscFemininas: 0,
      vagasMasculinas: 0,
      vagasFemininas: 0,
      textoParcela: "",
      paginaInscricaoGrupo: false,
      paginaInscricaoGrupoTorcedor: false,
      paginaInscricaoVagasTorcedor: false,
      paginaInscricaoOnibus: false,
      paginaInscricaoVagasOnibus: false,
      caravana: false,
      inscricaoLocalizada: {
        cod_incricao: "",
        nome: "",
        email: "",
        sexo: "",
        telefone: "",
        eventoNome: "",
        eventoLocal: "",
        eventoLocalizacao: "",
        usaCartaoConsumo: "",
        setor: "",
        corSetor: "",
      },
      linkBoleto: "",
      consultaCPF: false,
      dialogoToken: false,
      token: "",
      divulgador: [],
      indicacao: false,
      possuiCupom: false,
      cupomDesconto: "",
      cupomAplicado: false,
      loader: null,
      loadingCupom: false,
      dadosCupom: [],
      qtdParcelas: null,
      usaCupomDesconto: null,
      tipoIngresso: "",
      eventoSelecionado: [],
      usaCartaoConsumo: null,
      bloqueiaVoltar: false,
      estados: [],
      municipios: [],
      tiposDocumento: ["CPF", "CNPJ"],
      valorTotalCompra: 0,
      aceiteLgpd: false,
      dialogoListaIngresso: false,
      clickedCells: [],
      exibeMapa: false,
      exibeNumero: false,
      x: 0,
      matrix: [],
      vagasSelecionadas: "",
      qtdIngressosCompra: 0,
      exibirQRCode: false,
      filhosSelect: [],
      urlPoliticaPrivacidade: "",
      dictionary: {
        custom: {
          nomeCartao: {
            required: () => "Informe o nome",
          },
          numCartao: {
            required: () => "Informe o número do cartão de crédito",
          },
          cpftitular: {
            required: () => "Informe o número do cartão de crédito",
          },
          codCartao: {
            required: () => "Informe o código de segurança",
          },
          expiraCartaoMes: {
            required: () => "Informe o mês de validade do cartão",
          },
          expiraCartaoAno: {
            required: () => "Informe o ano de validade do cartão",
          },
          dateOfBirth: {
            required: () => "Informe a Data de Nascimento",
            date_format: () => "Informe uma data válida (dd/mm/aaaa)",
          },
        },
      },
      descricaoExpandida: {},
    };
  },

  mounted: async function () {
    await this.carregaDados();
    await this.pegaParametrosUrl();
    this.$validator.localize("pt", this.dictionary);
    this.buscaUfs();
    this.buscaMunicipios();
  },

  watch: {
    dialogoIngressoIndividual(val) {
      if (val == false) {
        setTimeout(() => {
          let keys = Object.keys(this.inscricaoLocalizada);

          for (let i = 0; i < keys.length; i++) {
            this.inscricaoLocalizada[keys[i]] = "";
          }
        }, 300);
      }
    },

    dialogoListaIngresso(val) {
      if (val == false) {
        this.inscricao = Object.assign({}, this.inscricaoDefault);
        this.pagePrincipal = true;
        this.paginaInscricaoGrupo = false;
        this.pagePagamento = false;
        this.idInscricao = [];
      }
    },
  },

  methods: {
    formatarDescricao(texto) {
      if (!texto) return '';
      // Converte **texto** em <strong>texto</strong>
      return texto.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    },
    
    adicionarPassageiro() {
      this.qtdCompra++;
      this.verificaCapacidade();
    },
    
    removerPassageiro() {
      if (this.qtdCompra > 1) {
        this.qtdCompra--;
        this.verificaCapacidade();
      }
    },

    onFilhoChange(filho, index) {
      // Se o filho foi desmarcado, remove o tamanho da camisa do global
      if (!this.inscricao[index].filho.includes(filho)) {
        const key = `${index}_${filho}`;
        this.$delete(this.tamanhosCamisaGlobal, key);
      }
    },

    retornaMunicipios(uf) {
      return this.municipios.filter(
        (municipios) => municipios["UF-sigla"] === uf
      );
    },

    criarQuantidades(minimo, maximo) {
      this.quantidade = [];

      for (let i = 0; i < 51; i++) {
        if (i >= minimo && i <= maximo) {
          this.quantidade.push(i);
        }
      }
    },

    criarAnosVencimento() {
      this.anosVencimento = [];
      let anoAtual = new Date().toISOString().substring(0, 4);
      let anoFinal = parseInt(new Date().toISOString().substring(0, 4)) + 14;

      while (anoAtual <= anoFinal) {
        this.anosVencimento.push((anoAtual++).toString());
      }
    },

    doCopy(id) {
      try {
        let copyText = document.getElementById(id);
        copyText.select();
        copyText.setSelectionRange(0, 99999); /* Para dispositivos móveis */
        document.execCommand("copy");
        this.snackbar = true;
        this.textoSnackbar = "Chave copiada para a área de transferência!";
      } catch (error) {
        this.snackbar = true;
        this.textoSnackbar =
          "Problema ao copiar chave para a área de transferência";
      }
    },

    reloadPage() {
      window.location.reload();
    },

    async carregaDados() {
      this.eventos = [];
      this.isLoading = true;

      await axios
        .post(baseApiUrl + "eventos/eventosFuturos", {
          empresaId: "663e5de71eecf94fda39b52c",
        })
        .then(async (response) => {
          if (response.data.eventos.lotes) {
            for (let i = 0; i < response.data.eventos.length; i++) {
              for (let j = 0; j < response.data.eventos[i].lotes.length; j++) {
                if (response.data.eventos[i].quantidadeInscricoes <= response.data.eventos[i].lotes[j].quantidade) {
                  response.data.eventos[i].lote = response.data.eventos[i].lotes[j].lote
                  response.data.eventos[i].valorPix = response.data.eventos[i].lotes[j].valorPix
                  response.data.eventos[i].valorCartao = response.data.eventos[i].lotes[j].valorCartao
                  response.data.eventos[i].acrescimoPix = response.data.eventos[i].lotes[j].acrescimoPix
                  response.data.eventos[i].acrescimoCartao1 = response.data.eventos[i].lotes[j].acrescimoCartao1
                  response.data.eventos[i].acrescimoCartao2 = response.data.eventos[i].lotes[j].acrescimoCartao2
                  response.data.eventos[i].acrescimoCartao3 = response.data.eventos[i].lotes[j].acrescimoCartao3
                  response.data.eventos[i].quantidadeParcelas = response.data.eventos[i].lotes[j].quantidadeParcelas
                  break
                }
              }
            }
          }

          this.eventos = response.data.eventos;
          this.empresa = response.data.empresa;
          this.urlPoliticaPrivacidade = response.data.urlPoliticaPrivacidade;
          this.isLoading = false;
        });
    },

    calculaValorTotalCartao(evento) {
      let valorTotal;

      if (this.inscricao.length < 15) {
        valorTotal = parseFloat(
          evento.valorCartao.replace(",", ".") * this.inscricao.length
        );
        return parseFloat(valorTotal);
      } else {
        valorTotal = parseFloat(
          evento.valorCartao.replace(",", ".") * this.inscricao.length
        );
        return parseFloat(parseFloat(valorTotal - 55));
      }
    },

    calculaParcelas(evento, qtdCompra) {
      let valorTotal;

      if (this.eventoSelecionado.permitePais === true){
        valorTotal = parseFloat(evento.valorCartao.replace(",", ".")) + parseFloat(evento["acrescimoCartao" + evento.quantidadeParcelas].replace(",", "."));
        valorTotal = valorTotal * ((this.qtdCompra - 1) + this.inscricao[0].filho.length);
        valorTotal = parseFloat(valorTotal / evento.quantidadeParcelas).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
      } else if (qtdCompra) {
        valorTotal = parseFloat(evento.valorCartao.replace(",", ".")) + parseFloat(evento["acrescimoCartao" + evento.quantidadeParcelas].replace(",", "."));
        valorTotal = valorTotal * qtdCompra;
        valorTotal = parseFloat(valorTotal / evento.quantidadeParcelas).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
      }
      else {
        valorTotal = parseFloat(evento.valorCartao.replace(",", ".")) + parseFloat(evento["acrescimoCartao" + evento.quantidadeParcelas].replace(",", "."));
        valorTotal = parseFloat(valorTotal / evento.quantidadeParcelas).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
      }
      
      return valorTotal;
    },

    criarParcelas(valor) {
      this.parcelas = [];

      for (let i = 0; i < this.qtdParcelas; i++) {
        // incrementa o índice do for para usar como número da parcela
        let numeroParcela = i + 1;

        // faz a soma do valor unitário com o referido acréscimo
        let valorIndividualComAcrescimo = parseFloat(valor.toString().replace(",", ".")) + parseFloat(this.valorAcrescimo["acrescimoCartao" + numeroParcela].replace(",", "."));

        // multiplica o valor individual com acréscimo com a quantidade a ser adquirida
        let valorTotal = (valorIndividualComAcrescimo) // * qtdCompra

        // divide o valor total pelo número da parcela
        let valorParcela = valorTotal / numeroParcela;

        // cria a string contendo todas as informações necessárias
        let textoParcela = numeroParcela + "X de R$ " + valorParcela.toFixed(2).replace(".", ",") + " (Total R$ " + valorTotal.toFixed(2).replace(".", ",") + ")";

        this.parcelas.push(textoParcela);
      }
    },

    cancelarPagamento() {
      //this.removeCupom()
      this.pagePagamento = false;

      if (
        this.eventoSelecionado.matrizColuna &&
        this.eventoSelecionado.matrizLinha
      ) {
        this.paginaInscricaoVagas = true;
      } else {
        this.paginaInscricaoGrupo = true;
      }
    },

    /* formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      }, */

    formatDatePadrao(date) {
      if (!date) return null;

      const [day, month, year] = date.substr(0, 10).split("/");
      return `${year}-${month}-${day}` + " " + date.substr(11, 6);
    },

    formatDateBrz(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    formatDateHora(date) {
      if (!date) return null;

      const [year, month, day] = date.substr(0, 10).split("-");
      const weekDays = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
      const dateObj = new Date(year, month - 1, day);
      const weekDay = weekDays[dateObj.getDay()];
      
      return `${weekDay}, ${day}/${month}/${year}`;
    },

    formatPeriodoEvento(evento) {
      if (!evento.inicio) return null;

      const [yearInicio, monthInicio, dayInicio] = evento.inicio.substr(0, 10).split("-");
      
      // Pega o dia da semana
      const weekDays = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
      const dateObj = new Date(yearInicio, monthInicio - 1, dayInicio);
      const weekDay = weekDays[dateObj.getDay()];
      
      let resultado = `${weekDay}, ${dayInicio}/${monthInicio}/${yearInicio}`;
      
      // Se tiver data de fim e for diferente da data de início, adiciona o período
      if (evento.fim) {
        const [yearFim, monthFim, dayFim] = evento.fim.substr(0, 10).split("-");
        const dataInicio = `${dayInicio}/${monthInicio}/${yearInicio}`;
        const dataFim = `${dayFim}/${monthFim}/${yearFim}`;
        
        if (dataInicio !== dataFim) {
          resultado = `${weekDay}, ${dataInicio} a ${dataFim}`;
        }
      }
      
      // Adiciona o horário de início
      // resultado += ` - ${horaInicio}`;
      
      return resultado + '.';
    },

    async acessaConsulta() {
      this.pagePrincipal = false;
      this.pageConsulta = true;
    },

    async solicitaCancelamento() {
      this.pagePrincipal = false;
      this.pageConsulta = true;
      if (
        this.inscricao.nome == "" ||
        this.eventoId == "" ||
        this.inscricao.cpf == ""
      ) {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Preencha os campos: Evento, Nome e CPF para solicitar o cancelamento!",
          "ATENÇÃO"
        );
      } else {
        this.isLoading = false;
        this.dialogCancelamento = true;
      }
    },

    async realizarCancelamento() {
      this.idInscricao = "";
      this.isLoading = true;
      try {
        let res = await axios.get(
          `${baseApiUrl}Inscricoes?filter={"where":{"and":[{"eventoId":"${this.eventoId}"},{"cpf":"${this.inscricao.cpf}"}]}}`
        );
        if (res.data[0].id) {
          this.idInscricao = res.data[0].id;
        } else {
          this.isLoading = false;
          this.dialogCancelamento = false;
          var vm = this;
          vm.$refs.chamaSnackbar.snack(
            "#F9A825",
            "Não foi possível localizar a inscrição, verifique os dados e tente novamente!",
            "ATENÇÃO"
          );
        }
      } catch (error) {
        this.isLoading = false;
        this.dialogCancelamento = false;
        vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Não foi possível localizar a inscrição, verifique os dados e tente novamente!",
          "ATENÇÃO"
        );
      }
      if (this.idInscricao != "") {
        try {
          let res = await axios.delete(
            `${baseApiUrl}Inscricoes/${this.idInscricao}`
          );
          if (res.data != "") {
            this.isLoading = false;
            this.inscricao = Object.assign({}, this.inscricaoDefault);
            this.dialogCancelamento = false;
            vm = this;
            vm.$refs.chamaSnackbar.snack(
              "#0288D1",
              "Cancelamento realizado com sucesso!",
              "INFORMAÇÃO"
            );
          } else {
            this.isLoading = false;
            this.dialogCancelamento = false;
            vm = this;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Não foi possível realizar o cancelamento, verifique os dados e tente novamente!",
              "ATENÇÃO"
            );
          }
        } catch (error) {
          this.isLoading = false;
          this.dialogCancelamento = false;
          vm = this;
          vm.$refs.chamaSnackbar.snack(
            "#F9A825",
            "Não foi possível realizar o cancelamento, verifique os dados e tente novamente!",
            "ATENÇÃO"
          );
        }
      }
    },

    async aplicaCupom() {
      var vm = this;

      if (this.cupomDesconto) {
        await axios
          .get(
            baseApiUrl +
            'Cupons?filter={"where":{"nome":"' +
            this.cupomDesconto.toUpperCase().trim() +
            '"}}'
          )
          .then((response) => {
            if (response.data) {
              if (
                response.data[0].nome.toUpperCase() ==
                this.cupomDesconto.toUpperCase().trim() &&
                response.data[0].quantidade > response.data[0].utilizados
              ) {
                this.dadosCupom = response.data[0];
                this.cupomAplicado = true;
                this.valorTotalCompra = parseFloat(
                  parseFloat(this.valorTotalCompra) -
                  parseFloat(this.dadosCupom.valor)
                )
                  .toFixed(2)
                  .replace(".", ",");
              }
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Cupom inválido ou esgotado!",
              "ATENÇÃO"
            );
          });
      }
    },

    removeCupom() {
      this.valorTotalCompra = parseFloat(
        parseFloat(this.valorTotalCompra) + parseFloat(this.dadosCupom.valor)
      )
        .toFixed(2)
        .replace(".", ",");
      this.cupomAplicado = false;
      this.dadosCupom = [];
      this.possuiCupom = false;
      this.cupomDesconto = "";
    },

    async atualizaCupomsUtilizados() {
      await axios.patch(baseApiUrl + "Cupons/" + this.dadosCupom.id, {
        utilizados: this.dadosCupom.utilizados + 1,
      });
    },

    carregaQtdParcelas() {
      for (let i = 0; i < this.parcelas.length; i++) {
        if (this.pagamento.valorEscolhido == this.parcelas[i]) {
          this.cobrancaAsaasCartao.installmentCount = parseInt(
            this.parcelas[i].split("X")[0]
          );
          this.textoParcela = this.parcelas[i];

          const parcela = this.parcelas[i];
          const match = parcela.match(/\(Total R\$\s*([\d,]+)\)/);

          if (match && match[1]) {
            this.pagamento.valor = match[1].replace(",", ".");
          }
        }
      }
    },

    async prosseguirPagamento(formaPagamento) {
      let vm = this;
      let inscricoesValidas = [];
      await this.pegaVagasDisponiveis();

      if (!this.aceiteLgpd) {
        vm.$refs.chamaSnackbar.snack("#F9A825", "Para continuar, concorde com as políticas de privacidade e tratamento de dados pessoais", "ATENÇÃO");
        return;
      }

      // if (this.eventoSelecionado.id != "68ffba0be0371b1ae7018b6f" && this.eventoSelecionado.matrizColuna && this.eventoSelecionado.matrizLinha && !this.inscricao[0].vagas) {
      //   vm.$refs.chamaSnackbar.snack("#F9A825", "Para continuar, selecione pelo menos uma mesa", "ATENÇÃO");
      //   return;
      // }

      if (
        this.eventoSelecionado.id != "68ffba0be0371b1ae7018b6f" &&
        (!this.inscricao[0].filho || this.inscricao[0].filho.length == 0) &&
        !(
          this.paginaInscricaoGrupoOnibus === true ||
          this.paginaInscricaoVagasOnibus === true
        )
      ) {
        vm.$refs.chamaSnackbar.snack("#F9A825", "Para continuar, selecione pelo menos um filho", "ATENÇÃO");
        return;
      }

      // Só valida tamanho de camisa se não for evento de ônibus
      if (!this.ehEventoOnibus) {
        if (this.tamanhosCamisaGlobal.length == 0) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Para continuar, informe o tamanho da camisa para todos os inscritos", "ATENÇÃO");
          return;
        }

        // Verifica se todos os filhos selecionados têm tamanho de camisa informado
        for (let i = 0; i < this.inscricao.length; i++) {
          const filhosSelecionados = this.inscricao[i].filho || [];
          
          for (const filho of filhosSelecionados) {
            const key = `${i}_${filho}`;
            if (!this.tamanhosCamisaGlobal[key]) {
              vm.$refs.chamaSnackbar.snack("#F9A825", `Informe o tamanho da camisa para ${filho}`, "ATENÇÃO");
              return;
            }
          }
        }
      }
      
      // if (this.eventoSelecionado.composicao.length >= 1 && (!this.inscricao[0].composicao || this.inscricao[0].composicao.length == 0)) {
      //   vm.$refs.chamaSnackbar.snack("#F9A825", "Para continuar, selecione um tipo de ingresso", "ATENÇÃO");
      //   return;
      // }

      for (let i = 0; i < this.inscricao.length; i++) {
        // this.inscricao[i].setor = this.eventoSelecionado.setores[0].nome;
        // this.inscricao[i].corSetor = this.eventoSelecionado.setores[0].cor;

        // verifica tipoDocumento da inscrição e se todas as informações estão preenchidas
        if (this.inscricao[i].tipoDocumento == "CPF" && !this.validarCamposInscricaoCPF(this.inscricao[i])) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente do " + (i + 1) + "º participante para confirmar a inscrição!", "ATENÇÃO");
          break;
        }
        else if (this.inscricao[i].tipoDocumento == "CNPJ" && !this.validarCamposInscricaoCNPJ(this.inscricao[i])) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente do " + (i + 1) + "º participante para confirmar a inscrição!", "ATENÇÃO");
          break;
        }
        else {
          /* if (this.vagasDisponiveis[this.inscricao[i].setor] > 0) { */
          inscricoesValidas.push(this.inscricao[i]);
          /* } else {
            vm.$refs.chamaSnackbar.snack("#F9A825", "Quantidade máxima do setor selecionado para o " + (i + 1) + "º participante foi atingido. Selecione outro setor.", "ATENÇÃO");
            break;
          } */
        }
      }

      if (inscricoesValidas.length === this.inscricao.length) {
        if (formaPagamento == "CARTÃO") {
          if (parseFloat(this.eventoSelecionado.valorCartao.replace(",", "."))) {
            this.valorTotalCompra = this.calculaValorInscricoes("valorCartao");
            
            // Aplica desconto do divulgador se houver
            if (this.indicacao && this.divulgador && this.divulgador.aplicaDesconto && this.eventoSelecionado.usaLinkDesconto) {
              this.valorTotalCompra -= (this.valorTotalCompra * this.divulgador.valorDesconto / 100);
            }
          }

          this.criarAnosVencimento();

          if (this.eventoSelecionado.matrizLinha && this.eventoSelecionado.matrizColuna) {
            this.criarParcelas(this.eventoSelecionado.valorCartao, this.inscricao[0].vagas.length);
          }
          else {
            this.criarParcelas(this.valorTotalCompra, this.inscricao.length);
          }

          if (this.paginaInscricaoGrupo || this.paginaInscricaoGrupoTorcedor || this.paginaInscricaoGrupoOnibus) {
            this.paginaInscricaoGrupo = false;
            this.paginaInscricaoGrupoTorcedor = false;
            this.paginaInscricaoGrupoOnibus = false;
          }

          if (this.paginaInscricaoVagas || this.paginaInscricaoVagasTorcedor || this.paginaInscricaoVagasOnibus) {
            this.paginaInscricaoVagas = false;
            this.paginaInscricaoVagasTorcedor = false;
            this.paginaInscricaoVagasOnibus = false;
          }

          this.pagePagamento = true;
        } else if (formaPagamento == "PIX") {
          if (parseFloat(this.eventoSelecionado.valorPix.replace(",", "."))) {
            this.valorTotalCompra = this.calculaValorInscricoes("valorPix");
            // this.valorTotalCompra = parseFloat(this.inscricao[0].length * this.eventoSelecionado.valorPix.replace(",", "."));
            
            // Aplica desconto do divulgador se houver
            if (this.indicacao && this.divulgador && this.divulgador.aplicaDesconto && this.eventoSelecionado.usaLinkDesconto) {
              this.valorTotalCompra -= (this.valorTotalCompra * this.divulgador.valorDesconto / 100);
            }
          }
          this.callFunctionPixPayment()
        } else if (formaPagamento == "BOLETO") {
          if (parseFloat(this.eventoSelecionado.valorPix.replace(",", "."))) {
            this.valorTotalCompra = parseFloat(this.inscricao.length * this.eventoSelecionado.valorPix.replace(",", "."));
            
            // Aplica desconto do divulgador se houver
            if (this.indicacao && this.divulgador && this.divulgador.aplicaDesconto && this.eventoSelecionado.usaLinkDesconto) {
              this.valorTotalCompra -= (this.valorTotalCompra * this.divulgador.valorDesconto / 100);
            }
          }
          this.pagamentoBoleto();
        }
      }
    },

    callFunctionPixPayment() {
      if (this.empresa.gatewayPagamentoPix == "TAPAGO") {
        this.pagarPixTaPago()
      }
      else if (this.empresa.gatewayPagamentoPix == "ASAAS") {
        this.pagarPixAsaas()
      }
      else if (this.empresa.gatewayPagamentoPix == "SICOOB") {
        this.pagarPixSicoob()
      }
    },

    validarCamposInscricaoCPF(inscricao) {
      if (
        inscricao.nome.trim() === "" ||
        inscricao.cpf.trim() === "" ||
        !CpfValidate(inscricao.cpf) 
        // inscricao.telefone.trim() === ""
      ) {
        return false;
      } else {
        return true;
      }
    },

    validarCamposInscricaoCNPJ(inscricao) {
      if (
        inscricao.nome.trim() === "" ||
        inscricao.cpf.trim() === "" ||
        !CnpjValidate(inscricao.cpf) ||
        inscricao.telefone.trim() === ""
      ) {
        return false;
      } else {
        return true;
      }
    },

    calculaValorInscricoes(chave) {
      let valor;

      if (chave == "valorPix") {
        if (
          this.eventoSelecionado.matrizLinha &&
          this.eventoSelecionado.matrizColuna
        ) {
          valor =
            parseFloat(this.eventoSelecionado[chave].replace(",", ".")) *
            this.inscricao[0].vagas.length;
        } else {
          // Garante que pelo menos 1 inscrição seja contabilizada
          let quantidadeFilhos;
          if (this.eventoSelecionado.permitePais === true){
            quantidadeFilhos = Math.max(1, (this.qtdCompra - 1) + this.inscricao[0].filho.length);
          } else if (this.inscricao[0].filho && this.inscricao[0].filho.length > 0) {
            quantidadeFilhos = Math.max(1, this.inscricao[0].filho.length)
          } else {
            quantidadeFilhos = Math.max(1, this.qtdCompra);
          }

          valor =  parseFloat(this.eventoSelecionado[chave].replace(",", ".")) * quantidadeFilhos;
        }
      } else if (chave == "valorCartao") {
        if (
          this.eventoSelecionado.matrizLinha &&
          this.eventoSelecionado.matrizColuna
        ) {
          valor =
            parseFloat(this.eventoSelecionado[chave].replace(",", ".")) *
            this.inscricao[0].vagas.length;
        } else {
          // Garante que pelo menos 1 inscrição seja contabilizada
          let quantidadeFilhos;
          if (this.eventoSelecionado.permitePais === true){
            quantidadeFilhos = Math.max(1, (this.qtdCompra - 1) + this.inscricao[0].filho.length);
          } else if (this.inscricao[0].filho && this.inscricao[0].filho.length > 0) {
            quantidadeFilhos = Math.max(1, this.inscricao[0].filho.length)
          } else {
            quantidadeFilhos = Math.max(1, this.qtdCompra);
          }
          valor = parseFloat(this.eventoSelecionado[chave].replace(",", ".")) * quantidadeFilhos;
        }
      }

      for (let i = 0; i < this.inscricao.length; i++) {
        if (
          this.inscricao[i].tipoDocumento == "CNPJ" &&
          this.eventoSelecionado.desconto
        ) {
          valor -= parseFloat(
            this.eventoSelecionado.desconto.replace(",", ".")
          );
        }
      }

      // Aplica desconto do divulgador se houver
      if (this.indicacao && this.divulgador && this.divulgador.aplicaDesconto && this.eventoSelecionado.usaLinkDesconto) {
        valor -= (valor * this.divulgador.valorDesconto / 100);
      }

      return valor;
    },

    async realizarInscricaoPagamento() {
      this.isLoading = true;
      this.jaExiste = false;
      var camposBranco = false;
      this.inscricao.eventoId = this.eventoId;
      var vm = this;
      if (await this.validaVagas()) {
        if (this.caravana) {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf) ||
            this.inscricao.participantes == "" ||
            this.inscricao.dataNascimento == "" ||
            !this.inscricao.aceiteLgpd
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.criarAnosVencimento();
            this.criarParcelas();
            this.isLoading = false;
            this.pagePrincipal = false;
            this.paginaInscricaoGrupo = false;
            this.pagePagamento = true;
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        } else {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf) ||
            this.inscricao.dataNascimento == ""
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.criarAnosVencimento();
            this.criarParcelas();
            this.isLoading = false;
            this.pagePrincipal = false;
            this.PageIncricao = false;
            this.pagePagamento = true;
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        }
      }
    },

    async realizarInscricaoPagamentoBoleto() {
      this.isLoading = true;
      this.jaExiste = false;
      var camposBranco = false;
      this.inscricao.eventoId = this.eventoId;
      var vm = this;
      if (await this.validaVagas()) {
        if (this.caravana) {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf) ||
            this.inscricao.participantes == "" ||
            this.inscricao.dataNascimento == "" ||
            !this.inscricao.aceiteLgpd
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.pagamentoBoleto();
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        } else {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf) ||
            this.inscricao.dataNascimento == ""
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.pagamentoBoleto();
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        }
      }
    },

    async realizarInscricaoPagamentoEmMaos() {
      this.isLoading = true;
      this.jaExiste = false;
      var camposBranco = false;
      this.inscricao.eventoId = this.eventoId;
      if (await this.validaVagas()) {
        if (
          this.inscricao.dataNascimento != "" &&
          this.calculateAge(this.formatDate(this.inscricao.dataNascimento)) < 16
        ) {
          this.isLoading = false;
          var vm2 = this;
          vm2.$refs.chamaSnackbar.snack(
            "#F9A825",
            "Só é permitido a inscrição de maiores de 16 anos!",
            "ATENÇÃO"
          );
        } else {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf)
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            var vm = this;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.inscricao.statusPagamento = "PENDENTE";
            this.inscricao.formOfPayment = "EM MAOS";
            this.inscricao.valorPago = "330,00";
            this.realizarInscricao(this.finalizaInscricao);
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        }
      }
    },

    async realizarInscricaoPagamentoPix() {
      this.isLoading = true;
      this.jaExiste = false;
      var camposBranco = false;
      this.inscricao.eventoId = this.eventoId;
      var vm = this;
      if (await this.validaVagas()) {
        if (this.caravana) {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf) ||
            this.inscricao.participantes == "" ||
            this.inscricao.dataNascimento == "" ||
            !this.inscricao.aceiteLgpd
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.empresa.gatewayPagamentoPix == "TAPAGO"
              ? this.pagarPixTaPago()
              : this.pagarPixAsaas();
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        } else {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf) ||
            this.inscricao.dataNascimento == ""
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.empresa.gatewayPagamentoPix == "TAPAGO"
              ? this.pagarPixTaPago()
              : this.pagarPixAsaas();
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        }
      }
    },

    realizarInscricaoAgora() {
      this.pagePrincipal = false;
      this.PageIncricao = true;
      this.validaVagas();
      this.verificaCapacidade();
    },

    generateMatrix() {
      this.matrix = [];

      for (let i = 0; i < this.eventoSelecionado.matrizLinha; i++) {
        const row = [];
        for (let j = 0; j < this.eventoSelecionado.matrizColuna; j++) {
          const localizacao = i * this.eventoSelecionado.matrizColuna + j + 1;
          row.push({
            localizacao,
            active: false,
            status: "LIVRE",
            tipo: "",
            vaga: "",
            empresaId: "",
            eventoId: "",
            setor: "",
          });
        }
        this.matrix.push(row);
      }

      // Espera a matriz ser criada e então carrega as vagas e atualiza a matriz
      this.$nextTick(() => {
        this.adjustBackgroundSize();
        this.getVagas().then(() => {
          this.updateMatrixCells(); // Atualiza a matriz com os dados recém carregados
        });
      });
    },

    updateMatrixCells() {
      let updatedMatrix = this.matrix.map((row) =>
        row.map((cell) => {
          // Converte `cell.localizacao` para número, se ainda não for, e compara com a `localizacao` de `clickedCells` convertida para número
          const found = this.clickedCells.find(
            (c) => parseInt(c.localizacao) === cell.localizacao
          );

          if (found) {
            // Se encontrada, atualiza a célula com os dados da vaga encontrada e marca como ativa
            return { ...cell, ...found, active: true };
          }

          return cell; // Retorna a célula como está se não encontrar correspondência
        })
      );

      this.matrix = updatedMatrix; // Substitui a matriz antiga pela nova para forçar a reatividade
      // console.log("Matriz atualizada com vagas marcadas:", this.matrix);
    },

    async realizarInscricaoGrupo(evento) {
      this.eventoSelecionado = evento;
      this.tipoIngresso = evento.nome;
      this.caravana = true;
      this.pagePrincipal = false;
      this.visualizacaoEvento(evento.id);

      if (this.eventoSelecionado.composicao) {
        for (let i = 0; i < this.eventoSelecionado.composicao.length; i++) {
          this.eventoSelecionado.composicao[i].quantidade = 0;
        }
      }

      this.inscricao = [];
      for (let i = 0; i < evento.vendaMinima; i++) {
        this.inscricao.push({
          cod_incricao: "",
          nome: "",
          cpf: "",
          email: "",
          sexo: "",
          telefone: "",
          eventoId: "",
          lote: "",
          tipo: "VIRTUAL",
          tipoDocumento:
            evento.tipoDocumento == "AMBOS"
              ? evento.documentoPadrao
              : evento.tipoDocumento,
          valorPago: "",
          qtdSenhasExtra: 1,
          filho: [],
        });
      }

      this.eventoId = evento.id;
      this.valorAcrescimo.acrescimoBoleto = evento.acrescimoBoleto;
      this.valorAcrescimo.acrescimoPix = evento.acrescimoPix;

      let keys = Object.keys(evento);
      keys = keys.filter((k) => k.includes("acrescimoCartao"));

      for (let i = 0; i < evento.quantidadeParcelas; i++) {
        if (keys[i]) {
          this.valorAcrescimo[keys[i]] = evento[keys[i]];
        } else {
          this.valorAcrescimo["acrescimoCartao" + (i + 1)] = "0,00";
        }
      }

      this.qtdParcelas = evento.quantidadeParcelas;
      this.usaCupomDesconto = evento.usaCupomDesconto;
      this.criarQuantidades(evento.vendaMinima, evento.vendaMaxima);
      this.qtdCompra = evento.vendaMinima;
      // await this.verificaCapacidade()

      for (let i = 0; i < this.inscricao.length; i++) {
        if (evento.tipoDocumento == "AMBOS") {
          this.inscricao[i].tipoDocumento = evento.documentoPadrao;
        } else {
          this.inscricao[i].tipoDocumento = evento.tipoDocumento;
        }
      }

      this.valorTotalCompra = 0;

      if (this.empresa.limiteInscricao == "SETOR") {
        this.pegaVagasDisponiveis();
      }

      if (evento.id === "68ffba0be0371b1ae7018b6f") {
        if (evento.matrizColuna && evento.matrizLinha) {
          this.paginaInscricaoVagasTorcedor = true;
        } else {
          this.paginaInscricaoGrupoTorcedor = true;
        }
      } else if (evento.permiteInscricaoPai === true) {
        if (evento.matrizColuna && evento.matrizLinha) {
          this.paginaInscricaoVagasOnibus = true;
        } else {
          this.paginaInscricaoGrupoOnibus = true;
        }
      } else {
        if (evento.matrizColuna && evento.matrizLinha) {
          this.paginaInscricaoVagas = true;
        } else {
          this.paginaInscricaoGrupo = true;
        }
      }
    },

    async verificaDocumento(cpf, index, tipo) {
      let vm = this;
      let jaExiste = false;

      if ((tipo == "CNPJ" && !CnpjValidate(cpf)) || (tipo == "CPF" && !CpfValidate(cpf))) {
        return;
      }

      if (this.verificaCpfInformado(cpf, index)) {
        jaExiste = true;
        this.inscricao[index].cpf = "";
        vm.$refs.chamaSnackbar.snack("#F9A825", "CPF não pode ser o mesmo de um já informado!", "ATENÇÃO");
      }

      if (!jaExiste) {
        await axios.post(baseApiUrl + "inscricoes/consultarInscricaoCPF", { cpf: cpf, eventoId: "66424717e23bc073eba6ea25" }) // Base de dados do evento
          .then((response) => {
            if (response.data.length > 0) { 
              if (Object.keys(response.data[0]).includes("statusPagamento")) {
                // this.inscricao[index].cod_incricao = response.data[0].cod_incricao;
                this.inscricao[index].cpf = response.data[0].cpf;
                this.inscricao[index].nome = response.data[0].nome;
                this.inscricao[index].telefone = response.data[0].telefone;
                //this.inscricao[index].email = response.data[0].email;
                //this.inscricao[index].dataNascimento = response.data[0].dataNascimento;
                //this.inscricao[index].estado = response.data[0].estado;
                //this.inscricao[index].cidade = response.data[0].cidade;
                //this.inscricao[index].valorPago = response.data[0].valorPago;
                //this.inscricao[index].tipoDocumento = response.data[0].tipoDocumento;
                // this.inscricao[index].id = response.data[0].id;
                this.filhosSelect = this.listaFilhos(response.data)

                if (this.eventoSelecionado.matrizColuna && this.eventoSelecionado.matrizLinha) {
                  this.exibeMapa = true
                }
              } else {
                this.dialogoInscricaoNaoLocalizada = true
                this.inscricao[index].cpf = ''
                // this.inscricao[index].nome = response.data[0].nome ? response.data[0].nome : "";
                // this.inscricao[index].cpf = response.data[0].cpf ? response.data[0].cpf : "";
                // this.inscricao[index].dataNascimento = response.data[0].dataNascimento ? response.data[0].dataNascimento : "";
                // this.inscricao[index].telefone = response.data[0].telefone ? response.data[0].telefone : "";
                // this.inscricao[index].email = response.data[0].email ? response.data[0].email : "";
              }
            }
          });

        if (this.eventoSelecionado.matrizColuna && this.eventoSelecionado.matrizLinha) {
          this.generateMatrix()
        }
      }
    },

    listaFilhos(lista) {
      let filhos = [];

      for (let i = 0; i < lista.length; i++) {
        for (let j = 0; j < lista[i].filho.length; j++) {
          if (lista[i].filho[j].nome) {
            filhos.push('(' + lista[i].filho[j].matricula + ") " + lista[i].filho[j].nome + " - " + lista[i].filho[j].equipe + " - " + lista[i].filho[j].turma);
          }
        }
      }

      return filhos;
    },

    verificaCpfInformado(cpf, indice) {
      let cpfLocalizado = false;

      for (let i = 0; i < this.inscricao.length; i++) {
        if (i != indice) {
          if (this.inscricao[i].cpf == cpf) {
            cpfLocalizado = true;
            break;
          }
        }
      }

      return cpfLocalizado;
    },

    async validaVagas() {
      var vm = this;

      try {
        await axios
          .get(
            baseApiUrl +
            'inscricoes/count?where={"and":[{"eventoId":"' +
            this.eventoId +
            '"},{"sexo":"MASCULINO"}]}'
          )
          .then((response) => {
            if (response.data) {
              this.qtdInscMasculinas = response.data.count;
            }
          });

        await axios
          .get(
            baseApiUrl +
            'inscricoes/count?where={"and":[{"eventoId":"' +
            this.eventoId +
            '"},{"sexo":"FEMININO"}]}'
          )
          .then((response) => {
            if (response.data) {
              this.qtdInscFemininas = response.data.count;
            }
          });

        /* let res = await axios.get(`${baseApiUrl}Inscricoes?filter[where][eventoId]=${this.eventoId}`)
          if (res.data.length > 0)
            res.data.forEach(insc => {
              if (insc.sexo == 'MASCULINO')
                this.qtdInscMasculinas = this.qtdInscMasculinas + 1
              else if (insc.sexo == 'FEMININO')
                this.qtdInscFemininas = this.qtdInscFemininas + 1
            }); */

        if (this.inscricao.sexo == "MASCULINO") {
          //this.qtdInscMasculinas = this.vagasMasculinas
          if (this.qtdInscMasculinas == this.vagasMasculinas) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#0288D1",
              "Desculpe-nos, todas as vagas para homens foram esgotadas!",
              "INFORMAÇÃO"
            );
            return false;
          } else {
            this.isLoading = false;
            return true;
          }
        } else if (this.inscricao.sexo == "FEMININO") {
          if (this.qtdInscFemininas == this.vagasFemininas) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#0288D1",
              "Desculpe-nos, todas as vagas para mulheres foram esgotadas!",
              "INFORMAÇÃO"
            );
            return false;
          } else {
            this.isLoading = false;
            return true;
          }
        } else {
          this.isLoading = false;
          return true;
        }
      } catch (error) {
        //
      }
    },

    async realizarInscricao(callback = null, formaPagamento, textoParcela) {
      this.isLoading = true;
      let vm = this;

      for (let i = 0; i < this.inscricao.length; i++) {
        // Concatena os filhos com seus respectivos tamanhos de camisa (apenas se não for evento de ônibus)
        if (this.inscricao[i].filho && this.inscricao[i].filho.length > 0) {
          this.inscricao[i].filho = this.inscricao[i].filho.map(filho => {
            if (this.ehEventoOnibus) {
              // Se for evento de ônibus, não adiciona o tamanho da camisa
              return filho;
            } else {
              // Se não for evento de ônibus, adiciona o tamanho da camisa
              const key = `${i}_${filho}`;
              const tamanhoCamisa = this.tamanhosCamisaGlobal[key];
              return `${filho} - CAMISA ${tamanhoCamisa}`;
            }
          });
        }
        
        // só preenche com cod_incricao quando for nova inscrição
        if (!this.inscricao[i].cod_incricao) {
          this.inscricao[i].cod_incricao = await this.verificaCodInscricao();
        }

        if (this.inscricao.length > 1) {
          this.inscricao[i].eventoId = this.eventoSelecionado.id;
          this.inscricao[i].statusPagamento = "PENDENTE";
          this.inscricao[i].empresaId = this.empresa.id;
          this.inscricao[i].email = this.inscricao[i].email.toLowerCase().trim();
          this.inscricao[i].formOfPayment = formaPagamento;
          this.inscricao[i].parcelas = textoParcela;
          this.inscricao[i].divulgadorId = this.indicacao
            ? this.divulgador.id
            : undefined;
          this.inscricao[i].lote = this.eventoSelecionado.lote;
          if (this.eventoSelecionado.permitePais === true) {
            // Calcula o total de pessoas (filhos + pais)
            // qtdCompra - 1 porque a primeira inscrição é para os filhos, não para um pai
            let totalPessoas = this.inscricao[0].filho.length + (this.qtdCompra - 1);
            let valorPorPessoa = this.valorTotalCompra / totalPessoas;
            
            if (i === 0) {
              // Primeira inscrição: valor por pessoa × número de filhos
              this.inscricao[i].valorPago = valorPorPessoa * this.inscricao[i].filho.length;
            } else {
              // Demais inscrições: valor por pessoa × 1 (cada pai)
              this.inscricao[i].valorPago = valorPorPessoa;
            }
          } else {
            this.inscricao[i].valorPago = (this.valorTotalCompra / this.inscricao.length);
          }
        } else {
          this.inscricao[i].eventoId = this.eventoSelecionado.id;
          this.inscricao[i].statusPagamento = "PENDENTE";
          this.inscricao[i].empresaId = this.empresa.id;
          this.inscricao[i].email = this.inscricao[i].email.toLowerCase().trim();
          this.inscricao[i].formOfPayment = formaPagamento;
          this.inscricao[i].parcelas = textoParcela;
          this.inscricao[i].divulgadorId = this.indicacao
            ? this.divulgador.id
            : undefined;
          this.inscricao[i].lote = this.eventoSelecionado.lote;
          this.inscricao[i].valorPago = this.valorTotalCompra;
        }
      }

      await axios
        .post(baseApiUrl + "inscricoes/criarInscricoes", this.inscricao)
        .then((response) => {
          for (let i = 0; i < response.data.length; i++) {
            for (let j = 0; j < this.inscricao.length; j++) {
              if (this.inscricao[j].cpf == response.data[i].cpf) {
                this.idInscricao.push(response.data[i].id);
                this.inscricao[j].id = response.data[i].id;
              }
            }
          }

          if (callback) {
            callback();
          }
        })
        .catch(() => {
          this.isLoading = false;
          vm.$refs.chamaSnackbar.snack(
            "#EF5350",
            "Erro ao realizar cadastro, tente novamente",
            "ERRO"
          );
        });
    },

    async verificaCodInscricao() {
      let codInscricao = new Date().getTime().toString();
      let codigoRetornado;

      await axios
        .post(baseApiUrl + "inscricoes/consultarInscricaoCodigo", {
          cod_incricao: codInscricao,
        })
        .then(async (response) => {
          if (response.data) {
            await this.verificaCodInscricao();
          }
        })
        .catch((error) => {
          if (error.response.data.error.message.includes("não localizada")) {
            codigoRetornado = codInscricao;
          }
        });

      return codigoRetornado;
    },

    async atualizaInscricao(callback = null) {
      this.inscricao.id = this.idInscricao;

      try {
        await axios.patch(`${baseApiUrl}Inscricoes`, this.inscricao);
        if (callback) {
          callback();
        }
      } catch (error) {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#EF5350",
          "Erro ao atualizar cadastro, tente novamente",
          "DESCULPE"
        );
      }
    },

    async enviaEmail() {
      try {
        await axios
          .post(`${baseApiUrl}Inscricoes/EnviaEmailInscrito`, {
            inscricaoId: this.idInscricao,
          })
          .then((res) => {
            if (res.data) {
              this.codigoAcesso = res.data.codigoAcesso;
            }
          });
      } catch (error) {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#EF5350",
          "Erro ao enviar e-mail, tente novamente",
          "DESCULPE"
        );
      }
    },

    async realizarConsulta() {
      if (this.cpf == "") {
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Preencha todos os campos corretamente para realizar a consulta!",
          "ATENÇÃO"
        );
      } else {
        this.isLoading = true;
        var cpfSemMascara = this.cpf.replaceAll(".", "").replaceAll("-", "");
        await axios
          .get(
            `${baseApiUrl}Inscricoes?filter={"where":{"and":[{"eventoId":"${this.eventoId}"},{"or":[{"cpf":"${this.cpf}"}, {"cpf":"${cpfSemMascara}"}]}]}}`
          )
          .then((res) => {
            if (res.data != "") {
              if (res.data[0].statusPagamento == "PENDENTE") {
                this.msgResultado = "Inscrição localizada";
                this.cultoSelecionado = this.eventos[0].nome;
                this.isLoading = false;
                this.inscricao.nome = res.data[0].nome;
                this.inscricao.cpf = res.data[0].cpf;
                this.inscricao.email = res.data[0].email;
                this.inscricao.ddd = res.data[0].ddd;
                this.inscricao.telefone = res.data[0].telefone;
                this.inscricao.sexo = res.data[0].sexo;
                this.inscricao.participantes = res.data[0].participantes;
                var vm2 = this;
                vm2.$refs.chamaSnackbar.snack(
                  "#F9A825",
                  "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Volte para a tela inicial e clique em 'Faça sua inscrição agora'.",
                  "ATENÇÃO"
                );
              } else {
                if (res.data[0].statusPagamento == "PAGO") {
                  this.cultoSelecionado = this.eventos[0].nome;
                  this.inscricao.nome = res.data[0].nome;
                  this.inscricao.cod_incricao = res.data[0].cod_incricao;
                  this.inscricao.email = res.data[0].email;
                  this.inscricao.participantes = res.data[0].participantes;
                  this.dialogoIngressoIndividual = true;
                  this.isLoading = false;
                }
              }
            } else {
              this.isLoading = false;
              vm2 = this;
              vm2.$refs.chamaSnackbar.snack(
                "#F9A825",
                "Não foi localizada inscrição para os dados informados!",
                "ATENÇÃO"
              );
            }
          });
      }
    },

    async consultaInscricaoPendente(cpf, indice) {
      this.isLoading = true;

      await axios
        .get(
          baseApiUrl +
          'inscricoes?filter={"where":{"and":[{"eventoId":"' +
          this.eventoId +
          '"},{"cpf":"' +
          cpf +
          '"}]},"include":"evento"}'
        )
        .then((response) => {
          if (response.data) {
            if (response.data[0].statusPagamento == "PENDENTE") {
              this.inscricaoLocalizada = true;
              this.msgResultado = "Inscrição localizada";
              this.cultoSelecionado = this.eventos[0].nome;
              this.isLoading = false;
              this.inscricao[indice].cod_incricao =
                response.data[0].cod_incricao;
              this.inscricao[indice].nome = response.data[0].nome;
              this.inscricao[indice].cpf = response.data[0].cpf;
              this.inscricao[indice].email = response.data[0].email;
              this.inscricao[indice].sexo = response.data[0].sexo;
              this.inscricao[indice].telefone = response.data[0].telefone;
              this.inscricao[indice].eventoId = response.data[0].eventoId;
              this.inscricao[indice].codigoTransacao =
                response.data[0].codigoTransacao;
              this.inscricao[indice].estado = response.data[0].estado;
              this.inscricao[indice].cidade = response.data[0].cidade;
              this.inscricao[indice].id = response.data[0].id;
              var vm2 = this;
              vm2.$refs.chamaSnackbar.snack(
                "#F9A825",
                "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Para prosseguir, escolha uma forma de pagamento no final do formulário.",
                "ATENÇÃO"
              );
            } else if (response.data[0].statusPagamento == "PAGO") {
              this.inscricao.cod_incricao = response.data[0].cod_incricao;
              this.cultoSelecionado = response.data[0].evento.nome;
              this.inscricao.participantes = response.data[0].participantes;
              this.inscricao.nome = response.data[0].nome;
              this.codigoAcesso = response.data[0].codigoAcesso;
              this.inscricao.email = response.data[0].email;
              this.dialogoIngressoIndividual = true;
              this.isLoading = false;
            }
          } else {
            this.isLoading = false;
            this.consultaDadosCpf(cpf);
          }
        });
    },

    async consultaDadosCpf(cpf) {
      await axios
        .get(baseApiUrl + 'inscricoes?filter={"where":{"cpf":"' + cpf + '"}}')
        .then((response) => {
          if (response.data) {
            this.inscricao.nome = response.data[0].nome.trim();
            this.inscricao.dataNascimento = response.data[0].dataNascimento;
            this.inscricao.telefone = response.data[0].telefone;
          }
        });
    },

    async verificaCapacidade() {
      this.isLoading = true;
      let vm = this;

      this.capacidadeEvento = this.eventoSelecionado.vagas;
      this.qtdInscritos =
        this.eventoSelecionado.quantidadeInscricoes +
        this.eventoSelecionado.reserva;

      if (
        this.qtdInscritos + this.qtdCompra > this.capacidadeEvento &&
        this.capacidadeEvento - this.qtdInscritos > 0
      ) {
        this.isLoading = false;
        this.qtdCompra = 1;
        vm.$refs.chamaSnackbar.snack(
          "#0288D1",
          "Desculpe-nos, restam apenas " +
          (this.capacidadeEvento - this.qtdInscritos) +
          " vaga(s) disponível!",
          "INFORMAÇÃO"
        );
        this.verificaCapacidade();
      } else if (
        this.qtdInscritos + this.qtdCompra > this.capacidadeEvento &&
        this.capacidadeEvento - this.qtdInscritos == 0
      ) {
        this.isLoading = false;
        this.qtdCompra = 0;
        vm.$refs.chamaSnackbar.snack(
          "#0288D1",
          "Desculpe-nos, todas as vagas foram esgotadas!",
          "INFORMAÇÃO"
        );
        this.verificaCapacidade();
      } else {
        this.isLoading = false;
        if (this.qtdCompra > this.inscricao.length) {
          let novasInscricoes = [];

          for (let i = 0; i < this.qtdCompra - this.inscricao.length; i++) {
            novasInscricoes.push({
              cod_incricao: "",
              nome: "",
              cpf: "",
              email: "",
              sexo: "",
              telefone: "",
              eventoId: "",
              lote: "",
              tipo: "VIRTUAL",
              estado: "",
              cidade: "",
              tipoDocumento:
                this.eventoSelecionado.tipoDocumento == "AMBOS"
                  ? this.eventoSelecionado.documentoPadrao
                  : this.eventoSelecionado.tipoDocumento,
              valorPago: "",
              qtdSenhasExtra: 1,
              filho: [],
            });
          }

          let novaLista = [...this.inscricao, ...novasInscricoes];
          this.inscricao = novaLista;
        } else {
          this.inscricao = this.removerElementos(
            this.inscricao,
            this.inscricao.length - this.qtdCompra
          );
        }
      }
    },

    removerElementos(lista, quantidade) {
      if (lista.length >= quantidade) {
        lista.splice(-quantidade, quantidade);

        return lista;
      }
    },

    async verificaVagas() {
      var vm = this;
      await axios
        .post(`${baseApiUrl}eventos/vagas`, { eventoId: this.eventoId })
        .then((response) => {
          if (response.data) {
            if (this.caravana) {
              if (response.data.vagasRestantes < 2) {
                vm.$refs.chamaSnackbar.snack(
                  "#0288D1",
                  "Desculpe-nos, todas as vagas foram esgotadas!",
                  "INFORMAÇÃO"
                );
                return false;
              } else if (
                response.data.vagasRestantes < this.inscricao.participantes
              ) {
                vm.$refs.chamaSnackbar.snack(
                  "#0288D1",
                  "Desculpe-nos, restam apenas " +
                  response.data.vagasRestantes +
                  " vaga(s) disponível(is)!",
                  "INFORMAÇÃO"
                );
                return false;
              }
            } else {
              if (response.data.vagasRestantes == 0) {
                this.isLoading = false;
                vm.$refs.chamaSnackbar.snack(
                  "#0288D1",
                  "Desculpe-nos, todas as vagas foram esgotadas!",
                  "INFORMAÇÃO"
                );
                return false;
              }
            }
            return true;
          }
        });
    },

    // método de pagamento
    /* async pagarCartao() {
        if ((this.pagamento.nomeTitular != '') && (this.pagamento.cartaoNumero != '') && (this.pagamento.cpfTitular != '') && (this.pagamento.cvv != '') && (this.pagamento.mesVencimento != '') && (this.pagamento.anoVencimento != '') && (this.pagamento.bandeira != '')) {
          await this.realizarInscricao()
          if (this.idInscricao) {
            this.isLoading = true
            var primeiroUltimoNome = this.inscricao.nome.trim().split(" ")
            this.modelCartao.id = this.encrypt(this.inscricao.cod_incricao.toString())
            this.modelCartao.tipoTransacao = 'A_VISTA'
            this.inscricao.valorPago = this.valorEvento
            this.modelCartao.valor = parseFloat(this.valorEvento.replace(',','.'))
            //dados do comprador
            this.modelCartao.comprador.id = this.encrypt(this.inscricao.cod_incricao.toString())
            this.modelCartao.comprador.documentoNumero = this.inscricao.cpf.replace(/[^\d]+/g,'')
            this.modelCartao.comprador.documentoTipo = '1'
            this.modelCartao.comprador.email = this.inscricao.email
            this.modelCartao.comprador.nomeCompleto = this.inscricao.nome
            this.modelCartao.comprador.primeiroNome = primeiroUltimoNome[0]
            this.modelCartao.comprador.ultimoNome = primeiroUltimoNome[primeiroUltimoNome.length - 1]
            this.modelCartao.comprador.enderecoLogradouro = "Rua Professor Joaquim Francisco Veloso Galvao"
            this.modelCartao.comprador.enderecoNumero = "1734"
            this.modelCartao.comprador.enderecoComplemento = "Igreja da Liberdade"
            this.modelCartao.comprador.enderecoCep = "58031130"
            this.modelCartao.comprador.enderecoBairro = "EXPEDICIONARIOS"
            this.modelCartao.comprador.enderecoCidade = "JOAO PESSOA"
            this.modelCartao.comprador.enderecoEstado = "PARAIBA"
            // this.modelCartao.comprador.telefone = this.financialManagers.cellPhone
            this.modelCartao.cartao.nome = this.pagamento.nomeTitular
            // this.modelCartao.cartao.numero = this.pagamento.cartaoNumero.replace(/[^\d]+/g,'')
            this.modelCartao.cartao.codigoSeguranca = this.pagamento.cvv
            this.modelCartao.cartao.expiracaoMes = this.pagamento.mesVencimento
            this.modelCartao.cartao.expiracaoAno = this.pagamento.anoVencimento
            this.modelCartao.cartao.bandeira = this.pagamento.bandeira

            // dados para a inscrição
            this.inscricao.cardCvv = this.encrypt(this.pagamento.cvv.toString())
            this.inscricao.cardNumber = this.pagamento.cartaoNumero.replace(/[^\d]+/g,'')
            this.inscricao.cardValidity = this.pagamento.mesVencimento + this.pagamento.anoVencimento
            this.inscricao.cardHolderName = this.pagamento.nomeTitular
            this.inscricao.cardFlag = this.pagamento.bandeira
            this.atualizaInscricao()
            try {
              let res = await axios.post(`${baseApiUrl}Pagamentos/cartaocredito`, this.modelCartao) 
              if (res.data) {
                this.inscricao.codigoTransacao = res.data.transacao.autorizacaoCodigo
                this.inscricao.nsu = res.data.transacao.nsu
                this.inscricao.paymentId = res.data.pagamentoId
                this.inscricao.formOfPayment = 'CARTAO'
                this.inscricao.statusPagamento = "PAGO"
                await this.atualizaInscricao()
                this.finalizaInscricao()
              }
            } catch (error) {
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao efetuar pagamento, " + error.response.data.error.mensagem,"DESCULPE!")
            }
          } else {
            this.isLoading = false
            var vm4 = this;
            vm4.$refs.chamaSnackbar.snack("#EF5350", "Falha ao realizar inscrição, tente novamente!", "DESCULPE")
          }
        } else {
          this.$validator.validateAll()
        }
      }, */

    /* async pagarBoleto() {
        await this.realizarInscricao()
        if (this.idInscricao) {
          this.isLoading = true
          // criando data de vencimeto do boleto
          var datapagvenc = new Date();
          datapagvenc.setDate(new Date().getDate())
          // criando nosso número
          var nossoNum = this.inscricao.cod_incricao.toString() + Math.floor(10 + Math.random() * 99999)
          // preencher o campos do modelBoleto
          modelBoleto.pagadorDocumentoNumero = this.inscricao.cpf.replace(/[^\d]+/g,'')
          modelBoleto.pagadorNome = this.inscricao.nome.substr(0, 39)
          modelBoleto.pagadorEndereco = "Prof Joaquim Francisco V. Galvao, 1734"
          modelBoleto.pagadorBairro = "EXPEDICIONARIOS"
          modelBoleto.pagadorCidade = "JOAO PESSOA"
          modelBoleto.pagadorUf = "PB"
          modelBoleto.pagadorCep = "58031130";
          modelBoleto.dataVencimento = datapagvenc.toISOString().substr(0, 10)
          modelBoleto.descontoDataLimite = datapagvenc.toISOString().substr(0, 10)
          // salvando o responsibility e o valor do boleto caso seja anual
          modelBoleto.valorNominal = parseFloat(this.valorEvento.replace(',','.'))
          modelBoleto.mensagem = 'Ref. ao evento ' + this.cultoSelecionado + " para a insc. de nº " + this.inscricao.cod_incricao
          modelBoleto.nsu = this.inscricao.cod_incricao
          modelBoleto.nossoNumero = nossoNum.substr(0,12)
          modelBoleto.seuNumero = nossoNum.substr(0,12)
          // gerando o Boleto e pegando o ID
          try {
            let res = await axios.post(`${baseApiUrl}Pagamentos/boletosPost`,modelBoleto)
            if (res.data != '') {
              this.inscricao.boletoId = res.data.id
              this.inscricao.formOfPayment = 'BOLETO'
              this.inscricao.situacaoBoleto = 'GERADO'
              this.inscricao.nsu = modelBoleto.nsu
              this.inscricao.nossoNumero = modelBoleto.nossoNumero
              this.inscricao.vencimentoBoleto = modelBoleto.dataVencimento
              this.inscricao.statusPagamento = 'PENDENTE'
              await this.atualizaInscricao()
              await this.imprimirBoleto()
              await this.finalizaInscricao()
            }
          } catch (error) {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao gerar boleto. Tente novamente!","DESCULPE");
            this.close()                 
          }                
        } else {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao realizar inscrição, tente novamente!","DESCULPE");
        }
      }, */

    async pagamentoCartao() {
      let vm = this;

      if (
        this.pagamento.nomeTitular != "" &&
        this.pagamento.cartaoNumero != "" &&
        this.pagamento.cpfTitular != "" &&
        this.pagamento.cvv != "" &&
        this.pagamento.mesVencimento != "" &&
        this.pagamento.anoVencimento != "" &&
        this.pagamento.bandeira != "" &&
        this.pagamento.cep != "" &&
        this.pagamento.numero != "" &&
        this.pagamento.email != "" &&
        this.pagamento.valor != 0
      ) {
        this.isLoading = true;

        await this.realizarInscricao(null, "CARTAO", this.textoParcela);
        await this.criarClienteAsaas();
        if (this.idInscricao.length > 0) {
          try {
            let codInscricaoGeral;

            for (let i = 0; i < this.inscricao.length; i++) {
              if (i == 0) {
                codInscricaoGeral = this.inscricao[i].cod_incricao;
              } else {
                codInscricaoGeral += ", " + this.inscricao[i].cod_incricao;
              }
            }
            this.cobrancaAsaasCartao.customer = this.idClienteAsaas;
            this.cobrancaAsaasCartao.billingType = "CREDIT_CARD";
            this.cobrancaAsaasCartao.value = parseFloat(this.pagamento.valor);
            this.cobrancaAsaasCartao.installmentValue = parseFloat(
              parseFloat(this.pagamento.valor) /
              this.cobrancaAsaasCartao.installmentCount
            );
            this.cobrancaAsaasCartao.dueDate = moment().format("YYYY-MM-DD");
            this.cobrancaAsaasCartao.description =
              "Ref. ao evento " +
              this.eventoSelecionado.nome +
              " para as insc. de nº " +
              codInscricaoGeral;
            this.cobrancaAsaasCartao.inscricaoId = this.idInscricao;
            this.cobrancaAsaasCartao.empresaId = this.empresa.id;
            axios.get("https://api.ipify.org/?format=json").then((res) => {
              if (res.data) {
                try {
                  this.cobrancaAsaasCartao.remoteIp = res.data.ip;
                } catch (error) {
                  this.cobrancaAsaasCartao.remoteIp = "127.0.0.1";
                }
              } else {
                this.cobrancaAsaasCartao.remoteIp = "127.0.0.1";
              }
            });
            // inserindo dados do cartão de crédito no objeto de pagamento
            this.cobrancaAsaasCartao.creditCard.holderName =
              this.pagamento.nomeTitular;
            this.cobrancaAsaasCartao.creditCard.number =
              this.pagamento.cartaoNumero;
            this.cobrancaAsaasCartao.creditCard.expiryMonth =
              this.pagamento.mesVencimento;
            this.cobrancaAsaasCartao.creditCard.expiryYear =
              this.pagamento.anoVencimento;
            this.cobrancaAsaasCartao.creditCard.ccv = this.pagamento.cvv;
            // inserindo dados do responśavel do cartão de crédito no objeto de pagamento
            this.cobrancaAsaasCartao.creditCardHolderInfo.name =
              this.pagamento.nomeTitular;
            this.cobrancaAsaasCartao.creditCardHolderInfo.email =
              this.pagamento.email.trim().toLowerCase();
            this.cobrancaAsaasCartao.creditCardHolderInfo.cpfCnpj =
              this.pagamento.cpfTitular;
            this.cobrancaAsaasCartao.creditCardHolderInfo.postalCode =
              this.pagamento.cep;
            this.cobrancaAsaasCartao.creditCardHolderInfo.addressNumber =
              this.pagamento.numero;
            this.cobrancaAsaasCartao.creditCardHolderInfo.phone =
              this.inscricao[0].telefone.replace(/[^\d]+/g, "");
            await axios
              .post(
                baseApiUrl + "Pagamentos/AsaasCobranca",
                this.cobrancaAsaasCartao
              )
              .then((response) => {
                if (response.data.cobranca.status == "CONFIRMED") {
                  this.finalizaInscricao('CARTÃO');
                  if (this.cupomAplicado) this.atualizaCupomsUtilizados();
                }
              });
          } catch (error) {
            this.idInscricao = [];
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#EF5350",
              "Transação não autorizada. Verifique os dados informados e tente novamente ou utilize um outro cartão.",
              "DESCULPE"
            );
          }
        } else {
          this.idInscricao = [];
          this.isLoading = false;
          vm.$refs.chamaSnackbar.snack(
            "#F9A825",
            "Falha ao realizar inscrição, tente novamente!",
            "DESCULPE"
          );
        }
      } else {
        this.$validator.validateAll();
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Preencha todos os campos corretamente para continuar!",
          "ATENÇÃO"
        );
      }
    },

    async criarClienteAsaas() {
      this.clienteAsaas.name = this.pagePagamento
        ? this.pagamento.nomeTitular
        : this.inscricao[0].nome;
      this.clienteAsaas.cpfCnpj = this.pagePagamento
        ? this.pagamento.cpfTitular
        : this.inscricao[0].cpf;
      this.clienteAsaas.email = this.pagamento.email;
      this.clienteAsaas.mobilePhone = this.inscricao[0].telefone.replace(
        /[^\d]+/g,
        ""
      );
      this.clienteAsaas.postalCode = this.pagamento.cep;
      this.clienteAsaas.addressNumber = this.pagamento.numero;
      this.clienteAsaas.empresaId = this.empresa.id;

      try {
        await axios
          .post(baseApiUrl + "Pagamentos/criarCliente", this.clienteAsaas)
          .then((response) => {
            if (response.data) {
              this.idClienteAsaas = response.data.id;
            }
          });
      } catch (error) {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Falha ao realizar inscrição, tente novamente!",
          "DESCULPE"
        );
      }
    },

    async pagamentoBoleto() {
      this.isLoading = true;

      await this.realizarInscricao(null, "BOLETO", "A VISTA");
      await this.criarClienteAsaas();
      if (this.idInscricao.length > 0) {
        let codInscricaoGeral;

        for (let i = 0; i < this.inscricao.length; i++) {
          if (i == 0) {
            codInscricaoGeral = this.inscricao[i].cod_incricao;
          } else {
            codInscricaoGeral += ", " + this.inscricao[i].cod_incricao;
          }
        }

        try {
          this.cobrancaAsaas.customer = this.idClienteAsaas;
          this.cobrancaAsaas.value = (parseFloat(this.valorTotalCompra) + parseFloat(this.valorAcrescimo.acrescimoBoleto.replace(",", "."))).toFixed(2);
          this.cobrancaAsaas.dueDate = moment().format("YYYY-MM-DD");
          this.cobrancaAsaas.billingType = "BOLETO";
          this.cobrancaAsaas.description =
            "Ref. ao evento " +
            this.cultoSelecionado +
            " para as insc. de nº " +
            codInscricaoGeral;
          this.cobrancaAsaas.inscricaoId = this.idInscricao;
          this.cobrancaAsaas.empresaId = this.empresa.id;
          await axios
            .post(`${baseApiUrl}Pagamentos/AsaasCobranca`, this.cobrancaAsaas)
            .then((res) => {
              if (res.data) {
                this.linkBoleto = res.data.cobranca.bankSlipUrl;
                this.finalizaInscricao('BOLETO');
                if (this.cupomAplicado) this.atualizaCupomsUtilizados();
              }
            });
        } catch (error) {
          this.isLoading = false;
          vm = this;
          vm.$refs.chamaSnackbar.snack(
            "#F9A825",
            "Problema encontrado ao gerar o boleto. Tente novamente mais tarde.",
            "DESCULPE"
          );
        }
      } else {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Falha ao realizar inscrição, tente novamente!",
          "DESCULPE"
        );
      }
    },

    abreBoleto() {
      window.open(this.linkBoleto);
    },

    async pagarPixAsaas() {
      this.isLoading = true;

      await this.realizarInscricao(null, "PIX", "A VISTA");
      await this.criarClienteAsaas();
      if (this.idInscricao.length > 0) {
        try {
          let codInscricaoGeral;

          for (let i = 0; i < this.inscricao.length; i++) {
            if (i == 0) {
              codInscricaoGeral = this.inscricao[i].cod_incricao;
            } else {
              codInscricaoGeral += ", " + this.inscricao[i].cod_incricao;
            }
          }

          this.cobrancaAsaas.customer = this.idClienteAsaas;
          this.cobrancaAsaas.value = (
            parseFloat(this.valorTotalCompra) +
            parseFloat(this.valorAcrescimo.acrescimoPix.replace(",", "."))
          ).toFixed(2);
          this.cobrancaAsaas.dueDate = moment().format("YYYY-MM-DD");
          this.cobrancaAsaas.billingType = "PIX";
          this.cobrancaAsaas.description =
            "Ref. ao evento " +
            this.eventoSelecionado.nome +
            " para as insc. de nº " +
            codInscricaoGeral;
          this.cobrancaAsaas.inscricaoId = this.idInscricao;
          this.cobrancaAsaas.empresaId = this.empresa.id;
          await axios
            .post(baseApiUrl + "Pagamentos/AsaasCobranca", this.cobrancaAsaas)
            .then((response) => {
              if (response.data) {
                this.inscricao.codigoTransacao =
                  response.data.cobranca.invoiceUrl;
                this.qrCode64 =
                  "data:image/jpeg;base64," + response.data.qrCode.encodedImage;
                this.chaveCopiaeCola = response.data.qrCode.payload;
                this.msgResultado = "Pré-inscrição realizada com sucesso";
                this.pagamentoPix = true;
                this.isLoading = false;
                this.inscricao.id = this.idInscricao;
                this.consultaPagamentoPix(response.data.id);
                if (this.cupomAplicado) this.atualizaCupomsUtilizados();
              }
            });
        } catch (error) {
          this.idInscricao = [];
          this.isLoading = false;
          vm = this;
          vm.$refs.chamaSnackbar.snack(
            "#F9A825",
            "Falha ao gerar pagamento. Tente novamente mais tarde.",
            "DESCULPE"
          );
        }
      } else {
        this.idInscricao = [];
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Falha ao realizar inscrição, tente novamente!",
          "DESCULPE"
        );
      }
    },

    async pagarPixSicoob() {
      this.isLoading = true;

      await this.realizarInscricao(null, "PIX", "A VISTA");
      if (this.idInscricao.length > 0) {
        let codInscricaoGeral = this.inscricao[0].cod_incricao

        // for (let i = 0; i < this.inscricao.length; i++) {
        //   if (i == 0) {
        //     codInscricaoGeral = this.inscricao[i].cod_incricao;
        //   } else {
        //     codInscricaoGeral += ", " + this.inscricao[i].cod_incricao;
        //   }
        // }

        let dadosCobranca = {
          empresaId: this.empresa.id,
          inscricaoId: this.idInscricao,
          calendario: {
            expiracao: 3600
          },
          devedor: {
            cpf: this.inscricao[0].cpf,
            nome: this.inscricao[0].nome,
          },
          valor: {
            original: ""
          },
          chave: "",
          solicitacaoPagador: "Ref. ao evento " + this.eventoSelecionado.nome + " para a insc. de nº " + codInscricaoGeral + ", qtd insc. " + this.inscricao.length
        };

        dadosCobranca.valor.original = (parseFloat(this.valorTotalCompra) + parseFloat(this.valorAcrescimo.acrescimoPix.replace(",", "."))).toFixed(2);

        await axios.post(baseApiUrl + "Pagamentos/sicoobCobranca", dadosCobranca)
          .then((response) => {
            if (response.data) {
              this.qrCode64 = response.data.brcode
              this.chaveCopiaeCola = response.data.brcode
              this.msgResultado = "Pré-inscrição realizada com sucesso";
              this.pagamentoPix = true;
              this.isLoading = false;
              this.consultaPagamentoPixSicoob();
              if (this.cupomAplicado) this.atualizaCupomsUtilizados();
            }
          })
          .catch(() => {
            this.isLoading = false;
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825", "Falha ao gerar pagamento. Tente novamente mais tarde.", "DESCULPE");
          });
      } else {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#F9A825", "Falha ao realizar inscrição, tente novamente!", "DESCULPE"
        );
      }
    },

    async consultaPagamentoPixSicoob() {
      try {
        this.verificaPagamento = setInterval(
          async function () {
            await axios.post(baseApiUrl + "Pagamentos/sicoobCobrancaConsulta", { "inscricaoId": this.idInscricao[0] })
              .then((res3) => {
                if (res3.data.status == "APPROVED") {
                  this.isLoading = true;
                  this.finalizaInscricao('PIX');
                  clearInterval(this.verificaPagamento);
                }
              });
          }.bind(this), 5000);
      } catch (error) {
        clearInterval(this.verificaPagamento);
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Não foi possível verificar o pagamento, tente novamente!", "DESCULPE");
      }
    },

    async consultaPagamentoPixTaPago() {
      try {
        this.verificaPagamento = setInterval(
          async function () {
            await axios
              .post(baseApiUrl + "Pagamentos/taPagoCobrancaConsulta", {
                inscricaoId: this.idInscricao[0],
                empresaId: this.empresa.id,
              })
              .then((res3) => {
                if (res3.data.status == "APPROVED") {
                  this.isLoading = true;
                  this.finalizaInscricao();
                  clearInterval(this.verificaPagamento);
                }
              });
          }.bind(this),
          5000
        );
      } catch (error) {
        clearInterval(this.verificaPagamento);
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#EF5350",
          "Não foi possível verificar o pagamento, tente novamente!",
          "DESCULPE"
        );
      }
    },

    consultaPagamentoPix() {
      try {
        this.verificaPagamento = setInterval(
          function () {
            axios
              .post(baseApiUrl + "Pagamentos/AsaasCobrancaConsulta", {
                inscricaoId: this.idInscricao[0],
                empresaId: this.empresa.id,
              })
              .then((res3) => {
                if (res3.data.status == "RECEIVED") {
                  this.finalizaInscricao('PIX');
                  clearInterval(this.verificaPagamento);
                }
              });
          }.bind(this),
          5000
        );
      } catch (error) {
        clearInterval(this.verificaPagamento);
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#EF5350",
          "Não foi possível verificar o pagamento, tente novamente!",
          "DESCULPE"
        );
      }
    },

    async pagarPixTaPago() {
      this.isLoading = true;

      await this.realizarInscricao(null, "PIX", "A VISTA");
      if (this.idInscricao.length > 0) {
        let codInscricaoGeral;

        for (let i = 0; i < this.inscricao.length; i++) {
          if (i == 0) {
            codInscricaoGeral = this.inscricao[i].cod_incricao;
          } else {
            codInscricaoGeral += ", " + this.inscricao[i].cod_incricao;
          }
        }

        let dadosCobranca = {
          empresaId: this.empresa.id,
          inscricaoId: this.idInscricao,
          valor: "",
          descricao:
            "Ref. ao evento " +
            this.eventoSelecionado.nome +
            " para a insc. de nº " +
            codInscricaoGeral,
        };

        dadosCobranca.valor = (
          parseFloat(this.valorTotalCompra) +
          parseFloat(this.valorAcrescimo.acrescimoPix.replace(",", "."))
        ).toFixed(2);

        await axios
          .post(baseApiUrl + "Pagamentos/taPagoCobranca", dadosCobranca)
          .then((response) => {
            if (response.data) {
              this.qrCode64 =
                "data:" +
                response.data.instantPayment.generateImage.mimeType +
                ";base64," +
                response.data.instantPayment.generateImage.imageContent;
              this.chaveCopiaeCola = response.data.instantPayment.textContent;
              this.msgResultado = "Pré-inscrição realizada com sucesso";
              this.pagamentoPix = true;
              this.isLoading = false;
              this.consultaPagamentoPixTaPago();
              if (this.cupomAplicado) this.atualizaCupomsUtilizados();
            }
          })
          .catch(() => {
            this.isLoading = false;
            vm = this;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Falha ao gerar pagamento. Tente novamente mais tarde.",
              "DESCULPE"
            );
          });
      } else {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Falha ao realizar inscrição, tente novamente!",
          "DESCULPE"
        );
      }
    },

    async imprimirBoleto() {
      //Baixando Boleto PDF
      try {
        let res = await axios.get(
          `https://p4x.srv.br/api/v1.0/boletos/${this.inscricao.boletoId}/imprimir`,
          {
            responseType: "arraybuffer",
            headers: {
              Authorization: "Bearer " + this.token, //the token is a variable which holds the token
              "Content-type": "application/pdf",
            },
          }
        );
        if (res.data) {
          //Create a Blob from the PDF Stream
          const file = new Blob([res.data], { type: "application/pdf" });
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          const link = document.createElement("a");
          link.href = fileURL;
          link.setAttribute("download", "boleto.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();
          //Open the URL on new Window
          window.open(fileURL);
          //exibe mensagem de conclusao
          this.isLoading = false;
          this.dialogLoading = true;
        }
      } catch (error) {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#EF5350",
          "Erro ao imprimir boleto. Tente novamente ou entre em contato com a Intelite Tecnologia!",
          "ERRO"
        );
      }
    },

    finalizaInscricao(formaPagamento) {
      this.isLoading = false;
      if (formaPagamento == "CARTÃO") {
        this.msgResultado = "Compra realizada com sucesso!";
        this.dialogoListaIngresso = true;
      }
      else if (formaPagamento == "BOLETO") {
        this.msgResultado = "Pré inscrição realizada com sucesso!";
        this.confirmacaoBoleto = true;
      }
      else if (formaPagamento == "EM MAOS") {
        this.msgResultado = "Pré inscrição realizada com sucesso!";
        this.confirmacaoEmMaos = true;
      }
      else if (formaPagamento == 'PIX') {
        this.pagamentoPix = false;
        this.msgResultado = "Compra realizada com sucesso!";
        this.dialogoListaIngresso = true;
      }
    },

    //Função para criptografia
    encrypt(text) {
      let crypto = require("crypto");
      let password = "pxuelh2so839ljis";
      let iv = "pxuelh2so839ljis";
      let cipher = crypto.createCipheriv("aes-128-cbc", password, iv);
      let encryptedData =
        cipher.update(text, "utf8", "Base64") + cipher.final("Base64");

      return encryptedData;
    },

    closeDialog() {
      this.pagamentoPix = false;

      if (!this.consultaCPF) {
        this.reloadPage();
      }

      this.$validator.reset();

      if (this.consultaCPF) {
        this.consultaCPF = false;
        this.inscricao = Object.assign({}, this.inscricaoDefault);
      }
    },

    compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const dataA = a.nome;
      const dataB = b.nome;

      let comparison = 0;
      if (dataA > dataB) {
        comparison = 1;
      } else if (dataA < dataB) {
        comparison = -1;
      }
      return comparison;
    },

    calculateAge(dobString) {
      var dob = new Date(dobString);
      var currentDate = new Date();
      var currentYear = currentDate.getFullYear();
      var birthdayThisYear = new Date(
        currentYear,
        dob.getMonth(),
        dob.getDate()
      );
      var age = currentYear - dob.getFullYear();

      if (birthdayThisYear > currentDate) {
        age--;
      }

      return age;
    },

    formatDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },

    async pegaParametrosUrl() {
      var vm = this;
      var params = window.location.search.substring(1).split("&");
      if (params[0] != "") {
        this.isLoading = true;
        let paramArray = {}; // Criar objeto que vai conter os parametros

        for (var i = 0; i < params.length; i++) {
          // Passar por todos os parametros
          var param = params[i].split("="); // Dividir os parametros chave e valor
          paramArray[param[0]] = param[1]; // Adicionar ao objeto criado antes
        }

        if (paramArray["cod"]) {
          await axios
            .post(baseApiUrl + "inscricoes/consultarInscricaoCodigo", {
              cod_incricao: paramArray["cod"],
            })
            .then(async (response) => {
              if (response.data) {
                if (response.data.statusPagamento == "PAGO") {
                  this.inscricaoLocalizada = Object.assign({}, response.data);
                  this.dialogoIngressoIndividual = true;
                } else {
                  vm.$refs.chamaSnackbar.snack(
                    "#F9A825",
                    "Pagamento da inscrição não foi efetuado.",
                    "ATENÇÃO"
                  );
                }
              }
            })
            .catch(error => {
              vm.$refs.chamaSnackbar.snack("red", error.response.data.error.message, "DESCULPE");
            })
        }

        if (paramArray["d"]) {
          this.consultaDivulgador(paramArray["d"]);
        }

        if (paramArray["e"]) {
          await axios
            .post(baseApiUrl + "eventos/porId", { eventoId: paramArray["e"] })
            .then((response) => {
              if (response.data) {
                if (
                  moment(
                    this.formatDateHora(response.data.fim),
                    "DD/MM/YYYY HH:mm:ss",
                    true
                  ).format() >= moment().format()
                ) {
                  this.bloqueiaVoltar = true;
                  this.realizarInscricaoGrupo(response.data);
                }
              }
            });
        }
      }
      this.isLoading = false;
    },

    async salvaHoraVisualizacao(id) {
      await axios.patch(baseApiUrl + "inscricoes/" + id, {
        visualizado: true,
        ultimaVisualizacao: moment().toISOString(),
      });
    },

    async consultarInscricao(cpf, cod) {
      var vm = this;
      if (cpf) {
        this.isLoading = true;
        let envio = {
          eventoId: this.eventoId,
          cpf: cpf,
          enviaToken: true,
          canalNotificacao: "ZAP",
          cod_incricao: cod,
        };

        try {
          await axios
            .post(`${baseApiUrl}inscricoes/consultarInscricao`, envio)
            .then((response) => {
              if (response.data.length > 0) {
                this.idInscricao = response.data;
                this.dialogoToken = true;
                this.consultaCPF = true;
                this.isLoading = false;
              }
            });
        } catch (error) {
          vm.$refs.chamaSnackbar.snack(
            "#EF5350",
            "Problema ao consultar inscrição, tente novamente!",
            "DESCULPE"
          );
        }
      } else {
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Informe o CPF para consultar",
          "ATENÇÃO"
        );
      }
    },

    async confirmaToken() {
      var vm = this;

      if (this.token) {
        this.isLoading = true;
        let confirmacao = {
          token: this.token,
          inscricaoId: this.idInscricao,
        };
        await axios
          .post(`${baseApiUrl}inscricoes/confirmToken`, confirmacao)
          .then((response) => {
            if (response.data) {
              if (response.data.statusPagamento == "PAGO") {
                this.consultaCPF = true;
                this.cultoSelecionado = this.eventos[0].nome;
                this.inscricao.nome = response.data.nome;
                this.inscricao.cod_incricao = response.data.cod_incricao;
                this.inscricao.email = response.data.email;
                this.inscricao.participantes = response.data.participantes;
                this.dialogoToken = false;
                this.token = "";
                this.dialogoIngressoIndividual = true;
                this.isLoading = false;
                this.idInscricao = "";
              } else if (response.data.statusPagamento == "PENDENTE") {
                this.inscricaoLocalizada = true;
                this.consultaInscricao(this.idInscricao);
                if (response.data.participantes > 1) {
                  this.dialogoToken = false;
                  this.isLoading = false;
                  this.pageConsulta = false;
                  this.realizarInscricaoGrupo();
                  vm.$refs.chamaSnackbar.snack(
                    "#F9A825",
                    "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Confirme as informações e, em seguida, escolha uma forma de pagamento desejada.",
                    "ATENÇÃO"
                  );
                } else {
                  this.dialogoToken = false;
                  this.isLoading = false;
                  this.pageConsulta = false;
                  this.realizarInscricaoAgora();
                  vm.$refs.chamaSnackbar.snack(
                    "#F9A825",
                    "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Confirme as informações e, em seguida, escolha uma forma de pagamento desejada.",
                    "ATENÇÃO"
                  );
                }
                this.token = "";
                this.idInscricao = "";
                this.inscricao = Object.assign({}, this.inscricaoDefault);
              } else if (response.data.statusPagamento == "CANCELADO") {
                this.dialogoToken = false;
                this.isLoading = false;
                vm.$refs.chamaSnackbar.snack(
                  "#F9A825",
                  "Foi localizada uma inscrição para este CPF com situação cancelada.",
                  "ATENÇÃO"
                );
                this.token = "";
                this.idInscricao = "";
                this.inscricao = Object.assign({}, this.inscricaoDefault);
              } else if (response.data.statusPagamento == "ESTORNADO") {
                this.dialogoToken = false;
                this.isLoading = false;
                vm.$refs.chamaSnackbar.snack(
                  "#F9A825",
                  "Foi localizada uma inscrição para este CPF com situação estornada.",
                  "ATENÇÃO"
                );
                this.token = "";
                this.idInscricao = "";
                this.inscricao = Object.assign({}, this.inscricaoDefault);
              }
            } else {
              this.isLoading = false;
              vm.$refs.chamaSnackbar.snack(
                "#F9A825",
                "Token inválido, tente novamente",
                "ATENÇÃO"
              );
            }
          })
          .catch(() => {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#EF5350",
              "Problema ao confirmar token, tente novamente",
              "DESCULPE"
            );
          });
      } else {
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Informe o token enviado para continuar",
          "ATENÇÃO"
        );
      }
    },

    async consultaInscricao(id) {
      await axios.get(baseApiUrl + "inscricoes/" + id).then((response) => {
        if (response.data) {
          this.inscricao.nome = response.data.nome;
          this.inscricao.cpf = response.data.cpf;
          this.inscricao.dataNascimento = response.data.dataNascimento;
          this.inscricao.telefone = response.data.telefone;
          this.inscricao.possuiNecessidade = response.data.possuiNecessidade;
          this.inscricao.necessidadeEspecial =
            response.data.necessidadeEspecial;
        }
      });
    },

    async consultaDivulgador(id) {
      await axios.get(baseApiUrl + "Divulgadores/" + id).then((response) => {
        if (response.data) {
          if (response.data.ativo) {
            this.indicacao = true;
            this.divulgador = response.data;
            if (localStorage.getItem('view_d') == id)
              return
            else
              axios.patch(baseApiUrl + 'Divulgadores/' + id, { "qtdClicks": response.data.qtdClicks ? response.data.qtdClicks + 1 : 1 }).then((response) => {
                if (response.data) {
                  localStorage.setItem('view_d', id);
                }
              });
          }
        }
      });
    },

    async visualizacaoEvento(id) {
      if (localStorage.getItem('view_e') == id)
        return
      else
        await axios.post(baseApiUrl + 'eventos/visita', { "id": id }).then((response) => {
          if (response.data) {
            localStorage.setItem('view_e', id);
          }
        });
    },

    retornaData(tipo) {
      return moment().format(tipo);
    },

    retornaPaginaPrincipal() {
      if (
        this.eventoSelecionado.matrizColuna &&
        this.eventoSelecionado.matrizLinha
      ) {
        this.paginaInscricaoVagas = false;
        this.paginaInscricaoVagasTorcedor = false;
        this.paginaInscricaoVagasOnibus = false;
      } else {
        this.paginaInscricaoGrupo = false;
        this.paginaInscricaoGrupoTorcedor = false;
        this.paginaInscricaoGrupoOnibus = false;
      }

      this.pagePrincipal = true;

      this.eventoSelecionado = [];
      this.filhosSelect = [];
      this.inscricao = this.inscricaoDefault;
      this.exibeMapa = false;
    },

    async buscaUfs() {
      await axios
        .get(
          "https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome"
        )
        .then((response) => {
          if (response.data) {
            this.estados = response.data;
          }
        });
    },

    async buscaMunicipios() {
      await axios
        .get(
          "https://servicodados.ibge.gov.br/api/v1/localidades/municipios?view=nivelado"
        )
        .then((response) => {
          if (response.data) {
            this.municipios = response.data;
          }
        });
    },

    getItemText(item) {
      return item.nome;
    },

    calculaValorTotal(setor, indice) {
      let vm = this;

      // localiza o setor escolhido pelo preço e o salva na inscrição
      for (let i = 0; i < this.eventoSelecionado.setores.length; i++) {
        if (this.eventoSelecionado.setores[i].nome == setor) {
          if (
            this.verificaVagaDisponivel(
              this.eventoSelecionado.setores[i].nome
            ) > 0
          ) {
            this.inscricao[indice].valorPago =
              this.eventoSelecionado.setores[i].valor;
            this.inscricao[indice].corSetor =
              this.eventoSelecionado.setores[i].cor;
          } else {
            this.inscricao[indice].valorPago = "";
            this.inscricao[indice].setor = "";
            this.inscricao[indice].corSetor = "";
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Quantidade máxima atingida para o setor",
              "ATENÇÃO"
            );
          }
          break;
        }
      }

      if (
        this.inscricao[indice].tipoDocumento == "CNPJ" &&
        this.eventoSelecionado.desconto
      ) {
        this.inscricao[indice].valorPago = parseFloat(
          this.inscricao[indice].valorPago.replace(",", ".") -
          this.eventoSelecionado.desconto.replace(",", ".")
        )
          .toFixed(2)
          .replace(".", ",");
      }

      this.valorTotalCompra = 0;

      this.inscricao.forEach((inscricao) => {
        if (inscricao.valorPago) {
          this.valorTotalCompra += parseFloat(
            inscricao.valorPago.replace(",", ".")
          );
        }
      });

      if (this.empresa.limiteInscricao == "SETOR") {
        this.pegaVagasDisponiveis();
      }
    },

    async pegaVagasDisponiveis() {
      await axios
        .post(baseApiUrl + "Empresas/vagasDisponiveis", {
          empresaId: this.empresa.id,
        })
        .then((response) => {
          if (response.data) {
            this.vagasDisponiveis = response.data;
          }

          if (this.inscricao.length > 0) {
            for (let i = 0; i < this.inscricao.length; i++) {
              if (this.inscricao[i].setor) {
                this.vagasDisponiveis[this.inscricao[i].setor] =
                  this.vagasDisponiveis[this.inscricao[i].setor] - 1;
              }
            }
          }
        });
    },

    verificaVagaDisponivel(setor) {
      return this.vagasDisponiveis[setor] - 1;
    },

    limpaSetor(indice) {
      if (this.inscricao[indice].valorPago) {
        this.valorTotalCompra -= parseFloat(
          this.inscricao[indice].valorPago.replace(",", ".")
        );
      }

      this.inscricao[indice].valorPago = "";
      this.inscricao[indice].setor = "";
      this.inscricao[indice].corSetor = "";
    },

    preencherInformacoes() {
      // let answer = confirm(
      //   "Deseja preencher os dados desta inscrição com os dados da primeira inscrição?"
      // );

      // if (answer) {
      //   this.inscricao[indice].cpf = this.inscricao[0].cpf;
      //   this.inscricao[indice].nome = this.inscricao[0].nome + ' ' + (indice + 1);
      //   this.inscricao[indice].telefone = this.inscricao[0].telefone;
      // }

      if (this.inscricao.length > 0) {
        for (let i = 1; i < this.inscricao.length; i++) {
          if (this.inscricao[i].cpf == "") {
            this.inscricao[i].cpf = this.inscricao[0].cpf
          }
        }
      }
    },

    async getVagas() {
      this.isLoading = true;
      try {
        let vagasSelecionadas = [];
        const response = await axios.post(baseApiUrl + "Vagas/busca", {
          eventoId: this.eventoSelecionado.id,
        });

        for (let i = 0; i < response.data.length; i++) {
          if (
            response.data[i].status == "SELECIONADO" &&
            response.data[i].cpf &&
            response.data[i].cpf !== this.inscricao[0].cpf
          ) {
            response.data[i].bloqueado = true;
          } else if (
            response.data[i].status == "SELECIONADO" &&
            response.data[i].cpf &&
            response.data[i].cpf === this.inscricao[0].cpf
          ) {
            vagasSelecionadas.push({
              vaga: response.data[i].vaga,
              setor: response.data[i].setor,
            });
          }
        }

        if (vagasSelecionadas.length > 0) {
          this.inscricao[0].vagas = vagasSelecionadas;
          this.qtdVagas();
        }

        // Normaliza os dados de `localizacao` para números
        this.clickedCells = response.data.map((vaga) => ({
          ...vaga,
          localizacao: parseInt(vaga.localizacao),
        }));

        // console.log("Dados das vagas carregados e normalizados:", this.clickedCells);
        this.updateMatrixCells();
        this.isLoading = false;
      } catch (error) {
        // console.error("Erro ao carregar vagas:", error);
        this.isLoading = false;
      }
    },

    async cellClicked(rowIndex, colIndex) {
      const cell = this.matrix[rowIndex][colIndex];
      // console.log(cell);

      if (cell.active) {
        this.isLoading = true;

        await axios
          .post(baseApiUrl + "Vagas/vaga", { vagaId: cell.id })
          .then(async (response) => {
            if (response.data) {
              if (!this.inscricao[0].vagas) {
                this.inscricao[0].vagas = [];
              }

              if (response.data.status == "LIVRE") {
                this.matrix[rowIndex][colIndex] = await this.setaStatus({
                  vagaId: cell.id,
                  status: "SELECIONADO",
                  cpf: this.inscricao[0].cpf,
                });
                this.inscricao[0].vagas.push({
                  vaga: cell.vaga,
                  setor: cell.setor,
                });
              } else if (response.data.status == "SELECIONADO") {
                if (response.data.cpf == this.inscricao[0].cpf) {
                  this.matrix[rowIndex][colIndex] = await this.setaStatus({
                    vagaId: cell.id,
                    status: "LIVRE",
                    cpf: this.inscricao[0].cpf,
                  });
                  this.inscricao[0].vagas = this.inscricao[0].vagas.filter(
                    function (item) {
                      return item.vaga !== cell.vaga;
                    }
                  );
                }
              } else if (response.data.status == "OCUPADO") {
                this.matrix[rowIndex][colIndex] = response.data;
              }
            }
          });

        this.x++;
        this.isLoading = false;
        this.qtdVagas();
      }
    },

    adjustBackgroundSize() {
      const matrix = this.$refs.matrixTable;
      const container = this.$refs.matrixContainer;
      if (matrix && container) {
        // Ajusta o tamanho da imagem para cobrir as dimensões da tabela
        this.backgroundStyle.backgroundSize = `${matrix.offsetWidth}px ${matrix.offsetHeight}px`;

        // Certifique-se que a posição de fundo é centralizada
        this.backgroundStyle.backgroundPosition = "center center";

        // Aplica os estilos ao container diretamente para garantir que sejam aplicados
        container.style.backgroundImage =
          this.eventoSelecionado.backgroundImage;
        container.style.backgroundSize = this.backgroundStyle.backgroundSize;
        container.style.backgroundPosition =
          this.backgroundStyle.backgroundPosition;
        container.style.backgroundRepeat = "no-repeat";
        container.style.width = `${matrix.offsetWidth}px`;
        container.style.height = `${matrix.offsetHeight}px`;
      }
    },

    async setaStatus(dados) {
      let response = await axios.post(baseApiUrl + "Vagas/setaStatus", dados);

      if (response.data) {
        return response.data;
      }
    },

    formatarLista(lista) {
      if (lista) {
        let resultado = "";

        lista.forEach((aluno, index) => {
          if (!resultado.includes(aluno.nome + " (" + aluno.turma + ")")) {
            resultado += aluno.nome + " (" + aluno.turma + ")";

            if (index !== lista.length - 1) {
              resultado += " | ";
            }
          }
        });

        return resultado;
      }
    },

    qtdVagas() {
      this.vagasSelecionadas = "";

      for (let i = 0; i < this.inscricao[0].vagas.length; i++) {
        this.vagasSelecionadas += this.inscricao[0].vagas[i].vaga;

        if (i !== this.inscricao[0].vagas.length - 1) {
          this.vagasSelecionadas += ", ";
        }
      }
    },

    formatarSetor(lista) {
      if (lista) {
        let resultado = "";

        lista.forEach((item, index) => {
          if (item.quantidade != "")
            resultado += "Mesa " + item.vaga + " (Setor " + item.setor + ")";

          if (index !== lista.length - 1 && item.quantidade != "") {
            resultado += " | ";
          }
        });

        return resultado;
      }
    },

    acrescentaComposicao(composicao) {
      for (let i = 0; i < this.eventoSelecionado.composicao.length; i++) {
        if (this.eventoSelecionado.composicao[i].tipo == composicao.tipo) {
          this.eventoSelecionado.composicao[i].quantidade++;
          this.x++;
          break;
        }
      }

      this.valorTotalCompra = this.calculaComposicao(
        this.eventoSelecionado.composicao
      );
    },

    removeComposicao(composicao) {
      for (let i = 0; i < this.eventoSelecionado.composicao.length; i++) {
        if (this.eventoSelecionado.composicao[i].tipo == composicao.tipo) {
          this.eventoSelecionado.composicao[i].quantidade--;
          this.x++;
          break;
        }
      }

      this.valorTotalCompra = this.calculaComposicao(
        this.eventoSelecionado.composicao
      );
    },

    calculaComposicao(composicao) {
      let valor = 0;
      let quantidade = 0;
      this.inscricao[0].composicao = [];

      composicao.forEach((item) => {
        if (item.quantidade) {
          valor += parseFloat(item.valor.replace(",", ".")) * item.quantidade;
          quantidade += item.quantidade;

          this.inscricao[0].composicao.push({
            tipo: item.tipo,
            quantidade: item.quantidade,
          });
        }
      });

      this.qtdIngressosCompra = quantidade;

      return valor;
    },

    formatDescricao(texto) {
      return texto.replace(/\n/g, "<br>");
    },
    
    mostrarDescricaoResumida(evento) {
      if (!evento.descricao) return '';
      
      // Se a descrição estiver expandida, mostrar o texto completo
      if (this.isDescricaoExpandida(evento.id)) {
        return this.formatDescricao(evento.descricao);
      } 
      
      // Se a descrição for curta, mostrar o texto completo
      if (evento.descricao.length <= 150) {
        return this.formatDescricao(evento.descricao);
      } 
      
      // Caso contrário, mostrar apenas os primeiros 150 caracteres
      const textoResumido = evento.descricao.substring(0, 150);
      return this.formatDescricao(textoResumido + '...');
    },
    
    toggleDescricao(eventoId) {
      this.$set(this.descricaoExpandida, eventoId, !this.isDescricaoExpandida(eventoId));
    },
    
    isDescricaoExpandida(eventoId) {
      return this.descricaoExpandida[eventoId] === true;
    },

    calculaValorPix() {
      // Garante que pelo menos 1 inscrição seja contabilizada
      let quantidadeFilhos;

      if (this.eventoSelecionado.permitePais === true){
        quantidadeFilhos = Math.max(1, (this.qtdCompra - 1) + this.inscricao[0].filho.length);
      } else if (this.inscricao[0].filho && this.inscricao[0].filho.length > 0) {
        quantidadeFilhos = Math.max(1, this.inscricao[0].filho.length)
      } else {
        quantidadeFilhos = Math.max(1, this.qtdCompra);
      }

      let valor = parseFloat(this.eventoSelecionado.valorPix.replace(",", ".")) * quantidadeFilhos;
      
      // Aplica desconto do divulgador se houver
      if (this.indicacao && this.divulgador && this.divulgador.aplicaDesconto && this.eventoSelecionado.usaLinkDesconto) {
        valor -= (valor * this.divulgador.valorDesconto / 100);
      }
      
      return valor;
    },

    calculaValorParcela() {
      // Garante que pelo menos 1 inscrição seja contabilizada
      let quantidadeFilhos;

      if (this.eventoSelecionado.permitePais === true){
        quantidadeFilhos = Math.max(1, (this.qtdCompra - 1) + this.inscricao[0].filho.length);
      } else if (this.inscricao[0].filho && this.inscricao[0].filho.length > 0) {
        quantidadeFilhos = Math.max(1, this.inscricao[0].filho.length)
      } else {
        quantidadeFilhos = Math.max(1, this.qtdCompra);
      }

      let valorBase = parseFloat(this.eventoSelecionado.valorCartao.replace(",", ".")) * quantidadeFilhos;
      
      // Aplica desconto do divulgador se houver
      if (this.indicacao && this.divulgador && this.divulgador.aplicaDesconto && this.eventoSelecionado.usaLinkDesconto) {
        valorBase -= (valorBase * this.divulgador.valorDesconto / 100);
      }
      
      // Divide pelo número de parcelas
      return valorBase / this.eventoSelecionado.quantidadeParcelas;
    },
  },
};
</script>

<style scoped>
/* LOGIN */

.limiter {
  width: 100%;
  margin: 0 auto;
}

.container-login {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 0px;
  background: linear-gradient(to right, #424242, #616161);
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;
}

.texto {
  font-weight: bold;
  color: #00253e;
  font-size: 17px;
}

.login {
  min-width: 80%;
  border-radius: 15px;
  background-color: #fff;
  opacity: 0.9;
  padding-top: 0px;
  padding-bottom: 15px;
}

.login-title {
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.no-break {
  word-wrap: normal;
  word-break: keep-all;
  white-space: pre-line;
}

a {
  text-decoration: none;
}

.theme--light.v-data-table thead tr th {
  color: white;
}

table {
  border-collapse: collapse;
}

td {
  width: 12px;
  height: 12px;
  border: 0px solid black;
  line-height: 0.5rem;
}

tr {
  height: 4px;
}

.active {
  background-color: #4caf50;
  color: white;
}

form {
  text-align: center;
  margin-bottom: 20px;
}

input[type="number"],
input[type="text"] {
  padding: 8px;
  margin-right: 10px;
  margin-top: 10px;
}

#clickedCellsInfo {
  text-align: center;
  margin-top: 10px;
}

.modern-card {
  background-color: #ffffff;
  transition: all 0.3s ease;
}

.input-field {
  transition: all 0.3s ease;
}

.input-field:hover .v-input__slot {
  border-color: #00695C !important;
}

.v-text-field--outlined.v-input--is-focused > .v-input__control > .v-input__slot {
  border-color: #00695C !important;
}

.v-text-field--outlined fieldset {
  border-radius: 12px !important;
}

.v-btn {
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.v-card.outlined {
  transition: all 0.3s ease;
}

.rounded-lg {
  border-radius: 12px;
}

.payment-option-card {
  transition: all 0.3s ease;
  position: relative;
}

.card-indicator {
  transition: all 0.3s ease;
}

/* Espaçamento entre botões em mobile */
@media (max-width: 600px) {
  .v-btn + .v-btn,
  .v-col + .v-col {
    margin-top: 16px !important;
  }
  
  .payment-buttons .v-col {
    padding-top: 8px;
    padding-bottom: 8px;
  }
}

/* Centralização dos cards em mobile */
@media (max-width: 960px) {
  .payment-card-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .payment-option-card {
    width: 100%;
    max-width: 300px;
    margin-left: auto !important;
    margin-right: auto !important;
  }

  .qr-container img, 
  .qr-container enhanced-qr-code {
    border: 10px solid white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  }
}

.evento-descricao {
  position: relative;
  width: 100%;
}

.descricao-texto {
  word-break: break-word;
  line-height: 1.5;
}

.evento-descricao {
  position: relative;
  width: 100%;
}

.descricao-container {
  transition: max-height 0.3s ease;
  overflow: hidden;
}

.descricao-container.expandida {
  max-height: none !important;
}

.descricao-texto {
  word-break: break-word;
  line-height: 1.5;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.75);
}

@media (max-width: 600px) {
  .descricao-texto {
    font-size: 13px;
  }
}
</style>
